// Подключаем основной CSS
import '../css/app.css';
import Hls from 'hls.js';
import appPromoImage from '../images/igma-app-promo.jpg';

/* =================== SAFE HELPERS =================== */
/* Принимают и селектор-строку, и уже готовый элемент */
/* Если jQuery загружен, НЕ трогаем $, публикуем наши как dom$/domAll */
(function(){
  function _dom$(sel, root = document){
    if (sel == null) return null;
    if (sel === document || sel === window) return sel;
    if (typeof sel !== 'string') return sel; // ← если это элемент — вернуть как есть
    return (root?.querySelector?.(sel) ?? null);
  }
  function _domAll(sel, root = document){
    if (sel == null) return [];
    if (typeof sel !== 'string') return [sel].filter(Boolean);
    const list = root?.querySelectorAll?.(sel);
    return list ? Array.from(list) : [];
  }

  if (window.$ && window.$.fn) {
    // jQuery уже есть — не переписываем $, даём свои алиасы
    window.dom$   = _dom$;
    window.domAll = _domAll;
  } else {
    // jQuery нет — используем твои имена $ / $all
    window.$    = _dom$;
    window.$all = _domAll;
    window.dom$   = _dom$;
    window.domAll = _domAll;
  }
})();
/* ==================================================== */


//glxavor ej
//  ✅ Автоматическое смещение подменю вправо, если оно выходит за пределы экрана
document.addEventListener('DOMContentLoaded', () => {
    console.log("✅ Главная страница загружена");

    function adjustSubmenuPosition() {
        document.querySelectorAll('.menu-item.has-submenu').forEach(item => {
          const submenu = item.querySelector('.submenu');
          if (!submenu) return;
    
          submenu.style.left = '';
          submenu.style.right = '';
          item.classList.remove('left-edge', 'right-edge');
    
          const itemRect = item.getBoundingClientRect();
          const submenuWidth = submenu.offsetWidth;
          const submenuHeight = submenu.offsetHeight;
          const screenWidth = window.innerWidth;
          const screenHeight = window.innerHeight;
    
          const spaceLeft = itemRect.left;
          const spaceRight = screenWidth - itemRect.right;
    
          // ✅ Прижимаем к правому краю, если не влезает
          if (submenuWidth > spaceRight && spaceLeft > spaceRight) {
            submenu.style.left = 'auto';
            submenu.style.right = '0';
            item.classList.add('right-edge');
          }
          // ✅ Прижимаем к левому краю, если слишком близко
          else if (spaceLeft < 20) {
            submenu.style.left = '0';
            submenu.style.right = 'auto';
            item.classList.add('left-edge');
          } else {
            submenu.style.left = '0';
            submenu.style.right = 'auto';
          }
    
          // ✅ Если выходит вниз — уменьшаем максимальную высоту
          if ((itemRect.bottom + submenuHeight) > screenHeight) {
            submenu.style.maxHeight = (screenHeight - itemRect.bottom - 20) + 'px';
            submenu.style.overflowY = 'auto';
          } else {
            submenu.style.maxHeight = '';
            submenu.style.overflowY = '';
          }
        });
      }
    
      adjustSubmenuPosition();
      window.addEventListener('resize', adjustSubmenuPosition);
      window.addEventListener('scroll', adjustSubmenuPosition);
      
    //==============================================================================================================  
    // =====================
// Account dropdown (header)
// =====================


    
    
    //Переключатель языка
      (function(){
        const root = document.getElementById('langSwitch');
        if(!root) return;
      
        const btn  = root.querySelector('.lang-current');
        const menu = root.querySelector('.lang-menu');
        const form = document.getElementById('langForm');
        const input= document.getElementById('langInput');
      
        function place(){
          root.classList.remove('align-left','align-right');
      
          const r = root.getBoundingClientRect();
          const gutter = 12; // минимальный отступ от краёв
      
          if (window.innerWidth - r.right < 160) {
            root.classList.add('align-right'); // мало места справа — раскрываем влево
          } else {
            root.classList.add('align-left');  // иначе — в привычную сторону
          }
        }
      
        btn.addEventListener('click', () => {
          const open = root.classList.toggle('open');
          btn.setAttribute('aria-expanded', String(open));
          if (open) place();
        });
      
        window.addEventListener('resize', () => {
          if (root.classList.contains('open')) place();
        });
      
        root.querySelectorAll('.lang-item').forEach(el=>{
          el.addEventListener('click', ()=>{
            input.value = el.getAttribute('data-lang');
            form.submit();
          });
        });
      
        // первичная установка
        place();
      })();
      
     //------умный поиск 
     

    
     //Vertikal MENU
// ✅ JS инициализирован
// ✅ JS инициализирован

let closeTimeout;

// 👉 Открытие меню (при наведении — для ПК)
function openCategoriesMenu() {
  if (window.innerWidth > 768) {
    clearTimeout(closeTimeout);
    const panel = document.getElementById('categoriesDropdownPanel');
    panel.style.display = 'flex';

    const items = document.querySelectorAll('.categories-dropdown-item');
    const activeExists = document.querySelector('.categories-dropdown-item.active');

    // 👉 Если нет активной категории — выделяем первую и загружаем подкатегории
    if (items.length > 0 && !activeExists) {
      const first = items[0];
      first.classList.add('active');
      const firstId = first.getAttribute('data-id');
      const firstIndex = first.getAttribute('data-index');
      loadSubCategories(firstId, firstIndex);
    }
  }
}

// 👉 Закрытие меню (при уходе мыши — для ПК)
function closeCategoriesMenu() {
  if (window.innerWidth > 768) {
    closeTimeout = setTimeout(() => {
      document.getElementById('categoriesDropdownPanel').style.display = 'none';
    }, 250);
  }
}

// 👉 Переключение видимости меню (для мобильных)
function toggleMobileCategories() {
  const panel = document.getElementById('categoriesDropdownPanel');
  const closeBtn = document.getElementById('mobileCloseBtn');
  const isVisible = panel.style.display === 'flex';

  if (isVisible) {
    panel.style.display = 'none';
    closeBtn.classList.remove('active');
    clearMobileSubcategories();
  } else {
    panel.style.display = 'flex';
    closeBtn.classList.add('active');
    clearMobileSubcategories();
  }
}

// 👉 Закрытие меню (по крестику — для мобильных)
function closeMobileCategories() {
  const panel = document.getElementById('categoriesDropdownPanel');
  const closeBtn = document.getElementById('mobileCloseBtn');
  panel.style.display = 'none';
  closeBtn.classList.remove('active');
  clearMobileSubcategories();
}

// 👉 Очистка активных и подкатегорий (мобилка)
function clearMobileSubcategories() {
  document.querySelectorAll('.categories-dropdown-item').forEach(item => {
    item.classList.remove('active');
  });
  const container = document.getElementById('subCategoryContainer');
  container.innerHTML = '';
  document.querySelectorAll('.mobile-subcategory-block').forEach(el => el.remove());
}

// 👉 Загрузка подкатегорий (по ID категории)
function loadSubCategories(mainId, index) {
  const current = document.querySelector(`.categories-dropdown-item[data-id='${mainId}']`);

  if (current && current.classList.contains('active')) {
    if (window.innerWidth <= 768) {
      current.classList.remove('active');
      document.querySelectorAll('.mobile-subcategory-block').forEach(el => el.remove());
    }
    return;
  }

  document.querySelectorAll('.categories-dropdown-item').forEach(item => {
    item.classList.remove('active');
  });

  if (current) current.classList.add('active');

  fetch(`/categories/${mainId}/children`)
    .then(res => res.json())
    .then(data => {
      const container = document.getElementById('subCategoryContainer');

      // 👉 ПК — правая часть
      if (window.innerWidth > 768) {
        container.innerHTML = '';
        data.forEach(sub => {
          const block = document.createElement('div');
          block.classList.add('subcategory-dropdown-block');

          const title = document.createElement('strong');
          title.innerText = sub.name;
          block.appendChild(title);

          const ul = document.createElement('ul');
          sub.children.forEach(child => {
            const li = document.createElement('li');
            li.innerHTML = `<a href="/listings/${child.slug ?? child.id}">${child.name}</a>`;
            ul.appendChild(li);
          });

          block.appendChild(ul);
          container.appendChild(block);
        });
      }

      // 👉 Мобильная версия — раскрытие подкатегорий ниже
      if (window.innerWidth <= 768 && current) {
        document.querySelectorAll('.mobile-subcategory-block').forEach(el => el.remove());

        const subBlock = document.createElement('div');
        subBlock.classList.add('mobile-subcategory-block');

        data.forEach(sub => {
          const block = document.createElement('div');
          block.classList.add('subcategory-dropdown-block');

          const title = document.createElement('strong');
          title.innerText = sub.name;
          block.appendChild(title);

          const ul = document.createElement('ul');
          sub.children.forEach(child => {
            const li = document.createElement('li');
            li.innerHTML = `<a href="/listings/${child.slug ?? child.id}">${child.name}</a>`;
            ul.appendChild(li);
          });

          block.appendChild(ul);
          subBlock.appendChild(block);
        });

        current.insertAdjacentElement('afterend', subBlock);
      }
    })
    .catch(error => console.error('Ошибка загрузки подкатегорий:', error));
}

/* Аккаунт-меню: открытие по аватарке, закрытие по повторному тапу,
   по клику вне, по Esc и при скролле на мобиле. */
(function () {
  var root = document.querySelector('.account-menu');
  if (!root) return;

  var toggle = root.querySelector('.account-toggle'); // зона с аватаркой/именем
  var drop = root.querySelector('.account-dropdown');

  function open() {
    root.classList.add('active');
    drop.style.display = 'flex'; // Explicitly set display for mobile
    drop.style.opacity = '1';
    drop.style.transform = 'translateY(0)';
  }

  function close() {
    root.classList.remove('active');
    drop.style.display = 'none';
    drop.style.opacity = '0';
    drop.style.transform = 'translateY(10px)';
  }

  // ПЕРЕОПРЕДЕЛЯЕМ глобальную функцию, на которую завязан inline onclick
  window.toggleAccountMenu = function (e) {
    // Игнорируем клики внутри меню — реагируем ТОЛЬКО на зона .account-toggle
    if (!toggle.contains(e.target)) return;

    e.stopPropagation(); // чтобы клик по аватарке не «пробил» до document
    const isOpen = root.classList.contains('active');

    if (window.innerWidth <= 768) {
      // Mobile: toggle on each tap
      if (isOpen) {
        close();
      } else {
        open();
        // Add listener to close on outside click
        document.addEventListener('click', closeOnOutsideClick);
      }
    } else {
      // Desktop: handled by CSS hover
      open();
    }
  };

  // Закрыть по клику вне
  function closeOnOutsideClick(e) {
    if (!root.contains(e.target)) {
      close();
      document.removeEventListener('click', closeOnOutsideClick);
    }
  }

  // Закрыть по Esc
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('active')) {
      close();
      document.removeEventListener('click', closeOnOutsideClick);
    }
  });

  // На мобиле закрываем при скролле (чтобы не залипало)
  function onScrollClose() {
    if (window.matchMedia('(max-width: 768px)').matches && root.classList.contains('active')) {
      close();
      window.removeEventListener('scroll', onScrollClose);
    }
  }
  window.addEventListener('scroll', onScrollClose, { passive: true });

  // Переход по пункту меню должен сразу закрывать мобильный dropdown.
  drop.addEventListener('click', function (e) {
    if (e.target.closest('a, button')) {
      close();
      document.removeEventListener('click', closeOnOutsideClick);
    }
  });
})();

//===============================================================
      
      // ❤️ Сохранённые объявления
 // ❤️ Сохранённые объявления
const csrf = document.querySelector('meta[name="csrf-token"]')?.content;

if (csrf) {
    fetch('/saved/list', {
        method: 'GET',
        headers: {
            'X-CSRF-TOKEN': csrf,
            'Accept': 'application/json'
        }
    })
    .then(res => res.status === 401 ? [] : res.json())
    .then(savedIds => {
        if (!Array.isArray(savedIds)) return;
        document.querySelectorAll('.save-ad-btn, .main-save-btn').forEach(btn => {
            const adId = Number(btn.dataset.ad);
            if (savedIds.includes(adId)) {
                btn.classList.add('active');
            }
        });
    })
    .catch(err => console.error('Ошибка при получении сохранённых:', err));
}

// ✅ Обработка кликов по ❤️
document.querySelectorAll('.save-ad-btn, .main-save-btn').forEach(btn => {
    btn.addEventListener('click', (e) => {
        e.preventDefault(); // ⛔️ важно: не даём кнопке перезагрузить страницу!

        const adId = btn.dataset.ad;

        // 🟡 Если пользователь не авторизован — открываем модалку
        if (btn.classList.contains('guest-only')) {
            document.getElementById('auth-required-modal')?.classList.remove('hidden');
            return;
        }

        // 🔁 Отправляем запрос на добавление/удаление из избранного
        fetch(`/ads/${adId}/save`, {
            method: 'POST',
            headers: {
                'X-CSRF-TOKEN': csrf,
                'Accept': 'application/json'
            }
        })
        .then(res => res.json())
        .then(data => {
            const isSaved = data.saved;
            btn.classList.toggle('active', isSaved);

            // 🧹 Удаляем карточку, если на странице "Мои избранные"
            const card = btn.closest('.saved-ad-card');
            if (!isSaved && card) {
                card.remove();
                const container = document.querySelector('#account-saved .saved-ads-list');
                if (container && container.children.length === 0) {
                    document.getElementById('account-saved').innerHTML = `
                        <p class="no-saved-message">У вас нет сохранённых объявлений.</p>
                    `;
                }
            }

            // 🟢 Обновляем счётчик сохранений (если есть)
            const saveCountElem = document.querySelector(`#ad-${data.ad_id} .save-count`);
            if (saveCountElem) {
                let current = parseInt(saveCountElem.textContent) || 0;
                current = isSaved ? current + 1 : Math.max(0, current - 1);
                saveCountElem.textContent = current;
            }
        })
        .catch(err => console.error('Ошибка при сохранении/удалении:', err));
    });
});

// ✅ Закрытие модального окна "войти"
const closeAuthModal = () => {
    const modal = document.getElementById('auth-required-modal');
    if (modal) modal.classList.add('hidden'); // 🟣 Скрываем модалку
};

// ✅ Обработчики на кнопку закрытия модалки
document.querySelectorAll('.save-modal-close').forEach(closeBtn => {
    closeBtn.removeEventListener('click', closeAuthModal); // 🔁 Удалим старый обработчик
    closeBtn.addEventListener('click', closeAuthModal);    // ✅ Назначим новый
});


    //-----------------------------------------------------------------------------------------------------------------------

    // ✅ Предпросмотр аватара (моментальный, без сохранения)

    // Получаем элементы
    const avatarInput = document.getElementById('avatarInput');
    const avatarPreview = document.getElementById('avatar-image');
    const headerAvatar = document.getElementById('header-avatar'); // если есть в шапке

    // Создаём функцию предварительного просмотра
    const previewAvatar = function () {
        const file = this.files?.[0];
        if (!file) return;
        const url = URL.createObjectURL(file);
        if (avatarPreview) avatarPreview.src = url;
        if (headerAvatar) headerAvatar.src = url;
    };

    // Добавляем обработчик один раз (если элементы существуют)
    if (avatarInput && avatarPreview) {
        avatarInput.removeEventListener('change', previewAvatar); // удалим если вдруг есть
        avatarInput.addEventListener('change', previewAvatar);
    }

    // Модальное окно подтверждения удаления аккаунта (только UI).
    const deleteAccountTrigger = document.querySelector('[data-action="delete-account"]');
    const deleteAccountModal = document.getElementById('deleteAccountModal');
    const deleteAccountCloseButton = deleteAccountModal?.querySelector('[data-delete-account-close]');
    let deleteAccountPreviousFocus = null;

    const closeDeleteAccountModal = () => {
        if (!deleteAccountModal || deleteAccountModal.hidden) return;

        deleteAccountModal.classList.remove('is-open');
        deleteAccountModal.hidden = true;
        document.body.classList.remove('no-scroll');
        deleteAccountTrigger?.setAttribute('aria-expanded', 'false');
        deleteAccountPreviousFocus?.focus?.();
    };

    const openDeleteAccountModal = () => {
        if (!deleteAccountModal) return;

        deleteAccountPreviousFocus = document.activeElement;
        deleteAccountModal.hidden = false;
        deleteAccountTrigger?.setAttribute('aria-expanded', 'true');
        document.body.classList.add('no-scroll');

        requestAnimationFrame(() => {
            deleteAccountModal.classList.add('is-open');
            deleteAccountCloseButton?.focus();
        });
    };

    deleteAccountTrigger?.addEventListener('click', openDeleteAccountModal);
    deleteAccountCloseButton?.addEventListener('click', closeDeleteAccountModal);

    deleteAccountModal?.addEventListener('click', (event) => {
        if (event.target === deleteAccountModal) {
            closeDeleteAccountModal();
        }
    });

    document.addEventListener('keydown', (event) => {
        if (!deleteAccountModal || deleteAccountModal.hidden) return;

        if (event.key === 'Escape') {
            event.preventDefault();
            closeDeleteAccountModal();
            return;
        }

        if (event.key !== 'Tab') return;

        const focusable = Array.from(deleteAccountModal.querySelectorAll('button:not([disabled])'));
        if (focusable.length === 0) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    });

    //----------------------------------------------------------------------
    // 📸 Галерея (ads_view)

   // ========== 📸 Основной слайдер (на странице) ==========
 //----------------------------------------------------------------------
// 📸 Галерея (ads_view)

// ========== 📸 Основной слайдер ==========
const slides = document.querySelectorAll('.slide');
const prevBtn = document.querySelector('.slider-nav.prev');
const nextBtn = document.querySelector('.slider-nav.next');

let currentSlide = 0;

function showSlide(index) {
  if (!slides.length) return;

  currentSlide = (index + slides.length) % slides.length;
  slides.forEach(slide => slide.classList.remove('active'));
  slides[currentSlide].classList.add('active');
}

if (slides.length) {
  showSlide(currentSlide);

  prevBtn?.addEventListener('click', (e) => {
    e.stopPropagation();
    showSlide(currentSlide - 1);
  });

  nextBtn?.addEventListener('click', (e) => {
    e.stopPropagation();
    showSlide(currentSlide + 1);
  });
}

// ========== 🖼️ Модалка ==========
let modalPhotos = [];
const photoDataEl = document.getElementById('photoModalData');

if (photoDataEl) {
  try {
    modalPhotos = JSON.parse(photoDataEl.dataset.photos || '[]');
  } catch (e) {
    console.error('Ошибка при разборе modalPhotos', e);
    modalPhotos = [];
  }
}

let modalIndex = 0;

function normalizePhotoUrl(path) {
  if (!path) return '';

  const value = String(path).trim();

  // Уже полный URL
  if (/^https?:\/\//i.test(value)) return value;

  // Уже абсолютный путь
  if (value.startsWith('/storage/')) return value;
  if (value.startsWith('/i/')) return value;
  if (value.startsWith('/')) return value;

  // Если пришло storage/...
  if (value.startsWith('storage/')) return `/${value}`;

  // Если пришло просто photos/...
  return `/storage/${value.replace(/^\/+/, '')}`;
}

function openPhotoModal(index = currentSlide) {
  const modal = document.getElementById('photoModal');
  if (!modal || !modalPhotos.length) return;

  modalIndex = index;
  updateModalImage();
  modal.style.display = 'flex';
  document.body.style.overflow = 'hidden';
}

function closePhotoModal() {
  const modal = document.getElementById('photoModal');
  if (!modal) return;

  modal.style.display = 'none';
  document.body.style.overflow = '';
}

function updateModalImage() {
  const modalImage = document.getElementById('modalImage');
  const dots = document.querySelectorAll('.dot');

  if (!modalImage || !modalPhotos.length) return;

  const rawPath = modalPhotos[modalIndex];
  const normalizedSrc = normalizePhotoUrl(rawPath);

  if (!normalizedSrc) {
    console.error('Пустой путь к фото в модалке:', rawPath);
    return;
  }

  modalImage.src = normalizedSrc;
  modalImage.onerror = function () {
    console.error('Не удалось загрузить фото модалки:', normalizedSrc);
  };

  dots.forEach(dot => dot.classList.remove('active'));
  if (dots[modalIndex]) dots[modalIndex].classList.add('active');
}

function prevModalPhoto() {
  if (!modalPhotos.length) return;
  modalIndex = (modalIndex - 1 + modalPhotos.length) % modalPhotos.length;
  updateModalImage();
}

function nextModalPhoto() {
  if (!modalPhotos.length) return;
  modalIndex = (modalIndex + 1) % modalPhotos.length;
  updateModalImage();
}

function goToModalPhoto(index) {
  if (!modalPhotos.length) return;
  modalIndex = index;
  updateModalImage();
}

// ✅ Свайп для мобильных
function addSwipeSupport(element, onSwipeLeft, onSwipeRight) {
  if (!element) return;

  let startX = 0;

  element.addEventListener('touchstart', (e) => {
    startX = e.touches[0].clientX;
  }, { passive: true });

  element.addEventListener('touchend', (e) => {
    const endX = e.changedTouches[0].clientX;
    const diff = endX - startX;

    if (Math.abs(diff) > 50) {
      if (diff > 0) {
        onSwipeRight();
      } else {
        onSwipeLeft();
      }
    }
  }, { passive: true });
}

const slider = document.querySelector('.slider');
if (slider) {
  addSwipeSupport(
    slider,
    () => showSlide(currentSlide + 1),
    () => showSlide(currentSlide - 1)
  );
}

const modal = document.getElementById('photoModal');
if (modal) {
  addSwipeSupport(modal, nextModalPhoto, prevModalPhoto);

  modal.addEventListener('click', (e) => {
    if (e.target === modal) closePhotoModal();
  });
}

document.addEventListener('keydown', (e) => {
  const modalEl = document.getElementById('photoModal');
  if (!modalEl || modalEl.style.display !== 'flex') return;

  if (e.key === 'Escape') closePhotoModal();
  if (e.key === 'ArrowLeft') prevModalPhoto();
  if (e.key === 'ArrowRight') nextModalPhoto();
});

// ✅ Глобальные функции (чтобы работали в HTML)
window.openPhotoModal = openPhotoModal;
window.closePhotoModal = closePhotoModal;
window.prevModalPhoto = prevModalPhoto;
window.nextModalPhoto = nextModalPhoto;
window.goToModalPhoto = goToModalPhoto;


    //------------------------------------------------------------------------------------------------------------------------------

    // 🔒 Форма входа
    const loginForm = document.getElementById("login-form");

    if (loginForm) {
        loginForm.addEventListener("submit", async function (e) {
            e.preventDefault();

            const submitBtn = this.querySelector('button[type="submit"]');
            if (!submitBtn) return;

            // ⏳ Показываем индикатор загрузки
            submitBtn.disabled = true;
            submitBtn.innerHTML = '<span class="spinner"></span> Загрузка...';

            try {
                // 📦 Собираем данные из формы
                const formData = new FormData(this);
                const data = {
                    email: formData.get("email"),
                    password: formData.get("password"),
                    _token: document.querySelector('meta[name="csrf-token"]')?.content || ''
                };

                // 📨 Отправляем POST-запрос
                const response = await fetch(this.action, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-CSRF-TOKEN": data._token
                    },
                    body: JSON.stringify(data)
                });

                // 🔁 Если редирект — перенаправляем
                if (response.redirected) {
                    window.location.href = response.url;
                    return;
                }

                const result = await response.json();

                // ❌ Показываем ошибку, если есть
                if (result.error) showError(result.error);

            } catch (error) {
                // ⚠️ Ошибка сети
                showError("Ошибка сети!");
            } finally {
                // 🔄 Восстанавливаем кнопку
                submitBtn.disabled = false;
                submitBtn.innerHTML = 'Войти';
            }
        });

        // 🛠 Показывает ошибку
        function showError(message) {
            const errorEl = document.getElementById('login-error');
            if (errorEl) {
                errorEl.textContent = message;
                errorEl.style.display = 'block';

                // ⏲️ Автоматически скрыть через 5 сек
                setTimeout(() => {
                    errorEl.style.display = 'none';
                    errorEl.textContent = '';
                }, 5000);
            }
        }
    }
//---------------------------------------------------------------------my account
//shtochik save,mesenger
// 🔁 Автоматическое открытие нужной вкладки по URL-хэшу
// 🔁 Автоматически активировать вкладку по хэшу в URL
function activateTabFromHash() {
  const hash = window.location.hash;

  if (!hash) return;

  const tabButtons = document.querySelectorAll('.account-nav-item');
  const contentSections = document.querySelectorAll('.account-content-section');

  tabButtons.forEach(b => b.classList.remove('active'));
  contentSections.forEach(c => c.classList.remove('active'));

  const hashWithoutSharp = hash.replace('#', '');
  const targetTab = document.querySelector(`.account-nav-item[data-target="${hashWithoutSharp}"]`);
  const targetSection = document.getElementById(hashWithoutSharp);

  if (targetTab && targetSection) {
      targetTab.classList.add('active');
      targetSection.classList.add('active');
      requestAnimationFrame(() => {
        const navScroller = targetTab.closest('.account-nav-tabs');
        if (!navScroller) return;
        const desiredLeft = targetTab.offsetLeft
          - ((navScroller.clientWidth - targetTab.offsetWidth) / 2);
        navScroller.scrollTo({ left: Math.max(0, desiredLeft), behavior: 'smooth' });
        if (window.matchMedia('(max-width: 768px)').matches) {
          window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
          document.documentElement.scrollTop = 0;
          document.body.scrollTop = 0;
        }
      });
  }
}

// ✅ Обрабатываем первый раз при загрузке
activateTabFromHash();

// 🔁 Обрабатываем при изменении хэша (если нажали назад/вперёд)
window.addEventListener('hashchange', activateTabFromHash);

// 🔘 Переключение вкладок при клике
const tabButtons = document.querySelectorAll('.account-nav-item');
const contentSections = document.querySelectorAll('.account-content-section');

tabButtons.forEach(button => {
  button.addEventListener('click', () => {
      const targetId = button.dataset.target;

      // Убираем активные классы
      tabButtons.forEach(b => b.classList.remove('active'));
      contentSections.forEach(c => c.classList.remove('active'));

      // Активируем нужную
      button.classList.add('active');
      const targetSection = document.getElementById(targetId);
      if (targetSection) {
          targetSection.classList.add('active');

          // Обновляем hash в URL
          history.pushState(null, null, `#${targetId}`);
      }
  });
});
  // ===============================
// Модальное окно «Продвинуть»
// ===============================

// ✅ Элементы модалки
const promoModal = document.getElementById('accountPromotionModal');
const modalOverlay = document.getElementById('accountModalOverlay');

// ✅ Тосты
const promoToast = document.getElementById('promoSuccessToast');
const promoMessage = document.getElementById('promoSuccessMessage');

const promoErrorToast = document.getElementById('promoErrorToast');
const promoErrorMessage = document.getElementById('promoErrorMessage');
const promoErrorButtons = document.getElementById('promoErrorButtons');

// ✅ Текущая локаль страницы (берём из <html lang="...">)
const LOCALE = (document.documentElement.lang || 'hy').split('-')[0].toLowerCase();

// ✅ Набор переводов
const I18N = {
  successPromoted: {
    hy: '✅ Հայտարարությունը հաջողությամբ առաջխաղացվեց։',
    ru: '✅ Объявление успешно продвинуто!',
    en: '✅ The ad has been promoted successfully!'
  },
  failGetAdId: {
    hy: '❌ Չհաջողվեց ստանալ հայտարարության ID։',
    ru: '❌ Не удалось получить ID объявления',
    en: '❌ Failed to get the ad ID'
  },
  genericError: {
    hy: '❌ Սխալ առաջխաղացման ժամանակ։',
    ru: '❌ Ошибка при продвижении',
    en: '❌ Error while promoting'
  },
  requestError: {
    hy: '❌ Հարցման սխալ։',
    ru: '❌ Ошибка при запросе',
    en: '❌ Request error'
  },
  insufficientFunds: {
    hy: '❌ Փողերը բավարար չեն։ Խնդրում ենք վերալիցքավորել ձեր դրամապանակը։',
    ru: '❌ Недостаточно средств. Пополните, пожалуйста, кошелёк.',
    en: '❌ Insufficient funds. Please top up your wallet.'
  }
};

// ✅ Утилита перевода
function t(key) {
  return (I18N[key] && I18N[key][LOCALE]) || (I18N[key] && I18N[key].en) || key;
}

// ✅ Распознаём "недостаточно средств" в любом ответе
function isInsufficientFunds(payloadMessage = '') {
  const msg = (payloadMessage || '').toLowerCase();
  return (
    // код от бекенда (если есть)
    payloadMessage === 'INSUFFICIENT_FUNDS' ||
    // рус/англ/арм слова
    msg.includes('недостаточно средств') ||
    msg.includes('insufficient funds') ||
    msg.includes('փողերը բավարար չեն') ||
    msg.includes('բավարար չի') ||
    msg.includes('բավարար չեն')
  );
}

// ===============================
// Открытие/закрытие модалки
// ===============================
window.closePromotionModal = function () {
  if (promoModal) {
    promoModal.style.display = 'none';
    promoModal.classList.add('hidden');
  }
  if (modalOverlay) modalOverlay.style.display = 'none';
  document.body.classList.remove('no-scroll');
};
modalOverlay?.addEventListener('click', closePromotionModal);

function hideTransientElement(element, { addHiddenClass = false } = {}) {
  if (!element) return;

  element.style.display = 'none';
  element.style.opacity = '';

  if (addHiddenClass) {
    element.classList.add('hidden');
  }
}

function resetTransientUiState() {
  [
    modalOverlay,
    document.getElementById('messageModalOverlay'),
    document.getElementById('callModalOverlay'),
    document.getElementById('deleteModalOverlay'),
    document.getElementById('businessModalOverlay'),
    document.getElementById('businessPromoOverlay'),
    document.getElementById('dialogDelOverlay'),
  ].forEach((element) => hideTransientElement(element));

  [
    promoModal,
    document.getElementById('messageModal'),
    document.getElementById('callModal'),
    document.getElementById('deleteConfirmModal'),
    document.getElementById('businessModal'),
    document.getElementById('businessPromoModal'),
    document.getElementById('dialogDelModal'),
  ].forEach((element) => hideTransientElement(element, { addHiddenClass: true }));

  document.body.classList.remove('no-scroll');
}

if (document.readyState === 'loading') {
  window.addEventListener('DOMContentLoaded', resetTransientUiState, { once: true });
} else {
  resetTransientUiState();
}

window.addEventListener('pageshow', resetTransientUiState);

window.showPromotionModal = function (adId) {
  if (!promoModal) return;
  promoModal.setAttribute('data-ad-id', adId);
  promoModal.classList.remove('hidden');
  promoModal.style.display = 'block';
  if (modalOverlay) modalOverlay.style.display = 'block';
  document.body.classList.add('no-scroll');
};

// ===============================
// Анимации
// ===============================
function fadeOut(el) {
  if (!el) return;
  el.style.opacity = 1;
  el.style.transition = 'opacity 0.5s ease';
  requestAnimationFrame(() => (el.style.opacity = 0));
  setTimeout(() => (el.style.display = 'none'), 500);
}

function fadeIn(el, displayType = 'flex') {
  if (!el) return;
  el.style.opacity = 0;
  el.style.display = displayType;
  el.style.transition = 'opacity 0.5s ease';
  requestAnimationFrame(() => (el.style.opacity = 1));
}

// ===============================
// Тосты
// ===============================
window.showSuccess = function (message = t('successPromoted')) {
  if (!promoToast || !promoMessage) return;
  promoMessage.textContent = message;
  fadeIn(promoToast);
  setTimeout(() => {
    fadeOut(promoToast);
    location.reload();
  }, 2500);
};

window.showError = function (message = t('genericError')) {
  if (!promoErrorToast || !promoErrorMessage) return;
  promoErrorMessage.textContent = message;

  // Показать кнопки, если это "Недостаточно средств" (на любом языке/коде)
  if (isInsufficientFunds(message)) {
    if (promoErrorButtons) promoErrorButtons.style.display = 'flex';
  } else {
    if (promoErrorButtons) promoErrorButtons.style.display = 'none';
  }

  fadeIn(promoErrorToast);
};

window.hideErrorToast = function () {
  fadeOut(promoErrorToast);
  if (promoErrorButtons) promoErrorButtons.style.display = 'none';
};

// ===============================
// Обработка кликов по вариантам продвижения
// ===============================
document.querySelectorAll('.account-promotion-option').forEach(option => {
  option.addEventListener('click', async () => {
    const adId = promoModal?.getAttribute('data-ad-id');
    const type = option.dataset.type;

    if (!adId || !type) return showError(t('failGetAdId'));

    try {
      const res = await fetch(`/ads/${adId}/promote/${encodeURIComponent(type)}`, {
        method: 'POST',
        headers: {
          'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.content || '',
          'Accept': 'application/json'
        }
      });

      // Попробуем распарсить JSON или текст
      let data;
      try {
        data = await res.json();
      } catch (_) {
        const txt = await res.text();
        data = { success: false, message: txt };
      }

      // Закрываем модалку
      closePromotionModal();

      // Нормализуем сообщение
      const backendMsg = (data && (data.message || data.error || data.code)) || '';

      // Спец-обработка неуспехов HTTP
      if (!res.ok) {
        // 419 — обычно CSRF
        if (res.status === 419) return showError(t('requestError') + ' (CSRF 419)');
        // 404 — нет маршрута
        if (res.status === 404) return showError(t('requestError') + ' (404)');
        // остальное
        if (isInsufficientFunds(backendMsg)) return showError(t('insufficientFunds'));
        return showError(backendMsg || t('genericError'));
      }

      // Успешный JSON-ответ
      if (data.success) {
        return showSuccess(t('successPromoted'));
      }

      // Неуспех по бизнес-логике
      if (isInsufficientFunds(backendMsg)) {
        return showError(t('insufficientFunds'));
      }

      return showError(backendMsg || t('genericError'));

    } catch (err) {
      console.error('❌ Promotion fetch error:', err);
      showError(t('requestError'));
    }
  });
});


   //---------------------------------------------


  // ---------------- КОШЕЛЁК / ВКЛАДКИ ---------------- //
// ---------------- КОШЕЛЁК / ВКЛАДКИ + ОПЛАТЫ ----------------
(() => {
  const scope  = document.getElementById('account-wallet') || document;

  /* ===== Вкладки ===== */
  const tabs   = scope.querySelectorAll('.wallet-tab');
  const panels = scope.querySelectorAll('.wallet-tab-content, .wallet-balance-tab, .wallet-payments-tab, .wallet-history-tab');
  const storageTabKey = `wallet_active_tab:${location.pathname}`;
  const defaultTab = 'wallet-balance';

  function activateTab(name){
    tabs.forEach(t => { t.classList.remove('active'); t.setAttribute('aria-selected','false'); });
    const btn = scope.querySelector(`.wallet-tab[data-tab="${name}"]`);
    if (btn){ btn.classList.add('active'); btn.setAttribute('aria-selected','true'); try{ btn.scrollIntoView({behavior:'smooth',inline:'center',block:'nearest'});}catch(_){}}  
    panels.forEach(p => { p.classList.remove('active'); p.setAttribute('hidden',''); });
    const panel = scope.querySelector(`#${name}`) || scope.querySelector(`.${name}-tab`);
    if (panel){ panel.classList.add('active'); panel.removeAttribute('hidden'); }
    try { localStorage.setItem(storageTabKey, name); } catch(_) {}
  }

  tabs.forEach(tab => tab.addEventListener('click', () => activateTab(tab.getAttribute('data-tab'))));
  const byHash = (location.hash || '').replace('#','') === 'account-wallet';
  if (byHash) { activateTab(defaultTab); try{ localStorage.setItem(storageTabKey, defaultTab);}catch(_){}} 
  else { const saved = (()=>{ try{ return localStorage.getItem(storageTabKey) || defaultTab; }catch(_){ return defaultTab; } })(); activateTab(saved); }

  /* ===== Оплаты ===== */
  const idramForm   = scope.querySelector('#form-idram');
  const cardForm    = scope.querySelector('#form-card');
  const radios      = scope.querySelectorAll('input[name="pay_method"]');
  const pmCards     = scope.querySelectorAll('.pm-picker .pm-card');
  const pill        = scope.querySelector('.pm-pill');
  const hint        = scope.querySelector('#pm-hint');

  const amountInput = scope.querySelector('#wallet-amount-input');
  const idramAmount = scope.querySelector('#idram-amount');
  const cardAmount  = scope.querySelector('#card-amount');

  // язык
  const docLang = (document.documentElement.getAttribute('lang') || 'en').slice(0,2).toLowerCase();
  const lang = ['hy','ru','en'].includes(docLang) ? docLang : 'en';
  const IDRAM_HINT = { hy: 'Վճարում Idram-ով', ru: 'Оплата Idram', en: 'Pay via Idram' }[lang];

  const ICONS = { idram: '/img/idram.jpg', card: '/img/visa_master.svg' };
  const storageMethodKey = 'wallet_pay_method';

  function renderPill(method){
    if (!pill) return;
    const icon = ICONS[method] || ICONS.idram;
    const text = method === 'card' ? 'Visa / Mastercard' : 'Idram';
    pill.innerHTML = `<img src="${icon}" alt="" /> <span>${text}</span>`;
  }

  function renderHint(method){
    if (!hint) return;
    if (method === 'idram') {
      hint.textContent = IDRAM_HINT;
      hint.classList.remove('hidden');
    } else {
      hint.textContent = '';
      hint.classList.add('hidden');
    }
  }

  function showForm(method){
    if (method === 'card') {
      idramForm?.classList.add('hidden');
      cardForm?.classList.remove('hidden');
    } else {
      cardForm?.classList.add('hidden');
      idramForm?.classList.remove('hidden');
    }
    renderPill(method);
    renderHint(method);
    try { localStorage.setItem(storageMethodKey, method); } catch(_) {}
  }

  function selectMethod(method){
    radios.forEach(r => { r.checked = (r.value === method); });
    pmCards.forEach(c => c.classList.toggle('active', c.dataset.method === method));
    showForm(method);
  }

  // init — берём из localStorage, иначе Idram
  let currentMethod = (() => { try { return localStorage.getItem(storageMethodKey) || 'idram'; } catch(_) { return 'idram'; } })();
  // если на странице нет карточек, корректируем
  if (currentMethod === 'card' && !cardForm) currentMethod = 'idram';
  selectMethod(currentMethod);

  // handlers
  pmCards.forEach(card => card.addEventListener('click', (e) => {
    e.preventDefault();
    const method = card.dataset.method || 'idram';
    selectMethod(method);
  }));
  radios.forEach(r => r.addEventListener('change', () => { if (r.checked) selectMethod(r.value); }));

  // sync amount
  function syncAmount(){
    const v = amountInput ? String(Math.max(0, parseInt(amountInput.value || '0', 10))) : '';
    if (idramAmount) idramAmount.value = v;
    if (cardAmount)  cardAmount.value  = v;
  }
  amountInput?.addEventListener('input', syncAmount);
  syncAmount();
})();




   //---------------------

   // Разметка с иконкой поиска
   const searchBtn = document.getElementById('searchBtn');
   const regionFilter = document.getElementById('regionFilter');
   
   if (searchBtn && regionFilter) {
       searchBtn.addEventListener('click', filterAds);
       regionFilter.addEventListener('change', filterAds);
   }

   function filterAds() {
       const region = document.getElementById('regionFilter')?.value.toLowerCase() || '';
       const search = document.getElementById('searchInput')?.value.toLowerCase() || '';

       const ads = document.querySelectorAll('.account-ad-card');

       ads.forEach(ad => {
           const regionText = ad.querySelector('.ad-location')?.textContent.toLowerCase() || '';
           const title = ad.querySelector('.account-ad-header h2')?.textContent.toLowerCase() || '';

           const matchRegion = !region || regionText.includes(region);
           const matchSearch = !search || title.includes(search);

           ad.style.display = (matchRegion && matchSearch) ? 'flex' : 'none';
       });
   }

   //---------------------------------------------------------------------------------------------------------------------

   /* ✅--------------------------- Создание объявлений (create.js)--------------------------- */
   const categories = document.querySelectorAll('.main-category');
   const container = document.getElementById('subcategories-container');
   const isMobile = window.innerWidth <= 768;
   
   // 🔒 Флаг загрузки — защита от повторного клика
   let loading = false;
   
   // 🧠 Кэш подкатегорий
   const cache = {};
   
   if (categories.length) {
     categories.forEach(category => {
       category.addEventListener('click', async function () {
         const categoryId = this.dataset.id;

         // 🔒 Блок повторных кликов
         if (loading) return;
         loading = true;

         // 📱 Очистка предыдущих (мобильная)
         if (isMobile) {
           document.querySelectorAll('.subcategory-mobile-block').forEach(el => el.remove());
           if (this.classList.contains('active')) {
             this.classList.remove('active');
             loading = false;
             return;
           }
         }

         // 🔄 Активируем
         categories.forEach(el => el.classList.remove('active'));
         this.classList.add('active');

         if (!isMobile) {
           container.innerHTML = '';
         }

         // 📦 Есть в кэше — вставляем сразу
         if (cache[categoryId]) {
           insertSubcategories(this, cache[categoryId]);
           loading = false;
           return;
         }

         // ⏳ Загрузка (вставим “Загрузка…”)
     

         try {
           const res = await fetch(`/get-subcategories/${categoryId}`);
           const data = await res.json();

           if (!Array.isArray(data) || data.length === 0) {
             const emptyHtml = '<div class="subcategory-mobile-block"><p>Нет подкатегорий</p></div>';
             cache[categoryId] = emptyHtml;
             insertSubcategories(this, emptyHtml);
             loading = false;
             return;
           }

           const grouped = {};
           data.forEach(item => {
             if (!grouped[item.parent_name]) grouped[item.parent_name] = [];
             grouped[item.parent_name].push(item);
           });

           let html = `<div class="subcategories-grid subcategory-mobile-block fade-in">`;
           for (const [group, items] of Object.entries(grouped)) {
             html += `
               <div class="subcategory-block">
                 <div class="subcategory-group-title">${group}</div>
                 <div class="subcategory-links">
                   ${items.map(sub => `<a href="/create?category=${sub.id}">${sub.name}</a>`).join('')}
                 </div>
               </div>
             `;
           }
           html += `</div>`;

           // ✅ Кэшируем
           cache[categoryId] = html;

           insertSubcategories(this, html);
         } catch (err) {
           const errorHtml = '<div class="subcategory-mobile-block"><p class="text-error">Ошибка загрузки</p></div>';
           insertSubcategories(this, errorHtml);
         }

         loading = false;
       });
     });

     // По умолчанию показываем первую категорию вместе с её подкатегориями.
     if (container && categories[0]) {
       categories[0].click();
     }
   }
   
   // 🔧 Вставка HTML + анимация
   function insertSubcategories(el, html) {
     requestAnimationFrame(() => {
       if (isMobile) {
         el.insertAdjacentHTML('afterend', html);
       } else {
         container.innerHTML = html;
       }
   
       const fadeInEl = document.querySelector('.fade-in');
       if (fadeInEl) {
         fadeInEl.style.opacity = 0;
         fadeInEl.style.transform = 'translateY(10px)';
         requestAnimationFrame(() => {
           fadeInEl.style.transition = 'all 0.25s ease';
           fadeInEl.style.opacity = 1;
           fadeInEl.style.transform = 'translateY(0)';
         });
       }
     });
   }
// gin 1000  10.000 100.000...
// Форматирование всех инпутов с data-format="price"

(() => {
  try {
    const nodes = document.querySelectorAll('input[data-format="price"]');
    if (!nodes.length) return;

    const fmt = (digits) => (digits ? Number(digits).toLocaleString('en-US') : '');
    const unfmt = (val) => (val || '').toString().replace(/[^0-9]/g, '');

    nodes.forEach((inp) => {
      // первичное форматирование
      if (inp.value && /[0-9]/.test(inp.value)) {
        inp.value = fmt(unfmt(inp.value));
      }
      // при вводе
      inp.addEventListener('input', (e) => {
        const raw = unfmt(e.target.value);
        e.target.value = fmt(raw);
      }, { passive: true });
      // перед сабмитом — убрать запятые (в БД уйдёт чистое число)
      if (inp.form) {
        inp.form.addEventListener('submit', () => {
          inp.value = unfmt(inp.value);
        });
      }
    });
  } catch (e) {
    console.error('price-format error:', e);
  }
})();



  // ============================== 📸 Photo Manager (единая сетка) ==============================
(function () {
  const USE_AJAX_REORDER = false;

  // --- helpers
  const qs  = (sel, root = document) => root.querySelector(sel);
  const qsa = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const isNew = (el) => String(el?.dataset.photoId || '').startsWith('new-');

  function getCtx() {
    const block     = qs('#photo-block');
    const grid      = qs('#all-photos');
    const deleted   = qs('#deleted-photos-container');
    const fileInput = qs('#photos');
    const inpOrder  = qs('#photos_order');
    const inpMainID = qs('#main_photo_id');
    const inpMainIx = qs('#main_preview_index');
    const form      = block?.closest('form') || qs('form');
    return { block, grid, deleted, fileInput, inpOrder, inpMainID, inpMainIx, form };
  }

  // ---------- MAIN badge
  function markMain(ctx) {
    const { grid } = ctx;
    if (!grid) return;
    const all = qsa('.photo-wrapper', grid);
    const existing = all.filter(el => !isNew(el));
    const pool = existing.length ? existing : all;

    all.forEach(el => {
      el.classList.remove('main-photo');
      el.querySelector('.main-photo-label')?.remove();
    });

    if (pool.length) {
      const first = pool[0];
      first.classList.add('main-photo');
      const badge = document.createElement('span');
      badge.className = 'main-photo-label';
      badge.textContent = document.documentElement.lang?.startsWith('ru')
        ? 'Главное'
        : (document.documentElement.lang?.startsWith('hy') ? 'Գլխավոր' : 'Main');
      first.appendChild(badge);
    }
  }

  function collectExistingOrder(ctx) {
    const { grid } = ctx;
    if (!grid) return [];
    return qsa('.photo-wrapper', grid)
      .map(el => el.dataset.photoId)
      .filter(id => id && !String(id).startsWith('new-'))
      .map(id => parseInt(id, 10))
      .filter(Number.isInteger);
  }

  function updateHidden(ctx) {
    const { grid, inpOrder, inpMainID, inpMainIx } = ctx;
    if (!grid) return;
    const all = qsa('.photo-wrapper', grid);
    const existing = all.filter(el => !isNew(el));
    const firstExisting = existing[0];

    if (inpOrder)  inpOrder.value = collectExistingOrder(ctx).join(',');
    if (inpMainID) inpMainID.value = firstExisting ? parseInt(firstExisting.dataset.photoId, 10) : '';
    if (inpMainIx) {
      if (existing.length === 0) {
        const firstNew = all.find(isNew);
        inpMainIx.value = (firstNew && typeof firstNew._fileIndex === 'number') ? String(firstNew._fileIndex) : '';
      } else {
        inpMainIx.value = '';
      }
    }
  }

  function ajaxSaveOrder(ctx) {
    if (!USE_AJAX_REORDER) return;
    const ids = collectExistingOrder(ctx);
    if (ids.length === 0) return;
    const csrf = qs('meta[name="csrf-token"]')?.content;
    if (!csrf) return;

    fetch('/photos/reorder', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': csrf },
      body: JSON.stringify({ photos: ids.map((id, i) => ({ id, order: i })) })
    }).then(r => r.json()).then(d => {
      if (!d?.success) console.error('❌ Ошибка сохранения порядка фото');
    }).catch(() => {});
  }

  function initRemove(ctx, filesState, container) {
    container.addEventListener('click', (e) => {
      const btn = e.target.closest('.remove-photo');
      if (!btn) return;
      const card = btn.closest('.photo-wrapper');
      if (!card) return;

      const pid = card.dataset.photoId || '';
      if (isNew(card)) {
        const idx = card._fileIndex;
        if (typeof idx === 'number') {
          filesState.selected = filesState.selected.filter((_, i) => i !== idx);
          syncFileInput(ctx, filesState);
          renumberNewCards(ctx, filesState);
        }
      } else {
        const { deleted } = ctx;
        if (deleted && !qs(`input[name="deleted_photos[]"][value="${pid}"]`, deleted)) {
          const input = document.createElement('input');
          input.type = 'hidden'; input.name = 'deleted_photos[]'; input.value = pid;
          deleted.appendChild(input);
        }
      }

      if (typeof card._revoke === 'function') {
        card._revoke();
      }
      card.remove();
      markMain(ctx); updateHidden(ctx); ajaxSaveOrder(ctx);
    });
  }

  function ensureMoveControls(card) {
    if (!card || card.querySelector('.photo-move-controls')) return;

    const controls = document.createElement('div');
    controls.className = 'photo-move-controls';

    const prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'photo-move photo-move-prev';
    prev.dataset.move = 'prev';
    prev.setAttribute('aria-label', 'Move photo backward');
    prev.setAttribute('draggable', 'false');
    prev.textContent = '‹';

    const next = document.createElement('button');
    next.type = 'button';
    next.className = 'photo-move photo-move-next';
    next.dataset.move = 'next';
    next.setAttribute('aria-label', 'Move photo forward');
    next.setAttribute('draggable', 'false');
    next.textContent = '›';

    controls.append(prev, next);
    card.appendChild(controls);
  }

  function syncMoveControls(ctx) {
    const { grid } = ctx;
    if (!grid) return;
    qsa('.photo-wrapper', grid).forEach(ensureMoveControls);
  }

  function movePhotoCard(ctx, card, direction) {
    const { grid } = ctx;
    if (!grid || !card) return;

    const siblings = qsa('.photo-wrapper', grid).filter((item) => isNew(item) === isNew(card));
    const currentIndex = siblings.indexOf(card);
    if (currentIndex === -1) return;

    const step = direction === 'prev' ? -1 : 1;
    const targetIndex = currentIndex + step;
    if (targetIndex < 0 || targetIndex >= siblings.length) return;

    const target = siblings[targetIndex];
    if (!target) return;

    if (direction === 'prev') {
      grid.insertBefore(card, target);
    } else {
      grid.insertBefore(target, card);
    }

    markMain(ctx);
    updateHidden(ctx);
    ajaxSaveOrder(ctx);
  }

  function initTouchMoveFallback(ctx, container) {
    container.addEventListener('click', (e) => {
      const btn = e.target.closest('.photo-move');
      if (!btn) return;

      const card = btn.closest('.photo-wrapper');
      if (!card) return;

      e.preventDefault();
      movePhotoCard(ctx, card, btn.dataset.move === 'prev' ? 'prev' : 'next');
    });
  }

  function initDnD(ctx, container) {
    let dragging = null;

    container.addEventListener('dragstart', (e) => {
      const card = e.target.closest('.photo-wrapper'); if (!card) return;
      dragging = card; dragging.classList.add('dragging');
    });

    container.addEventListener('dragend', () => {
      if (!dragging) return;
      dragging.classList.remove('dragging'); dragging = null;
      markMain(ctx); updateHidden(ctx); ajaxSaveOrder(ctx);
    });

    container.addEventListener('dragover', (e) => {
      e.preventDefault(); if (!dragging) return;
      const candidates = qsa('.photo-wrapper', container)
        .filter(el => (isNew(dragging) ? isNew(el) : !isNew(el)))
        .filter(el => el !== dragging);
      if (!candidates.length) return;
      const after = getClosestByDistance(candidates, e.clientX, e.clientY);
      if (!after) {
        const tail = getTailOfGroup(container, isNew(dragging));
        container.insertBefore(dragging, tail ? tail.nextSibling : null);
      } else {
        container.insertBefore(dragging, after);
      }
    });
  }

  function getClosestByDistance(elements, x, y) {
    let best = { el: null, d2: Infinity };
    elements.forEach(el => {
      const r = el.getBoundingClientRect();
      const cx = r.left + r.width / 2, cy = r.top + r.height / 2;
      const d2 = (cx - x) ** 2 + (cy - y) ** 2;
      if (d2 < best.d2) best = { el, d2 };
    });
    return best.el;
  }

  function getTailOfGroup(container, wantNew) {
    const items = qsa('.photo-wrapper', container)
      .filter(el => wantNew ? isNew(el) : !isNew(el));
    return items.length ? items[items.length - 1] : null;
  }

  // ---------- файловое состояние
  function syncFileInput(ctx, filesState) {
    const { fileInput } = ctx;
    const dt = new DataTransfer();
    filesState.selected.forEach(f => dt.items.add(f));
    fileInput.files = dt.files;
  }

  function renumberNewCards(ctx, filesState) {
    const { grid } = ctx;
    const news = qsa('.photo-wrapper', grid).filter(isNew);
    const map = new Map(filesState.selected.map((f, i) => [f, i]));
    news.forEach(card => { if (card._file && map.has(card._file)) card._fileIndex = map.get(card._file); });
  }

  // ---------- добавление карточки превью
  function addNewCard(ctx, filesState, file) {
    const { grid } = ctx;
    const id = 'new-' + (filesState.seq++);

    const card = document.createElement('div');
    card.className = 'photo-wrapper';
    card.dataset.photoId = id;
    card.setAttribute('draggable', 'true');

    const img = document.createElement('img');
    img.src = URL.createObjectURL(file);
    img.className = 'preview-image';
    img.alt = 'Photo';

    const rm = document.createElement('button');
    rm.type = 'button';
    rm.className = 'remove-photo';
    rm.title = 'Удалить фото';
    rm.textContent = '×';

    card._file = file; // для удаления/индексов
    card.append(img, rm);
    ensureMoveControls(card);

    const tailNew = getTailOfGroup(grid, true);
    if (tailNew) grid.insertBefore(card, tailNew.nextSibling);
    else {
      const tailOld = getTailOfGroup(grid, false);
      if (tailOld) grid.insertBefore(card, tailOld.nextSibling);
      else grid.appendChild(card);
    }

    // освобождать URL позже, при удалении карточки/сабмите, чтобы превью не отвалилось
    card._revoke = () => { try { URL.revokeObjectURL(img.src); } catch (_) {} };

    markMain(ctx); updateHidden(ctx);
  }

  // ---------- выбор файлов без клиентского сжатия
  function initPicker(ctx, filesState) {
    const { fileInput } = ctx;
    if (!fileInput) return;

    fileInput.addEventListener('change', () => {
      const picked = Array.from(fileInput.files || []);
      if (!picked.length) return;

      picked.forEach((f) => {
        if (!f.type?.startsWith('image/')) return;
        if (filesState.selected.length >= 25) return;
        filesState.selected.push(f);
        addNewCard(ctx, filesState, f);
      });

      // индексация и синхронизация input
      syncFileInput(ctx, filesState);
      renumberNewCards(ctx, filesState);
    });
  }

  // ---------- инициализация
  function initPhotoManager() {
    const ctx = getCtx();
    const { block, grid, form } = ctx;
    if (!block || !grid) return;

    const filesState = { selected: [], seq: 0 };

    syncMoveControls(ctx);
    markMain(ctx);
    updateHidden(ctx);

    initDnD(ctx, grid);
    initRemove(ctx, filesState, grid);
    initTouchMoveFallback(ctx, grid);
    initPicker(ctx, filesState);

    form?.addEventListener('submit', () => {
      renumberNewCards(ctx, filesState);
      syncFileInput(ctx, filesState);
      markMain(ctx);
      updateHidden(ctx);
    });
  }

  window.initPhotoManager = initPhotoManager;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      if (document.getElementById('photo-block')) initPhotoManager();
    });
  } else {
    if (document.getElementById('photo-block')) initPhotoManager();
  }
})();


// ================= 🚀 Создание объявления + фоновая догрузка фото =================
(function () {
  const form = document.getElementById('ad-form');
  const photoInput = document.getElementById('photos');
  if (!form || !photoInput) return;

  const csrf = document.querySelector('meta[name="csrf-token"]')?.content || '';
  const submitBtn = form.querySelector('.submit-btn, button[type="submit"]');
  const statusBox = document.getElementById('ad-form-status');
  const mainPreviewInput = document.getElementById('main_preview_index');
  const uploadBatchInput = document.getElementById('photo_upload_batch');
  const uploadedManifestInput = document.getElementById('uploaded_photos_manifest');
  const draftKey = ['ad-form-draft', 'v2', window.location.pathname, form.querySelector('[name="category_id"]')?.value || '0'].join(':');
  const preparedUploadFiles = new WeakMap();
  const locale = (document.documentElement.lang || 'ru').slice(0, 2).toLowerCase();
  const dict = {
    ru: {
      creating: 'Публикуем объявление...',
      published: 'Объявление опубликовано. Загружаем фото...',
      uploading: (current, total) => `Загружаем фото ${current}/${total}...`,
      preparingPhotos: 'Подготавливаем фотографии...',
      finishingUploads: 'Завершаем загрузку фотографий...',
      uploadBeforePublish: 'Сначала дождитесь окончания загрузки фотографий.',
      validationFallback: 'Проверьте заполнение формы.',
      saveFailed: 'Не удалось сохранить объявление. Попробуйте ещё раз.',
      uploadFailed: 'Объявление опубликовано, но фото не загрузились. Переходим к редактированию, чтобы вы ничего не потеряли.',
      leaveWarn: 'Идёт загрузка фото. Если закрыть страницу, часть фото может не загрузиться.',
      authRequired: 'Сессия, похоже, истекла. Войдите снова и повторите попытку.',
      verifyRequired: 'Нужно подтвердить аккаунт, прежде чем публиковать объявления.',
      sessionExpired: 'Сессия истекла или устарел токен формы. Обновите страницу и попробуйте ещё раз.',
      serverError: (status) => `Сервер вернул ошибку${status ? ` (${status})` : ''}. Попробуйте ещё раз.`,
      unexpectedResponse: 'Сервер вернул неожиданный ответ. Обновите страницу и попробуйте ещё раз.',
    },
    en: {
      creating: 'Publishing the ad...',
      published: 'Ad published. Uploading photos...',
      uploading: (current, total) => `Uploading photo ${current}/${total}...`,
      preparingPhotos: 'Preparing photos...',
      finishingUploads: 'Finishing photo uploads...',
      uploadBeforePublish: 'Wait until the photo uploads finish first.',
      validationFallback: 'Please check the form fields.',
      saveFailed: 'Failed to save the ad. Please try again.',
      uploadFailed: 'The ad was published, but the photos failed to upload. Opening the edit page so your data stays safe.',
      leaveWarn: 'Photos are still uploading. If you leave now, some photos may not upload.',
      authRequired: 'Your session seems to have expired. Please sign in again and try once more.',
      verifyRequired: 'You need to verify your account before publishing ads.',
      sessionExpired: 'Your session expired or the form token became invalid. Refresh the page and try again.',
      serverError: (status) => `The server returned an error${status ? ` (${status})` : ''}. Please try again.`,
      unexpectedResponse: 'The server returned an unexpected response. Refresh the page and try again.',
    },
    hy: {
      creating: 'Հրապարակում ենք հայտարարությունը...',
      published: 'Հայտարարությունը հրապարակված է։ Բեռնում ենք լուսանկարները...',
      uploading: (current, total) => `Բեռնվում է լուսանկար ${current}/${total}...`,
      preparingPhotos: 'Պատրաստում ենք լուսանկարները...',
      finishingUploads: 'Ավարտում ենք լուսանկարների բեռնումը...',
      uploadBeforePublish: 'Խնդրում ենք սպասել, մինչև լուսանկարների բեռնումը ավարտվի։',
      validationFallback: 'Խնդրում ենք ստուգել ձևի դաշտերը։',
      saveFailed: 'Չհաջողվեց պահպանել հայտարարությունը։ Փորձեք կրկին։',
      uploadFailed: 'Հայտարարությունը հրապարակվել է, բայց լուսանկարները չեն բեռնվել։ Բացում ենք խմբագրումը, որպեսզի տվյալները չկորչեն։',
      leaveWarn: 'Լուսանկարները դեռ բեռնվում են։ Էջը փակելու դեպքում մի մասը կարող է չբեռնվել։',
      authRequired: 'Սեսիան, հավանաբար, ավարտվել է։ Կրկին մուտք գործեք և փորձեք նորից։',
      verifyRequired: 'Հայտարարություն հրապարակելու համար պետք է հաստատել հաշիվը։',
      sessionExpired: 'Սեսիան ավարտվել է կամ ձևի թոքենը հնացել է։ Թարմացրեք էջը և փորձեք կրկին։',
      serverError: (status) => `Սերվերը վերադարձրեց սխալ${status ? ` (${status})` : ''}։ Խնդրում ենք փորձել կրկին։`,
      unexpectedResponse: 'Սերվերը վերադարձրեց անսպասելի պատասխան։ Թարմացրեք էջը և փորձեք կրկին։',
    },
  };
  const t = dict[locale] || dict.ru;
  const originalBtnHtml = submitBtn?.innerHTML || '';
  const uploadConcurrency = 2;
  const directUploadConcurrency = 4;
  const directUploadEnabled = Boolean(uploadBatchInput && uploadedManifestInput);
  let isSubmitting = false;
  let beforeUnloadHandler = null;
  let createdPayload = null;
  const directUploadState = {
    enabled: directUploadEnabled,
    presignUrl: '/ads/photos/presign',
    batchToken: uploadBatchInput?.value || '',
    entries: [],
    queue: [],
    activeCount: 0,
  };

  function normalizeMessages(messages) {
    const source = Array.isArray(messages) ? messages : [messages];

    return [...new Set(source
      .flatMap((message) => typeof message === 'string' ? message.split(/\r?\n/) : [])
      .map((message) => message.trim())
      .filter(Boolean))];
  }

  function clearStatus() {
    if (!statusBox) return;
    statusBox.classList.remove('is-visible', 'is-error', 'is-warning');
    statusBox.innerHTML = '';
  }

  function getValidationNodes() {
    return {
      title: form.querySelector('[name="title"]'),
      description: form.querySelector('[name="description"]'),
      subregion: document.getElementById('selectedRegionText'),
      subregionInput: document.getElementById('selectedSubregionId'),
    };
  }

  function clearFieldError(field) {
    if (!field) return;
    field.classList.remove('field-invalid');
    const next = field.parentElement?.querySelector('.field-error.is-dynamic');
    if (next) next.remove();
  }

  function setFieldError(field, message) {
    if (!field) return;
    field.classList.add('field-invalid');

    let error = field.parentElement?.querySelector('.field-error.is-dynamic');
    if (!error) {
      error = document.createElement('div');
      error.className = 'field-error is-dynamic';
      field.parentElement?.appendChild(error);
    }

    error.textContent = message;
  }

  function clearValidationErrors() {
    const { title, description, subregion } = getValidationNodes();
    [title, description, subregion].forEach(clearFieldError);
  }

  function applyServerValidationErrors(errors) {
    clearValidationErrors();

    const { title, description, subregion } = getValidationNodes();
    const map = {
      title,
      description,
      subregion_id: subregion,
    };

    Object.entries(errors || {}).forEach(([key, messages]) => {
      const field = map[key];
      const message = Array.isArray(messages) ? messages[0] : messages;
      if (field && message) {
        setFieldError(field, message);
      }
    });

    const firstInvalid = [title, description, subregion].find((node) => node?.classList.contains('field-invalid'));
    firstInvalid?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function runClientValidation() {
    clearValidationErrors();

    const { title, description, subregion, subregionInput } = getValidationNodes();
    const errors = {};

    if (!title?.value?.trim()) {
      errors.title = ['Заполните заголовок'];
    }

    if (!description?.value?.trim()) {
      errors.description = ['Заполните описание'];
    }

    if (!subregionInput?.value?.trim()) {
      errors.subregion_id = ['Выберите район'];
    }

    if (Object.keys(errors).length) {
      applyServerValidationErrors(errors);
      return false;
    }

    return true;
  }

  function showStatus(type, messages) {
    if (!statusBox) return;

    const items = normalizeMessages(messages);
    if (!items.length) {
      clearStatus();
      return;
    }

    statusBox.classList.remove('is-error', 'is-warning');
    statusBox.classList.add('is-visible', type === 'warning' ? 'is-warning' : 'is-error');
    statusBox.innerHTML = '';

    const list = document.createElement('ul');
    list.className = 'ad-form-status__list';

    items.forEach((message) => {
      const item = document.createElement('li');
      item.textContent = message;
      list.appendChild(item);
    });

    statusBox.appendChild(list);
    statusBox.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function collectErrorMessages(payload) {
    const messages = [];
    const errors = payload?.errors;

    if (errors && typeof errors === 'object') {
      Object.values(errors).forEach((value) => {
        if (Array.isArray(value)) {
          value.forEach((message) => messages.push(message));
        } else if (typeof value === 'string') {
          messages.push(value);
        }
      });
    }

    if (typeof payload?.message === 'string' && payload.message.trim() && !/^validation failed$/i.test(payload.message.trim())) {
      messages.push(payload.message.trim());
    }

    if (typeof payload?.error === 'string' && payload.error.trim()) {
      messages.push(payload.error.trim());
    }

    return normalizeMessages(messages.length ? messages : [t.validationFallback]);
  }

  async function parseResponse(response) {
    const contentType = response.headers.get('content-type') || '';
    const rawText = await response.text();
    let payload = null;

    if (rawText) {
      try {
        payload = JSON.parse(rawText);
      } catch (_) {}
    }

    return {
      payload,
      rawText,
      contentType,
      finalUrl: response.url || '',
    };
  }

  function inferNonJsonError(response, parsed) {
    const finalPath = getFinalPath(parsed.finalUrl);

    if (response.status === 419) {
      return [t.sessionExpired];
    }

    if (response.redirected && /\/login\/?$/.test(finalPath)) {
      return [t.authRequired];
    }

    if (response.redirected && /\/email\/verify\/?$/.test(finalPath)) {
      return [t.verifyRequired];
    }

    if (response.status === 401) {
      return [t.authRequired];
    }

    if (response.status === 403) {
      return [t.verifyRequired];
    }

    if (!response.ok) {
      return [t.serverError(response.status)];
    }

    return [t.unexpectedResponse];
  }

  function getFinalPath(url) {
    try {
      return url ? new URL(url, window.location.origin).pathname : '';
    } catch (_) {
      return '';
    }
  }

  function isSuccessRedirect(response, parsed) {
    if (!response.redirected) return false;
    const finalPath = getFinalPath(parsed.finalUrl);
    return /^\/ads\/success\/\d+\/?$/.test(finalPath);
  }

  function payloadFromSuccessRedirect(parsed) {
    const finalPath = getFinalPath(parsed.finalUrl);
    const match = finalPath.match(/^\/ads\/success\/(\d+)\/?$/);
    if (!match) return null;

    const adId = match[1];
    return {
      ok: true,
      ad_id: Number(adId),
      success_url: parsed.finalUrl || `/ads/success/${adId}`,
      edit_url: `/ads/${adId}/edit`,
      upload_url: `/ads/${adId}/photos/deferred`,
    };
  }

  function setButtonState(disabled, text = '') {
    if (!submitBtn) return;
    submitBtn.disabled = disabled;
    submitBtn.classList.toggle('is-loading', disabled);
    submitBtn.setAttribute('aria-busy', disabled ? 'true' : 'false');
    if (text) {
      submitBtn.innerHTML = `<span class="submit-btn-spinner" aria-hidden="true"></span><span>${text}</span>`;
    } else {
      submitBtn.innerHTML = originalBtnHtml;
    }
  }

  function firstErrorMessage(payload) {
    return collectErrorMessages(payload)[0] || t.validationFallback;
  }

  function getUploadPlan(files, mainIndex) {
    if (!files.length) return [];
    const safeMainIndex = Number.isInteger(mainIndex) && mainIndex >= 0 && mainIndex < files.length ? mainIndex : 0;
    const items = files.map((file, index) => ({
      file,
      isMain: index === safeMainIndex,
    }));
    const main = items.find(item => item.isMain);
    const tail = items.filter(item => !item.isMain);
    return main ? [main, ...tail] : items;
  }

  function shouldOptimizeUploadFile(file) {
    if (!(file instanceof File)) return false;
    if (file.size <= 1.2 * 1024 * 1024) return false;
    return ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'].includes((file.type || '').toLowerCase());
  }

  function queryPhotoCards() {
    return Array.from(document.querySelectorAll('#all-photos .photo-wrapper'));
  }

  function findPhotoCardByFile(file) {
    return queryPhotoCards().find((card) => card?._file === file) || null;
  }

  function normalizeUploadHeaders(headers) {
    const normalized = {};

    Object.entries(headers || {}).forEach(([key, value]) => {
      const lower = String(key || '').toLowerCase();
      if (lower === 'host' || lower === 'content-length') {
        return;
      }

      normalized[key] = Array.isArray(value) ? value[0] : value;
    });

    return normalized;
  }

  function setPhotoCardUploadState(card, state, message = '') {
    if (!card) return;

    card.dataset.uploadState = state;
    if (message) {
      card.dataset.uploadMessage = message;
      card.title = message;
    } else {
      delete card.dataset.uploadMessage;
      card.removeAttribute('title');
    }

    card.classList.toggle('photo-uploading', state === 'uploading' || state === 'queued');
    card.classList.toggle('photo-upload-error', state === 'error');
  }

  function getDirectUploadEntry(file) {
    return directUploadState.entries.find((entry) => entry.file === file) || null;
  }

  async function requestPhotoPresign(file) {
    const response = await fetch(directUploadState.presignUrl, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': csrf,
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        name: file.name,
        type: file.type || 'image/jpeg',
        size: file.size,
        batch_token: directUploadState.batchToken,
      }),
    });

    const payload = await response.json().catch(() => ({}));
    if (!response.ok || !payload?.ok) {
      throw new Error(payload?.message || `Presign failed (${response.status})`);
    }

    return payload;
  }

  async function uploadFileDirectToCloud(file) {
    const card = findPhotoCardByFile(file);
    setPhotoCardUploadState(card, 'uploading', t.preparingPhotos);

    const preparedFile = await prepareUploadFile(file);
    const presigned = await requestPhotoPresign(preparedFile);
    const headers = normalizeUploadHeaders(presigned.headers);
    if (!headers['Content-Type'] && !headers['content-type'] && preparedFile.type) {
      headers['Content-Type'] = preparedFile.type;
    }

    const uploadResponse = await fetch(presigned.url, {
      method: 'PUT',
      headers,
      body: preparedFile,
    });

    if (!uploadResponse.ok) {
      throw new Error(`Cloud upload failed (${uploadResponse.status})`);
    }

    const result = {
      temp_id: presigned.temp_id,
      disk: presigned.disk,
      path: presigned.path,
      originalName: file.name,
      uploadedSizeBytes: preparedFile.size,
    };

    if (card) {
      card.dataset.tempId = result.temp_id;
      card.dataset.remoteDisk = result.disk;
      card.dataset.remotePath = result.path;
      card.dataset.uploadReady = '1';
      setPhotoCardUploadState(card, 'done');
    }

    return result;
  }

  function pumpDirectUploadQueue() {
    if (!directUploadState.enabled) return;

    while (directUploadState.activeCount < directUploadConcurrency && directUploadState.queue.length) {
      const entry = directUploadState.queue.shift();
      directUploadState.activeCount += 1;

      uploadFileDirectToCloud(entry.file)
        .then((result) => {
          entry.status = 'done';
          entry.result = result;
          entry.resolve(result);
        })
        .catch((error) => {
          entry.status = 'error';
          entry.error = error;
          const card = findPhotoCardByFile(entry.file);
          setPhotoCardUploadState(card, 'error', error instanceof Error ? error.message : String(error));
          entry.reject(error);
        })
        .finally(() => {
          directUploadState.activeCount -= 1;
          pumpDirectUploadQueue();
        });
    }
  }

  function enqueueDirectPhotoUpload(file) {
    if (!directUploadState.enabled || !(file instanceof File)) {
      return null;
    }

    const existing = getDirectUploadEntry(file);
    if (existing) {
      return existing.promise;
    }

    const card = findPhotoCardByFile(file);
    setPhotoCardUploadState(card, 'queued');

    const entry = {
      file,
      status: 'queued',
      result: null,
      error: null,
      promise: null,
      resolve: null,
      reject: null,
    };

    entry.promise = new Promise((resolve, reject) => {
      entry.resolve = resolve;
      entry.reject = reject;
    });

    directUploadState.entries.push(entry);
    directUploadState.queue.push(entry);
    pumpDirectUploadQueue();

    return entry.promise;
  }

  function startDirectUploadsFromInput() {
    if (!directUploadState.enabled) return;

    Array.from(photoInput.files || []).forEach((file) => {
      enqueueDirectPhotoUpload(file);
    });
  }

  async function waitForDirectUploads() {
    if (!directUploadState.enabled || !directUploadState.entries.length) {
      return;
    }

    await Promise.all(directUploadState.entries.map((entry) => entry.promise.catch(() => null)));
  }

  function buildDirectUploadManifest() {
    if (!directUploadState.enabled) {
      return [];
    }

    return queryPhotoCards()
      .filter((card) => String(card?.dataset?.photoId || '').startsWith('new-'))
      .map((card) => {
        const entry = getDirectUploadEntry(card._file);
        return entry?.status === 'done' ? entry.result : null;
      })
      .filter(Boolean)
      .map((item) => ({ temp_id: item.temp_id }));
  }

  function loadImageElement(file) {
    return new Promise((resolve, reject) => {
      const objectUrl = URL.createObjectURL(file);
      const image = new Image();

      image.onload = () => {
        URL.revokeObjectURL(objectUrl);
        resolve(image);
      };

      image.onerror = () => {
        URL.revokeObjectURL(objectUrl);
        reject(new Error('Image decode failed'));
      };

      image.src = objectUrl;
    });
  }

  function canvasToBlob(canvas, type, quality) {
    return new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (blob) {
          resolve(blob);
          return;
        }

        reject(new Error('Canvas export failed'));
      }, type, quality);
    });
  }

  async function prepareUploadFile(file) {
    if (!shouldOptimizeUploadFile(file)) {
      return file;
    }

    if (preparedUploadFiles.has(file)) {
      return preparedUploadFiles.get(file);
    }

    const pending = (async () => {
      try {
        const image = await loadImageElement(file);
        const maxSide = 1600;
        const ratio = Math.min(1, maxSide / Math.max(image.naturalWidth || image.width, image.naturalHeight || image.height));
        const width = Math.max(1, Math.round((image.naturalWidth || image.width) * ratio));
        const height = Math.max(1, Math.round((image.naturalHeight || image.height) * ratio));
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext('2d', { alpha: false });
        if (!ctx) {
          return file;
        }

        ctx.drawImage(image, 0, 0, width, height);

        const blob = await canvasToBlob(canvas, 'image/jpeg', 0.82);
        if (!blob || blob.size >= file.size) {
          return file;
        }

        const optimizedName = (file.name || 'photo').replace(/\.[^.]+$/, '') + '.jpg';
        const optimized = new File([blob], optimizedName, {
          type: 'image/jpeg',
          lastModified: Date.now(),
        });

        console.info('Prepared lighter upload file', {
          originalName: file.name,
          originalSizeBytes: file.size,
          optimizedSizeBytes: optimized.size,
        });

        return optimized;
      } catch (error) {
        console.warn('Upload optimization skipped', {
          name: file?.name || null,
          sizeBytes: file?.size || null,
          error: error instanceof Error ? error.message : String(error),
        });
        return file;
      }
    })();

    preparedUploadFiles.set(file, pending);
    return pending;
  }

  async function uploadSinglePhoto(uploadUrl, file, isMain) {
    const startedAt = performance.now();
    const preparedFile = await prepareUploadFile(file);
    const data = new FormData();
    data.append('_token', csrf);
    data.append('photo', preparedFile);
    if (isMain) {
      data.append('is_main', '1');
    }

    const response = await fetch(uploadUrl, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'X-CSRF-TOKEN': csrf,
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: data,
    });

    let payload = {};
    try {
      payload = await response.json();
    } catch (_) {}

    if (!response.ok || !payload?.ok) {
      throw new Error(payload?.message || `Upload failed (${response.status})`);
    }

    return {
      payload,
      seconds: typeof payload?.seconds === 'number'
        ? payload.seconds
        : Math.round((performance.now() - startedAt) / 10) / 100,
      uploadedSizeBytes: preparedFile?.size || file?.size || null,
    };
  }

  async function uploadPhotoBatch(uploadUrl, uploadPlan, onProgress) {
    if (!uploadPlan.length) return;

    let completed = 0;
    let nextIndex = 0;
    let aborted = false;

    const worker = async () => {
      while (!aborted) {
        const currentIndex = nextIndex;
        nextIndex += 1;

        if (currentIndex >= uploadPlan.length) {
          return;
        }

        const item = uploadPlan[currentIndex];

        try {
          const result = await uploadSinglePhoto(uploadUrl, item.file, item.isMain);
          completed += 1;

          console.info('Deferred photo uploaded', {
            index: currentIndex + 1,
            total: uploadPlan.length,
            name: item.file?.name || null,
            sizeBytes: item.file?.size || null,
            isMain: item.isMain,
            seconds: result?.seconds ?? null,
            uploadedSizeBytes: result?.uploadedSizeBytes ?? null,
          });

          if (typeof onProgress === 'function') {
            onProgress(completed, uploadPlan.length);
          }
        } catch (uploadError) {
          aborted = true;
          const prefix = `Фото ${currentIndex + 1}/${uploadPlan.length}`;
          if (uploadError instanceof Error) {
            uploadError.message = `${prefix}: ${uploadError.message}`;
          }
          throw uploadError;
        }
      }
    };

    const workers = Array.from(
      { length: Math.min(uploadConcurrency, uploadPlan.length) },
      () => worker(),
    );

    await Promise.all(workers);
  }

  function enableLeaveWarning() {
    beforeUnloadHandler = (event) => {
      event.preventDefault();
      event.returnValue = t.leaveWarn;
      return t.leaveWarn;
    };
    window.addEventListener('beforeunload', beforeUnloadHandler);
  }

  function disableLeaveWarning() {
    if (!beforeUnloadHandler) return;
    window.removeEventListener('beforeunload', beforeUnloadHandler);
    beforeUnloadHandler = null;
  }

  function clearDraft() {
    try {
      sessionStorage.removeItem(draftKey);
    } catch (_) {}
  }

  clearDraft();

  if (directUploadState.enabled) {
    photoInput.addEventListener('change', () => {
      startDirectUploadsFromInput();
    });
  }

  form.addEventListener('input', () => {
    clearStatus();
    clearValidationErrors();
  }, true);

  form.addEventListener('change', () => {
    clearStatus();
    clearValidationErrors();
  }, true);

  form.addEventListener('submit', async (event) => {
    event.preventDefault();

    if (isSubmitting) {
      return;
    }

    if (!runClientValidation()) {
      return;
    }

    if (window.__videoUploadState?.processing || window.__videoUploadState?.uploading) {
      clearStatus();
      showStatus('warning', window.__videoUploadState.errorMessage || 'Дождитесь окончания обработки видео.');
      return;
    }

    if (window.__videoUploadState?.promise) {
      await window.__videoUploadState.promise;
    }

    const files = Array.from(photoInput.files || []);
    clearStatus();
    isSubmitting = true;
    setButtonState(true, t.creating);

    if (directUploadState.enabled && directUploadState.entries.length) {
      enableLeaveWarning();
      setButtonState(true, t.finishingUploads);
      await waitForDirectUploads();

      const failedEntry = directUploadState.entries.find((entry) => {
        const card = findPhotoCardByFile(entry.file);
        return card && entry.status === 'error';
      });

      if (failedEntry) {
        disableLeaveWarning();
        showStatus('error', failedEntry.error instanceof Error ? failedEntry.error.message : t.uploadBeforePublish);
        setButtonState(false);
        isSubmitting = false;
        return;
      }

      const uploadedManifest = buildDirectUploadManifest();
      uploadedManifestInput.value = JSON.stringify(uploadedManifest);
      disableLeaveWarning();
    }

    const formData = new FormData(form);
    formData.delete('photos[]');

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'X-CSRF-TOKEN': csrf,
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      });

      const parsed = await parseResponse(response);
      let payload = parsed.payload || {};

      if (isSuccessRedirect(response, parsed)) {
        payload = payloadFromSuccessRedirect(parsed) || payload;
      }

      if (!response.ok || !payload?.ok) {
        if (payload?.errors && typeof payload.errors === 'object') {
          applyServerValidationErrors(payload.errors);
        }
        const errorMessages = parsed.payload
          ? collectErrorMessages(payload)
          : inferNonJsonError(response, parsed);
        const error = new Error(errorMessages[0] || t.saveFailed);
        error.messages = errorMessages;
        error.responseMeta = {
          status: response.status,
          redirected: response.redirected,
          url: parsed.finalUrl,
          contentType: parsed.contentType,
          preview: (parsed.rawText || '').slice(0, 400),
        };
        throw error;
      }

      createdPayload = payload;

      if (directUploadState.enabled || !payload.upload_url || !files.length) {
        window.location.href = payload.success_url || parsed.finalUrl || '/ads/success';
        return;
      }

      enableLeaveWarning();
      setButtonState(true, t.published);

      const mainIndex = parseInt(mainPreviewInput?.value || '0', 10);
      const uploadPlan = getUploadPlan(files, mainIndex);
      setButtonState(true, t.uploading(1, uploadPlan.length));

      const [mainPhoto, ...tailPhotos] = uploadPlan;
      const mainResult = await uploadSinglePhoto(payload.upload_url, mainPhoto.file, mainPhoto.isMain);
      console.info('Deferred photo uploaded', {
        index: 1,
        total: uploadPlan.length,
        name: mainPhoto.file?.name || null,
        sizeBytes: mainPhoto.file?.size || null,
        isMain: mainPhoto.isMain,
        seconds: mainResult?.seconds ?? null,
        uploadedSizeBytes: mainResult?.uploadedSizeBytes ?? null,
      });

      if (tailPhotos.length) {
        setButtonState(true, t.uploading(2, uploadPlan.length));
        await uploadPhotoBatch(payload.upload_url, tailPhotos, (completedTail, totalTail) => {
          const completedTotal = 1 + completedTail;
          const total = 1 + totalTail;
          const nextVisible = Math.min(total, completedTotal + 1);
          setButtonState(true, t.uploading(nextVisible, total));
        });
      }

      disableLeaveWarning();
      window.location.href = payload.success_url || '/ads/success';
    } catch (error) {
      disableLeaveWarning();
      const messages = normalizeMessages(error?.messages || (error instanceof Error ? [error.message] : [t.saveFailed]));
      if (error?.responseMeta) {
        console.error('Ad submit failed', error.responseMeta);
      }
      if (createdPayload?.edit_url) {
        showStatus('warning', t.uploadFailed);
        window.setTimeout(() => {
          window.location.href = createdPayload.edit_url;
        }, 1400);
        return;
      }

      if (!(error?.messages && error.responseMeta?.status === 422)) {
        showStatus('error', messages.length ? messages : [t.saveFailed]);
      }
      setButtonState(false);
      isSubmitting = false;
    }
  });
})();


// ================= 🎬 Лента видеообъявлений на главной =================
(function () {
  const modal = document.getElementById('videoFeedModal');
  const items = Array.from(document.querySelectorAll('[data-video-feed-item]'));
  if (!modal || !items.length) return;

  const player = modal.querySelector('.video-feed-player-media');
  const playerShell = modal.querySelector('.video-feed-player');
  const ownerName = modal.querySelector('[data-video-owner-name]');
  const ownerAvatar = modal.querySelector('[data-video-owner-avatar]');
  const adLink = modal.querySelector('[data-video-ad-link]');
  const adPoster = modal.querySelector('[data-video-ad-poster]');
  const adTitle = modal.querySelector('[data-video-ad-title]');
  const adPrice = modal.querySelector('[data-video-ad-price]');
  const modalSave = modal.querySelector('.video-feed-modal-save');
  const shareButton = modal.querySelector('.video-feed-share');
  const shareMenu = modal.querySelector('[data-video-share-menu]');
  const shareWhatsapp = modal.querySelector('[data-video-share-whatsapp]');
  const shareTelegram = modal.querySelector('[data-video-share-telegram]');
  const shareCopy = modal.querySelector('[data-video-share-copy]');
  const previousButton = modal.querySelector('[data-video-feed-prev]');
  const nextButton = modal.querySelector('[data-video-feed-next]');
  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content || '';
  const resumeStorageKey = 'igma.videoFeedResume';
  let currentIndex = 0;
  let touchStartY = 0;
  let touchDeltaY = 0;
  let touchActive = false;
  let isSwitching = false;
  const swipeEasing = 'cubic-bezier(.22, 1, .36, 1)';
  let resumeAt = 0;
  let activeHls = null;
  const videoPreloaders = new Map();

  function loadPlayerSource(url, autoplay = true) {
    if (activeHls) {
      activeHls.destroy();
      activeHls = null;
    }

    player.removeAttribute('src');
    player.load();

    if (!url) return;

    const isHls = /\.m3u8(?:$|[?#])/i.test(url);
    if (isHls && player.canPlayType('application/vnd.apple.mpegurl')) {
      player.src = url;
      player.load();
      if (autoplay) player.play().catch(() => {});
      return;
    }

    if (isHls && Hls.isSupported()) {
      activeHls = new Hls({
        enableWorker: true,
        startLevel: -1,
      });
      activeHls.loadSource(url);
      activeHls.attachMedia(player);
      if (autoplay) {
        activeHls.once(Hls.Events.MANIFEST_PARSED, () => {
          player.play().catch(() => {});
        });
      }
      return;
    }

    player.src = url;
    player.load();
    if (autoplay) player.play().catch(() => {});
  }

  function warmUpcomingVideo(index) {
    const upcomingIndex = (index + items.length) % items.length;
    const upcomingItem = items[upcomingIndex];
    const url = upcomingItem?.dataset.videoUrl;
    if (!url || videoPreloaders.has(url)) return;

    const preloader = document.createElement('video');
    preloader.preload = 'auto';
    preloader.muted = true;
    preloader.playsInline = true;
    preloader.src = url;
    preloader.load();
    videoPreloaders.set(url, preloader);

    // Keep only the current look-ahead cache, avoiding unnecessary traffic.
    while (videoPreloaders.size > 2) {
      const [staleUrl, staleVideo] = videoPreloaders.entries().next().value;
      staleVideo.removeAttribute('src');
      staleVideo.load();
      videoPreloaders.delete(staleUrl);
    }
  }

  function registerVideoView(item, onOpen = false) {
    const adId = item?.dataset.adId;
    if (!adId || (!onOpen && player.currentTime < 3)) return;

    // Versioned key lets us retry views that were attempted by an older bundle
    // before the server-side counter was available.
    const viewedStorageKey = `igma.videoViewed.v2.${adId}`;
    if (sessionStorage.getItem(viewedStorageKey)) return;

    fetch(`/ads/${adId}/video-view`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'X-CSRF-TOKEN': csrfToken,
        'X-Requested-With': 'XMLHttpRequest',
      },
    }).then((response) => {
      if (!response.ok) throw new Error('Video view was not recorded');
      sessionStorage.setItem(viewedStorageKey, '1');
    }).catch(() => sessionStorage.removeItem(viewedStorageKey));
  }

  function shareData() {
    const item = items[currentIndex];
    return {
      title: item?.dataset.adTitle || document.title,
      url: item?.dataset.adUrl || window.location.href,
    };
  }

  function updateShareLinks() {
    const { title, url } = shareData();
    const text = `${title}\n${url}`;
    if (shareWhatsapp) shareWhatsapp.href = `https://wa.me/?text=${encodeURIComponent(text)}`;
    if (shareTelegram) shareTelegram.href = `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`;
  }

  function render(index, autoplay = true, startAt = 0) {
    currentIndex = (index + items.length) % items.length;
    const item = items[currentIndex];
    const sourceSave = item.querySelector('.video-feed-save');
    resumeAt = Math.max(0, Number(startAt) || 0);

    player.preload = 'auto';
    player.poster = item.dataset.posterUrl || '';
    loadPlayerSource(item.dataset.videoUrl || '', autoplay);

    ownerName.textContent = item.dataset.ownerName || '';
    ownerAvatar.src = item.dataset.ownerAvatar || '';
    adLink.href = item.dataset.adUrl || '#';
    adPoster.src = item.dataset.posterUrl || '';
    adTitle.textContent = item.dataset.adTitle || '';
    adPrice.textContent = item.dataset.adPrice || '';
    modalSave.dataset.ad = item.dataset.adId || '';
    modalSave.classList.toggle('active', Boolean(sourceSave?.classList.contains('active')));
    if (shareMenu) shareMenu.hidden = true;
    updateShareLinks();
    warmUpcomingVideo(currentIndex + 1);
  }

  function open(index = 0, startAt = 0) {
    render(index, true, startAt);
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('video-feed-open');
    registerVideoView(items[currentIndex], true);
  }

  function close() {
    player.pause();
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('video-feed-open');
  }

  function resetSwipePosition(animate = true) {
    if (!playerShell) return;
    playerShell.style.transition = animate ? `transform 260ms ${swipeEasing}, opacity 180ms ease` : 'none';
    playerShell.style.transform = 'translate3d(0, 0, 0)';
    playerShell.style.opacity = '1';
  }

  function switchVideo(direction, animate = false) {
    if (isSwitching || !direction) return;

    if (!animate || !playerShell) {
      render(currentIndex + direction);
      return;
    }

    isSwitching = true;
    const exitOffset = direction > 0 ? '-100%' : '100%';
    const enterOffset = direction > 0 ? '100%' : '-100%';
    playerShell.style.transition = `transform 260ms ${swipeEasing}, opacity 180ms ease`;
    playerShell.style.transform = `translate3d(0, ${exitOffset}, 0)`;
    playerShell.style.opacity = '.9';

    window.setTimeout(() => {
      render(currentIndex + direction);
      playerShell.style.transition = 'none';
      playerShell.style.transform = `translate3d(0, ${enterOffset}, 0)`;
      playerShell.style.opacity = '.9';
      requestAnimationFrame(() => requestAnimationFrame(() => {
        playerShell.style.transition = `transform 340ms ${swipeEasing}, opacity 220ms ease`;
        playerShell.style.transform = 'translate3d(0, 0, 0)';
        playerShell.style.opacity = '1';
        window.setTimeout(() => {
          playerShell.style.transition = '';
          playerShell.style.opacity = '';
          isSwitching = false;
        }, 350);
      }));
    }, 260);
  }

  items.forEach((item, index) => {
    item.addEventListener('click', (event) => {
      if (event.target.closest('.main-save-btn')) return;
      open(index);
    });
    item.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        open(index);
      }
    });
  });

  document.querySelector('[data-video-feed-open]')?.addEventListener('click', () => open(0));
  modal.querySelectorAll('[data-video-feed-close]').forEach((button) => button.addEventListener('click', close));
  previousButton?.addEventListener('click', () => switchVideo(-1, true));
  nextButton?.addEventListener('click', () => switchVideo(1, true));

  modalSave?.addEventListener('click', () => {
    const sourceSave = items[currentIndex].querySelector('.video-feed-save');
    window.setTimeout(() => modalSave.classList.toggle('active', Boolean(sourceSave?.classList.contains('active'))), 0);
  });

  shareButton?.addEventListener('click', async () => {
    const { title, url } = shareData();
    if (navigator.share && window.matchMedia('(max-width: 768px)').matches) {
      try {
        await navigator.share({ title, url });
        return;
      } catch (_) {
        return;
      }
    }
    if (shareMenu) shareMenu.hidden = !shareMenu.hidden;
  });

  shareCopy?.addEventListener('click', async () => {
    try {
      await navigator.clipboard.writeText(shareData().url);
      shareCopy.classList.add('is-copied');
      window.setTimeout(() => shareCopy.classList.remove('is-copied'), 1200);
    } catch (_) {}
  });

  player.addEventListener('loadedmetadata', () => {
    if (resumeAt > 0 && Number.isFinite(player.duration)) {
      player.currentTime = Math.min(resumeAt, Math.max(0, player.duration - .25));
      resumeAt = 0;
    }
  });

  player.addEventListener('timeupdate', () => registerVideoView(items[currentIndex]));

  adLink.addEventListener('click', () => {
    const item = items[currentIndex];
    sessionStorage.setItem(resumeStorageKey, JSON.stringify({
      adId: item.dataset.adId,
      seconds: Math.max(0, player.currentTime || 0),
    }));
  });

  playerShell?.addEventListener('touchstart', (event) => {
    if (event.target.closest('button, a')) return;
    touchStartY = event.touches[0]?.clientY || 0;
    touchDeltaY = 0;
    touchActive = true;
  }, { passive: true });

  playerShell?.addEventListener('touchmove', (event) => {
    if (!touchActive || isSwitching) return;
    touchDeltaY = (event.touches[0]?.clientY || 0) - touchStartY;
    if (Math.abs(touchDeltaY) < 4) return;
    event.preventDefault();
    const offset = Math.max(-125, Math.min(125, touchDeltaY * .5));
    playerShell.style.transition = 'none';
    playerShell.style.transform = `translate3d(0, ${offset}px, 0)`;
    playerShell.style.opacity = String(Math.max(.92, 1 - Math.abs(offset) / 1500));
  }, { passive: false });

  playerShell?.addEventListener('touchend', (event) => {
    if (!touchActive) return;
    const deltaY = (event.changedTouches[0]?.clientY || 0) - touchStartY;
    touchActive = false;
    touchDeltaY = 0;
    if (Math.abs(deltaY) >= 45) {
      switchVideo(deltaY < 0 ? 1 : -1, true);
      return;
    }
    resetSwipePosition();
  }, { passive: true });

  playerShell?.addEventListener('touchcancel', () => {
    touchActive = false;
    touchDeltaY = 0;
    resetSwipePosition();
  }, { passive: true });

  document.addEventListener('keydown', (event) => {
    if (!modal.classList.contains('is-open')) return;
    if (event.key === 'Escape') close();
    if (event.key === 'ArrowDown') switchVideo(1, true);
    if (event.key === 'ArrowUp') switchVideo(-1, true);
  });

  if (new URLSearchParams(window.location.search).has('video_feed_resume')) {
    try {
      const resume = JSON.parse(sessionStorage.getItem(resumeStorageKey) || 'null');
      const resumeIndex = items.findIndex((item) => item.dataset.adId === String(resume?.adId));
      if (resumeIndex >= 0) open(resumeIndex, Number(resume?.seconds) || 0);
      sessionStorage.removeItem(resumeStorageKey);
    } catch (_) {
      sessionStorage.removeItem(resumeStorageKey);
    }
    window.history.replaceState({}, '', window.location.pathname);
  }
})();

// ================= Вернуться к видео из карточки объявления =================
(function () {
  const chip = document.getElementById('videoReturnChip');
  if (!chip) return;

  const storageKey = 'igma.videoFeedResume';
  let resume = null;
  try { resume = JSON.parse(sessionStorage.getItem(storageKey) || 'null'); } catch (_) {}
  if (!resume?.adId) return;

  chip.hidden = false;
  document.getElementById('videoReturnDismiss')?.addEventListener('click', () => {
    sessionStorage.removeItem(storageKey);
    chip.hidden = true;
  });
})();

// ================= 🎥 ВИДЕО: предпросмотр и удаление =================

// ====== 🎥 Оплата, сжатие и добавление видео ======
(function () {
  const csrf = document.querySelector('meta[name="csrf-token"]')?.content || '';

  const openBtn = document.getElementById('openVideoPayModal');
  const fileInput = document.getElementById('video');
  const preview = document.getElementById('video-preview');
  const existing = document.getElementById('existing-video');
  const feedback = document.getElementById('video-upload-feedback');
  const removeVideoInput = document.getElementById('remove_video');
  const paidInput = document.getElementById('video_feature_paid');
  const videoBatchInput = document.getElementById('video_upload_batch');
  const uploadedVideoManifestInput = document.getElementById('uploaded_video_manifest');
  const modal = document.getElementById('videoWalletModal');
  const payBtn = document.getElementById('vpm-pay');
  const statusEl = document.getElementById('vpm-status');
  const balanceEl = document.getElementById('vpm-balance');

  if (!openBtn || !fileInput || !modal || !payBtn || !balanceEl) return;

  let balance = parseInt(balanceEl.dataset.balance || '0', 10);
  const price = parseInt(payBtn.dataset.price || '0', 10);
  const endpoint = payBtn.getAttribute('data-endpoint') || '/features/video/pay-wallet';
  const videoState = window.__videoUploadState || (window.__videoUploadState = {
    enabled: Boolean(videoBatchInput && uploadedVideoManifestInput),
    presignUrl: '/ads/videos/presign',
    batchToken: videoBatchInput?.value || '',
    processing: false,
    uploading: false,
    progress: 0,
    promise: Promise.resolve(),
    errorMessage: '',
    result: null,
    xhr: null,
  });

  let ffmpegModulePromise = null;
  let ffmpegInstancePromise = null;
  let videoObjectUrl = null;

  const i18n = {
    insufficient: modal.dataset.i18nInsufficient || 'Недостаточно средств',
    network: modal.dataset.i18nNetwork || 'Ошибка сети',
    paid: modal.dataset.i18nPaid || 'Опция активирована',
    error: modal.dataset.i18nError || 'Ошибка',
    compressing: document.documentElement.lang?.startsWith('hy')
      ? 'Սեղմում ենք տեսանյութը բեռնման արագացման համար...'
      : document.documentElement.lang?.startsWith('en')
        ? 'Compressing the video to speed up upload...'
        : 'Сжимаем видео, чтобы оно загрузилось быстрее...',
    uploading: document.documentElement.lang?.startsWith('hy')
      ? 'Տեսանյութը բեռնվում է...'
      : document.documentElement.lang?.startsWith('en')
        ? 'Uploading the video...'
        : 'Загружаем видео...',
    processing: document.documentElement.lang?.startsWith('hy')
      ? 'Պատրաստում ենք տեսանյութը...'
      : document.documentElement.lang?.startsWith('en')
        ? 'Preparing the video...'
        : 'Подготавливаем видео...',
    waitProcessing: document.documentElement.lang?.startsWith('hy')
      ? 'Սպասեք, մինչև տեսանյութի պատրաստումը ավարտվի։'
      : document.documentElement.lang?.startsWith('en')
        ? 'Please wait until the video processing finishes.'
        : 'Дождитесь окончания обработки видео.',
    pickAgain: document.documentElement.lang?.startsWith('hy')
      ? 'Տեսանյութը ակտիվացված է։ Կրկին սեղմեք՝ ֆայլը ընտրելու համար։'
      : document.documentElement.lang?.startsWith('en')
        ? 'Video is enabled. Tap again to choose a file.'
        : 'Видео активировано. Нажмите ещё раз, чтобы выбрать файл.',
    invalidType: document.documentElement.lang?.startsWith('hy')
      ? 'Թույլատրվում են MP4, MOV կամ M4V տեսանյութեր։'
      : document.documentElement.lang?.startsWith('en')
        ? 'Only MP4, MOV, or M4V videos are supported.'
        : 'Поддерживаются только видео MP4, MOV или M4V.',
    compressionFallback: document.documentElement.lang?.startsWith('hy')
      ? 'Չստացվեց սեղմել տեսանյութը, բեռնում ենք բնօրինակը։'
      : document.documentElement.lang?.startsWith('en')
        ? 'Could not compress the video, uploading the original file instead.'
        : 'Не получилось сжать видео, загрузим исходный файл.',
  };

  function isVideoPaid() {
    return paidInput?.value === '1';
  }

  function setVideoPaid(value) {
    if (paidInput) {
      paidInput.value = value ? '1' : '0';
    }
  }

  function updateVideoEnabledState() {
    fileInput.disabled = !isVideoPaid();
  }

  function syncUploadedVideoManifest(result) {
    videoState.result = result || null;
    if (!uploadedVideoManifestInput) return;
    uploadedVideoManifestInput.value = result?.temp_id ? JSON.stringify({ temp_id: result.temp_id }) : '';
  }

  function setProcessingState(active, message = '') {
    videoState.processing = active;
    videoState.errorMessage = active ? message : '';
    document.documentElement.classList.toggle('video-processing', active);
  }

  function setFeedback(message = '', state = '') {
    if (!feedback) return;
    feedback.textContent = message;
    feedback.className = 'video-upload-feedback';
    if (message && state) {
      feedback.classList.add(`is-${state}`);
    }
  }

  function isSupportedVideoFile(file) {
    if (!(file instanceof File)) return false;

    const normalizedType = String(file.type || '').toLowerCase();
    const normalizedName = String(file.name || '').toLowerCase();
    const allowedTypes = new Set(['video/mp4', 'video/quicktime', 'video/x-m4v', 'application/octet-stream']);
    const allowedExtensions = ['.mp4', '.mov', '.m4v'];

    return allowedTypes.has(normalizedType) || allowedExtensions.some((extension) => normalizedName.endsWith(extension));
  }

  function clearPreview() {
    const videoEl = preview.querySelector('video');
    if (videoEl) {
      videoEl.pause?.();
      videoEl.removeAttribute('src');
      videoEl.load?.();
    }
    if (videoObjectUrl) {
      URL.revokeObjectURL(videoObjectUrl);
      videoObjectUrl = null;
    }
    preview.innerHTML = '';
  }

  function isCoarsePointerDevice() {
    return window.matchMedia?.('(pointer: coarse)').matches || /Android|iPhone|iPad|iPod/i.test(navigator.userAgent || '');
  }

  function setUploadState(active, progress = 0, message = '') {
    videoState.uploading = active;
    videoState.progress = progress;
    videoState.errorMessage = active ? message : videoState.errorMessage;
  }

  function shouldCompressVideo(file) {
    if (!(file instanceof File)) return false;
    if (file.size < 6 * 1024 * 1024) return false;

    const lowerName = String(file.name || '').toLowerCase();
    return file.type.startsWith('video/') || ['.mp4', '.mov', '.m4v'].some((suffix) => lowerName.endsWith(suffix));
  }

  function extFromFile(file) {
    const lowerName = String(file?.name || '').toLowerCase();
    if (lowerName.endsWith('.mov')) return 'mov';
    if (lowerName.endsWith('.m4v')) return 'm4v';
    return 'mp4';
  }

  async function loadFfmpegModule() {
    if (!ffmpegModulePromise) {
      ffmpegModulePromise = import('@ffmpeg/ffmpeg');
    }
    return ffmpegModulePromise;
  }

  async function getFfmpeg() {
    if (!ffmpegInstancePromise) {
      ffmpegInstancePromise = (async () => {
        const { FFmpeg } = await loadFfmpegModule();
        const ffmpeg = new FFmpeg();
        await ffmpeg.load();
        return ffmpeg;
      })();
    }

    return ffmpegInstancePromise;
  }

  async function requestVideoPresign(file) {
    const response = await fetch(videoState.presignUrl, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': csrf,
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        name: file.name,
        type: file.type || 'video/mp4',
        size: file.size,
        batch_token: videoState.batchToken,
      }),
    });

    const payload = await response.json().catch(() => ({}));
    if (!response.ok || !payload?.ok) {
      throw new Error(payload?.message || `Video presign failed (${response.status})`);
    }

    return payload;
  }

  function uploadVideoToPresignedUrl(file, presigned) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      videoState.xhr = xhr;
      xhr.open('PUT', presigned.url, true);

      Object.entries(presigned.headers || {}).forEach(([key, value]) => {
        if (value != null) {
          xhr.setRequestHeader(key, String(value));
        }
      });

      if (!(presigned.headers || {})['Content-Type'] && file.type) {
        xhr.setRequestHeader('Content-Type', file.type);
      }

      xhr.upload.onprogress = (event) => {
        if (!event.lengthComputable) return;
        const percent = Math.max(0, Math.min(100, Math.round((event.loaded / event.total) * 100)));
        setUploadState(true, percent, i18n.uploading);
        setFeedback(`${i18n.uploading} ${percent}%`, 'info');
      };

      xhr.onerror = () => reject(new Error('Video cloud upload failed'));
      xhr.onabort = () => reject(new Error('Video upload aborted'));
      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve({
            temp_id: presigned.temp_id,
            disk: presigned.disk,
            path: presigned.path,
            originalName: file.name,
            uploadedSizeBytes: file.size,
          });
          return;
        }

        reject(new Error(`Video cloud upload failed (${xhr.status})`));
      };

      xhr.send(file);
    });
  }

  async function uploadVideoDirectToCloud(file) {
    const presigned = await requestVideoPresign(file);
    return uploadVideoToPresignedUrl(file, presigned);
  }

  async function compressVideoFile(file) {
    const ffmpeg = await getFfmpeg();
    const inputExt = extFromFile(file);
    const inputName = `input.${inputExt}`;
    const outputName = 'output.mp4';
    const sourceBytes = new Uint8Array(await file.arrayBuffer());
    let lastPercent = -1;

    const onProgress = ({ progress }) => {
      const percent = Math.max(0, Math.min(100, Math.round((progress || 0) * 100)));
      if (percent === lastPercent) return;
      lastPercent = percent;
      setFeedback(`${i18n.compressing} ${percent}%`, 'info');
    };

    ffmpeg.on('progress', onProgress);

    try {
      await ffmpeg.writeFile(inputName, sourceBytes);
      await ffmpeg.exec([
        '-i', inputName,
        '-vf', "scale='min(1280,iw)':-2:force_original_aspect_ratio=decrease",
        '-c:v', 'mpeg4',
        '-q:v', '7',
        '-movflags', '+faststart',
        '-pix_fmt', 'yuv420p',
        '-c:a', 'aac',
        '-b:a', '128k',
        outputName,
      ]);

      const compressedBytes = await ffmpeg.readFile(outputName);
      const normalizedBytes = compressedBytes instanceof Uint8Array
        ? compressedBytes
        : new Uint8Array(compressedBytes);

      if (!normalizedBytes.byteLength || normalizedBytes.byteLength >= file.size * 0.97) {
        return file;
      }

      return new File(
        [normalizedBytes],
        `${file.name.replace(/\.(mp4|mov|m4v)$/i, '') || 'video'}-compressed.mp4`,
        {
          type: 'video/mp4',
          lastModified: Date.now(),
        },
      );
    } finally {
      ffmpeg.off('progress', onProgress);
      await Promise.allSettled([
        ffmpeg.deleteFile(inputName),
        ffmpeg.deleteFile(outputName),
      ]);
    }
  }

  function syncVideoInputFile(file) {
    const dt = new DataTransfer();
    dt.items.add(file);
    fileInput.files = dt.files;
  }

  function renderVideoPreview(file, pending = false) {
    clearPreview();

    const video = document.createElement('video');
    videoObjectUrl = URL.createObjectURL(file);
    video.src = videoObjectUrl;
    video.controls = true;
    video.preload = 'metadata';

    const removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = 'remove-video';
    removeBtn.title = '×';
    removeBtn.textContent = '×';
    removeBtn.addEventListener('click', () => {
      if (videoState.xhr && videoState.uploading) {
        try {
          videoState.xhr.abort();
        } catch (_) {}
      }
      fileInput.value = '';
      syncUploadedVideoManifest(null);
      setUploadState(false, 0, '');
      setProcessingState(false);
      clearPreview();
      setFeedback('');
    });

    const wrap = document.createElement('div');
    wrap.className = pending ? 'video-wrapper video-wrapper-pending' : 'video-wrapper';
    const spinner = document.createElement('div');
    spinner.className = 'video-upload-spinner';

    if (pending) {
      wrap.append(video, spinner, removeBtn);
    } else {
      wrap.append(video, removeBtn);
    }

    const markLoaded = () => {
      wrap.classList.remove('video-wrapper-pending');
      spinner.remove();
    };

    video.addEventListener('loadeddata', markLoaded, { once: true });
    video.addEventListener('error', () => {
      wrap.classList.remove('video-wrapper-pending');
      spinner.remove();
      setFeedback(i18n.invalidType, 'error');
    }, { once: true });

    preview.appendChild(wrap);
  }

  function openModal() {
    modal.classList.remove('hidden');
    modal.setAttribute('aria-hidden', 'false');
    if (balance < price) {
      statusEl.textContent = i18n.insufficient;
      statusEl.classList.add('error');
      payBtn.disabled = true;
    } else {
      statusEl.textContent = '';
      statusEl.classList.remove('error');
      payBtn.disabled = false;
    }
  }

  function closeModal() {
    modal.classList.add('hidden');
    modal.setAttribute('aria-hidden', 'true');
  }

  function updateBalanceUI() {
    balanceEl.dataset.balance = String(balance);
    balanceEl.textContent = `${balance.toLocaleString('ru-RU')} ֏`;
  }

  async function chargeOnServer() {
    try {
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'X-CSRF-TOKEN': csrf,
        },
      });
      const data = await res.json().catch(() => ({}));

      if (res.status === 401) {
        statusEl.textContent = i18n.error;
        statusEl.classList.add('error');
        return false;
      }

      if (!res.ok || !data.ok) {
        statusEl.textContent = data.error || i18n.error;
        statusEl.classList.add('error');
        if (typeof data.balance === 'number') {
          balance = data.balance;
          updateBalanceUI();
        }
        return false;
      }

      if (typeof data.balance === 'number') {
        balance = data.balance;
        updateBalanceUI();
      }

      return true;
    } catch {
      statusEl.textContent = i18n.network;
      statusEl.classList.add('error');
      return false;
    }
  }

  openBtn.addEventListener('click', (e) => {
    e.preventDefault();
    if (isVideoPaid() && !fileInput.disabled) {
      setFeedback('');
      fileInput.click();
      return;
    }
    openModal();
  });

  modal.querySelectorAll('[data-close]').forEach((el) => el.addEventListener('click', closeModal));
  document.addEventListener('keydown', (e) => {
    if (!modal.classList.contains('hidden') && e.key === 'Escape') closeModal();
  });

  payBtn.addEventListener('click', async () => {
    if (payBtn.disabled) return;
    if (balance < price) {
      statusEl.textContent = i18n.insufficient;
      statusEl.classList.add('error');
      return;
    }

    const original = payBtn.innerHTML;
    payBtn.disabled = true;
    payBtn.innerHTML = '<span class="spinner"></span>';

    const ok = await chargeOnServer();

    payBtn.disabled = false;
    payBtn.innerHTML = original;

    if (!ok) return;

    setVideoPaid(true);
    updateVideoEnabledState();
    closeModal();

    if (isCoarsePointerDevice()) {
      setFeedback(i18n.pickAgain, 'info');
      window.showSuccessToast?.('🎥 ' + i18n.pickAgain);
      return;
    }

    setFeedback('');
    fileInput.click();
    window.showSuccessToast?.('🎥 ' + i18n.paid);
  });

  fileInput.addEventListener('change', async () => {
    const file = fileInput.files?.[0];
    clearPreview();
    syncUploadedVideoManifest(null);
    setFeedback('');
    if (!file) return;

    if (!isSupportedVideoFile(file)) {
      fileInput.value = '';
      setFeedback(i18n.invalidType, 'error');
      return;
    }

    if (removeVideoInput) {
      removeVideoInput.value = '0';
    }

    renderVideoPreview(file, true);
    setProcessingState(true, videoState.enabled ? i18n.uploading : i18n.processing);
    setUploadState(videoState.enabled, 0, videoState.enabled ? i18n.uploading : '');
    setFeedback(videoState.enabled ? `${i18n.uploading} 0%` : i18n.processing, 'info');

    const processingPromise = (async () => {
      let finalFile = file;

      if (videoState.enabled) {
        syncVideoInputFile(file);
        const uploaded = await uploadVideoDirectToCloud(file);
        syncUploadedVideoManifest(uploaded);
        fileInput.value = '';
        renderVideoPreview(file, false);
        setUploadState(false, 100, '');
        setFeedback(i18n.paid, 'info');
        return;
      }

      if (shouldCompressVideo(file)) {
        try {
          finalFile = await compressVideoFile(file);
        } catch (error) {
          console.warn('Video compression failed, using original file', error);
          finalFile = file;
          setFeedback(i18n.compressionFallback, 'info');
        }
      }

      syncVideoInputFile(finalFile);
      renderVideoPreview(finalFile, false);

      if (!feedback.textContent || feedback.textContent === i18n.processing) {
        setFeedback(i18n.paid, 'info');
      }
    })();

    videoState.promise = processingPromise
      .catch((error) => {
        setUploadState(false, 0, '');
        syncUploadedVideoManifest(null);
        if (error instanceof Error) {
          setFeedback(error.message, 'error');
          videoState.errorMessage = error.message;
        }
      })
      .finally(() => {
        videoState.xhr = null;
        setProcessingState(false);
      });

    await videoState.promise;
  });

  if (existing) {
    const deleteBtn = existing.querySelector('.remove-video');
    if (deleteBtn) {
      deleteBtn.addEventListener('click', () => {
        existing.remove();
        if (removeVideoInput) {
          removeVideoInput.value = '1';
        } else {
          const hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = 'remove_video';
          hidden.value = '1';
          (existing.closest('form') || document.querySelector('form'))?.appendChild(hidden);
        }
        setFeedback('');
      });
    }
  }

  updateVideoEnabledState();
})();

(function () {
  const form = document.getElementById('ad-edit-form');
  const submitBtn = form?.querySelector('.submit-btn, button[type="submit"]');
  const statusBox = document.getElementById('ad-edit-form-status');
  const photoInput = document.getElementById('photos');
  const videoInput = document.getElementById('video');
  if (!form || !submitBtn) return;

  const lang = (document.documentElement.lang || 'ru').slice(0, 2).toLowerCase();
  const messages = {
    ru: {
      saving: 'Сохраняем изменения...',
      photos: 'Сохраняем объявление и загружаем фото...',
      video: 'Сохраняем объявление и загружаем видео...',
    },
    en: {
      saving: 'Saving changes...',
      photos: 'Saving the ad and uploading photos...',
      video: 'Saving the ad and uploading the video...',
    },
    hy: {
      saving: 'Պահպանում ենք փոփոխությունները...',
      photos: 'Պահպանում ենք հայտարարությունը և բեռնում լուսանկարները...',
      video: 'Պահպանում ենք հայտարարությունը և բեռնում տեսանյութը...',
    },
  };
  const t = messages[lang] || messages.ru;
  let isSubmitting = false;

  form.addEventListener('submit', (event) => {
    if (window.__videoUploadState?.processing || window.__videoUploadState?.uploading) {
      event.preventDefault();
      if (statusBox) {
        statusBox.className = 'ad-form-status is-visible is-warning';
        statusBox.textContent = window.__videoUploadState.errorMessage || 'Дождитесь окончания обработки видео.';
      }
      return;
    }

    if (isSubmitting) {
      event.preventDefault();
      return;
    }

    isSubmitting = true;

    const hasVideo = Boolean(videoInput?.files?.length);
    const hasPhotos = Boolean(photoInput?.files?.length);
    const text = hasVideo ? t.video : (hasPhotos ? t.photos : t.saving);

    submitBtn.disabled = true;
    submitBtn.classList.add('is-loading');
    submitBtn.setAttribute('aria-busy', 'true');
    submitBtn.innerHTML = `<span class="submit-btn-spinner" aria-hidden="true"></span><span>${text}</span>`;

    if (statusBox) {
      statusBox.className = 'ad-form-status is-visible is-warning';
      statusBox.textContent = text;
    }
  });
})();

// ================= Код (только для агентств) «в день» Тип расчёта (только для нужных категорий) =================


// Помечаем тач-устройства (чтобы выключить CSS-тултип)
if (window.matchMedia('(hover: none)').matches) {
  document.documentElement.classList.add('is-touch');
}

/* ====== Кастом-селект для валюты ====== */
document.querySelectorAll('select[data-cs="currency"]').forEach(select => {
  const wrap  = document.createElement('div'); wrap.className = 'cs';
  const btn   = document.createElement('button'); btn.type='button'; btn.className='cs__btn';
  const caret = document.createElement('span'); caret.className='cs__caret'; caret.textContent='▾';
  const list  = document.createElement('div'); list.className='cs__list';

  // Вкладываем; если JS не загрузится — останется нативный select
  select.parentNode.insertBefore(wrap, select);
  wrap.appendChild(select);
  wrap.appendChild(btn);
  wrap.appendChild(list);

  // Рендер
  const build = () => {
    // Кнопка
    btn.innerHTML = '';
    btn.appendChild(document.createTextNode(select.options[select.selectedIndex]?.textContent || '—'));
    btn.appendChild(caret);
    // Ширина списка = ширина кнопки (но с ограничением 92vw в CSS)
    const r = btn.getBoundingClientRect();
    wrap.style.setProperty('--cs-w', r.width + 'px');

    // Контент списка
    list.innerHTML = '';
    [...select.options].forEach((o, i) => {
      const it = document.createElement('div');
      it.className = 'cs__opt';
      it.textContent = o.textContent;
      it.addEventListener('click', () => {
        select.selectedIndex = i;
        select.dispatchEvent(new Event('change'));
        build();
        wrap.classList.remove('is-open');
      });
      list.appendChild(it);
    });

    // Позиционирование списка (фиксированно и в пределах экрана)
    const placeList = () => {
      const b = btn.getBoundingClientRect();
      const L = list.getBoundingClientRect();
      const gap = 8, vw = innerWidth, vh = innerHeight;

      // по вертикали — вниз если места хватает
      const below = (vh - b.bottom - gap) >= L.height || (vh - b.bottom) >= b.top;
      let top = below ? (b.bottom + gap) : (b.top - L.height - gap);
      top = Math.max(8, Math.min(top, vh - L.height - 8));

      // по горизонтали — центр относительно кнопки, но в пределах экрана
      let left = b.left + b.width/2 - L.width/2;
      left = Math.max(8, Math.min(left, vw - L.width - 8));

      list.style.top  = top + 'px';
      list.style.left = left + 'px';
    };

    placeList();
    // Перестраиваем позицию при открытом списке
    const onReflow = () => { if (wrap.classList.contains('is-open')) placeList(); };
    window.addEventListener('resize', onReflow, { passive:true });
    window.addEventListener('scroll',  onReflow, true);
  };

  // Скрываем нативный селект только после сборки
  select.style.display = 'none';
  build();

  btn.addEventListener('click', (e) => {
    e.preventDefault();
    wrap.classList.toggle('is-open');
  });

  // Закрытие по клику вне/ESC
  document.addEventListener('click', (e) => {
    if (!wrap.contains(e.target)) wrap.classList.remove('is-open');
  }, true);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') wrap.classList.remove('is-open');
  });
});

/* ====== Мобильный поповер для «?» (только на тач) ====== */
if (window.matchMedia('(hover: none)').matches) {
  const btn   = document.querySelector('.pg-item.pg-code .pg-tooltip');
  const field = document.querySelector('.pg-item.pg-code .pg-field');
  if (btn && field) {
    let pop = null;

    const clamp = () => {
      if (!pop) return;
      const a = field.getBoundingClientRect();
      const p = pop.getBoundingClientRect();
      const vw = innerWidth, vh = innerHeight, gap = 8;

      const below = (vh - a.bottom - gap) >= p.height || (vh - a.bottom) >= a.top;
      let top = below ? a.bottom + gap : a.top - p.height - gap;
      top = Math.max(8, Math.min(top, vh - p.height - 8));

      let left = a.left + a.width/2 - p.width/2;
      left = Math.max(8, Math.min(left, vw - p.width - 8));

      pop.style.top = `${top}px`;
      pop.style.left = `${left}px`;
      pop.dataset.side = below ? 'bottom' : 'top';

      const arrowX = a.left + a.width/2 - left;
      pop.style.setProperty('--arrow-x', `${Math.max(12, Math.min(arrowX, p.width - 12))}px`);
    };

    const open  = () => { if (!pop) { pop = document.createElement('div'); pop.className='tt-pop';
      pop.textContent = btn.getAttribute('data-tooltip') || ''; document.body.appendChild(pop); clamp(); } };
    const close = () => { if (pop) { pop.remove(); pop = null; } };

    btn.addEventListener('click', e => { e.preventDefault(); pop ? close() : open(); });
    document.addEventListener('click', e => { if (pop && !e.target.closest('.pg-item.pg-code')) close(); }, true);
    ['resize','orientationchange'].forEach(ev => window.addEventListener(ev, clamp));
    window.addEventListener('scroll', clamp, true);
  }
}

//=======================================================================================================

//для загрузки моделей телефона
const phoneBrandSelect = document.getElementById('phone-brand');
const phoneModelSelect = document.getElementById('phone-model');

if (phoneBrandSelect) {
  if (window.jQuery && typeof jQuery.fn.select2 === 'function') {
    // ✅ Инициализация select2 через jQuery (без конфликта с нашими хелперами)
    jQuery(phoneBrandSelect).select2({
      placeholder: 'Выбрать марку',
      allowClear: true,
      width: '100%'
    });

    jQuery(phoneBrandSelect).on('change', function () {
      const brandId = this.value;
      phoneModelSelect.innerHTML = '<option value="">Загрузка...</option>';

      if (brandId) {
        fetch(`/get-phone-models/${brandId}`)
          .then(response => response.json())
          .then(data => {
            let options = '<option value="">Выбрать модель</option>';
            data.forEach(model => {
              options += `<option value="${model.id}">${model.name}</option>`;
            });
            phoneModelSelect.innerHTML = options;
          })
          .catch(() => {
            phoneModelSelect.innerHTML = '<option value="">Ошибка загрузки</option>';
          });
      } else {
        phoneModelSelect.innerHTML = '<option value="">Сначала выберите марку</option>';
      }
    });
  } else {
    // 🔁 Fallback без jQuery/select2 — нативный select, всё работает
    phoneBrandSelect.addEventListener('change', function () {
      const brandId = this.value;
      phoneModelSelect.innerHTML = '<option value="">Загрузка...</option>';

      if (brandId) {
        fetch(`/get-phone-models/${brandId}`)
          .then(response => response.json())
          .then(data => {
            let options = '<option value="">Выбрать модель</option>';
            data.forEach(model => {
              options += `<option value="${model.id}">${model.name}</option>`;
            });
            phoneModelSelect.innerHTML = options;
          })
          .catch(() => {
            phoneModelSelect.innerHTML = '<option value="">Ошибка загрузки</option>';
          });
      } else {
        phoneModelSelect.innerHTML = '<option value="">Сначала выберите марку</option>';
      }
    });
  }
}

//===================================================================================================
// Яндекс карта
let mapInstance = null;
let placemark = null;

window.openMapModal = function () {
  const modal = document.getElementById('mapModal');
  modal.style.display = 'block';

  const lat = parseFloat(document.getElementById('lat')?.value) || 40.1792;
  const lng = parseFloat(document.getElementById('lng')?.value) || 44.4991;
  const addressInput = document.getElementById('address-input');

  // Очистка предыдущей карты
  if (mapInstance) {
    mapInstance.destroy();
    mapInstance = null;
  }

  ymaps.ready(() => {
    mapInstance = new ymaps.Map("map", {
      center: [lat, lng],
      zoom: 15
    });

    placemark = new ymaps.Placemark([lat, lng], {}, {
      draggable: !!addressInput // Разрешить перетаскивание только при добавлении
    });

    mapInstance.geoObjects.add(placemark);

    // ✅ Если это режим добавления, с input'ом — обновляем адрес при клике и перемещении
    if (addressInput) {
      placemark.events.add('dragend', function () {
        const coords = placemark.geometry.getCoordinates();
        setCoordinates(coords);
        updateAddressFromCoords(coords);
      });

      mapInstance.events.add('click', function (e) {
        const coords = e.get('coords');
        placemark.geometry.setCoordinates(coords);
        setCoordinates(coords);
        updateAddressFromCoords(coords);
      });

      // Если пользователь уже ввёл адрес — обновляем координаты по нему
      const query = addressInput.value.trim();
      if (query.length > 2) {
        ymaps.geocode(query).then(res => {
          const first = res.geoObjects.get(0);
          if (first) {
            const coords = first.geometry.getCoordinates();
            placemark.geometry.setCoordinates(coords);
            mapInstance.setCenter(coords);
            setCoordinates(coords);
          }
        });
      }
    }
  });
};

window.closeMapModal = function () {
  document.getElementById('mapModal').style.display = 'none';
};

function setCoordinates(coords) {
  document.getElementById('lat').value = coords[0];
  document.getElementById('lng').value = coords[1];
}

function updateAddressFromCoords(coords) {
  const input = document.getElementById('address-input');
  if (input) {
    ymaps.geocode(coords).then(res => {
      const first = res.geoObjects.get(0);
      if (first) {
        input.value = first.getAddressLine();
      }
    });
  }
}

// 📽️ Открытие модалки видео
window.openVideoModal = function () {
  // The standalone ad video takes focus, so don't leave the feed-return chip
  // above it.
  document.getElementById('videoReturnChip')?.setAttribute('hidden', '');
  const modal = document.getElementById("videoModal");
  if (modal) {
    modal.classList.remove("hidden");
    const video = modal.querySelector("video");
    if (video) video.play();
  }
};

window.closeVideoModal = function () {
  const modal = document.getElementById("videoModal");
  if (modal) {
    modal.classList.add("hidden");
    const video = modal.querySelector("video");
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
  }
};

// marka_modeli mashin 
// 🚘 Select2 + Загрузка моделей по марке
const carBrandSelect = document.querySelector('.js-car-brand');
const modelSelect = document.getElementById('car-model');

// ✅ Инициализируем Select2 (поиск по марке)
if (carBrandSelect) {
  if (window.jQuery && typeof jQuery.fn.select2 === 'function') {
    jQuery(carBrandSelect).select2({
      placeholder: 'Выбрать марку',
      allowClear: true,
      width: '100%'
    });

    // ✅ Загружаем модели при выборе марки
    jQuery(carBrandSelect).on('change', function () {
      const carId = this.value;
      modelSelect.innerHTML = '<option value="">Загрузка...</option>';

      if (carId) {
        fetch(`/get-car-models/${carId}`)
          .then(response => response.json())
          .then(data => {
            let options = '<option value="">Выбрать модель</option>';
            data.forEach(model => {
              options += `<option value="${model.id}">${model.name}</option>`;
            });
            modelSelect.innerHTML = options;
          })
          .catch(() => {
            modelSelect.innerHTML = '<option value="">Ошибка загрузки</option>';
          });
      } else {
        modelSelect.innerHTML = '<option value="">Сначала выберите марку</option>';
      }
    });
  } else {
    // 🔁 Fallback без jQuery/select2 — нативный select
    carBrandSelect.addEventListener('change', function () {
      const carId = this.value;
      modelSelect.innerHTML = '<option value="">Загрузка...</option>';

      if (carId) {
        fetch(`/get-car-models/${carId}`)
          .then(response => response.json())
          .then(data => {
            let options = '<option value="">Выбрать модель</option>';
            data.forEach(model => {
              options += `<option value="${model.id}">${model.name}</option>`;
            });
            modelSelect.innerHTML = options;
          })
          .catch(() => {
            modelSelect.innerHTML = '<option value="">Ошибка загрузки</option>';
          });
      } else {
        modelSelect.innerHTML = '<option value="">Сначала выберите марку</option>';
      }
    });
  }
}

//------------- REGION ZAGRUSKA   -----------------
//------------- REGION ЗАГРУЗКА -----------------

function initRegionDropdown({
  dropdownId,
  selectedTextId,
  optionsId,
  inputId,
  formId,
  autoSubmit = true
}) {
  const dropdown = document.getElementById(dropdownId);
  const selectedText = document.getElementById(selectedTextId);
  const optionsContainer = document.getElementById(optionsId);
  const subregionInput = document.getElementById(inputId);
  const regionForm = document.getElementById(formId);

  const isCreatePage = window.location.pathname.includes('/create');

  if (!dropdown || !selectedText || !optionsContainer || !subregionInput) {
    return;
  }

  const getLabelNode = () => {
    return selectedText.querySelector('.selected-option-label') || selectedText;
  };

  const getPlaceholder = () => {
    return selectedText.dataset.placeholder || selectedText.getAttribute('data-placeholder') || '';
  };

  const getClearLabel = () => {
    return selectedText.dataset.clearLabel || 'Очистить';
  };

  const renderSelectedText = (text, withClear = false) => {
    const clearLabel = getClearLabel();
    selectedText.innerHTML = `
      <span class="selected-option-label">${text}</span>
      ${withClear ? `
        <button type="button" class="clear-selection" title="${clearLabel}" aria-label="${clearLabel}">
          <i class="fas fa-times"></i>
        </button>
      ` : ''}
    `;
    bindClearButton();
  };

  const openDropdown = () => {
    document.querySelectorAll('.options-container').forEach(el => {
      if (el !== optionsContainer) {
        el.classList.add('hidden');
      }
    });

    document.querySelectorAll('.custom-select').forEach(el => {
      if (el !== dropdown) {
        el.classList.remove('open');
      }
    });

    optionsContainer.classList.remove('hidden');
    dropdown.classList.add('open');
    selectedText.classList.add('active');
  };

  const closeDropdown = () => {
    optionsContainer.classList.add('hidden');
    dropdown.classList.remove('open');
    selectedText.classList.remove('active');

    optionsContainer.querySelectorAll('.subregion-list').forEach(el => {
      el.classList.remove('open');
    });
    optionsContainer.querySelectorAll('.region-name').forEach(el => {
      el.classList.remove('opened');
    });
  };

  const toggleDropdown = (e) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();

    if (optionsContainer.classList.contains('hidden')) {
      openDropdown();
    } else {
      closeDropdown();
    }
  };

  const bindClearButton = () => {
    const clearBtn = selectedText.querySelector('.clear-selection');
    if (!clearBtn) return;

    clearBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      subregionInput.value = '';
      renderSelectedText(getPlaceholder(), false);

      if (autoSubmit && !isCreatePage && regionForm) {
        regionForm.submit();
      }

      closeDropdown();
    });
  };

  selectedText.addEventListener('click', toggleDropdown);

  optionsContainer.addEventListener('click', (e) => {
    e.stopPropagation();
  });

  document.addEventListener('click', (e) => {
    if (!dropdown.contains(e.target)) {
      closeDropdown();
    }
  });

  optionsContainer.querySelectorAll('.region-name').forEach((regionEl) => {
    regionEl.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const list = regionEl.nextElementSibling;
      const isOpen = list?.classList.contains('open');

      optionsContainer.querySelectorAll('.subregion-list').forEach(el => {
        el.classList.remove('open');
      });

      optionsContainer.querySelectorAll('.region-name').forEach(el => {
        el.classList.remove('opened');
      });

      if (!isOpen && list) {
        list.classList.add('open');
        regionEl.classList.add('opened');
      }
    });
  });

  optionsContainer.querySelectorAll('.subregion-option').forEach((opt) => {
    opt.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const id = opt.dataset.id || '';
      const subName = opt.textContent.trim();
      const regionName = opt.closest('.region-group')?.querySelector('.region-name')?.textContent.trim() || '';

      subregionInput.value = id;
      renderSelectedText(regionName ? `${regionName} — ${subName}` : subName, true);

      if (autoSubmit && !isCreatePage && regionForm) {
        regionForm.submit();
      }

      closeDropdown();
    });
  });

  bindClearButton();

  const initialSubregionId = (subregionInput.value || '').trim();
  if (initialSubregionId) {
    const selectedOption = optionsContainer.querySelector(`.subregion-option[data-id="${initialSubregionId}"]`);
    if (selectedOption) {
      const subName = selectedOption.textContent.trim();
      const regionName = selectedOption.closest('.region-group')?.querySelector('.region-name')?.textContent.trim() || '';
      renderSelectedText(regionName ? `${regionName} — ${subName}` : subName, true);
    }
  }
}

// desktop
initRegionDropdown({
  dropdownId: 'regionDropdown',
  selectedTextId: 'selectedRegionText',
  optionsId: 'regionOptions',
  inputId: 'selectedSubregionId',
  formId: document.getElementById('regionFilterForm') ? 'regionFilterForm' : 'filterForm'
});

// mobile
initRegionDropdown({
  dropdownId: 'regionDropdownMobile',
  selectedTextId: 'selectedRegionTextMobile',
  optionsId: 'regionOptionsMobile',
  inputId: 'selectedSubregionIdMobile',
  formId: 'form-mobile-filters',
  autoSubmit: false
});

//------------- /REGION ЗАГРУЗКА -----------------

// =============================================================

// 📌 Делаем доступным глобально
window.openCategoriesMenu = openCategoriesMenu;
window.closeCategoriesMenu = closeCategoriesMenu;
window.loadSubCategories = loadSubCategories;
window.toggleMobileCategories = toggleMobileCategories; // Исправлено: добавлено вместо toggleMobileSubCategories
window.closeMobileCategories = closeMobileCategories;

// 💬 Открытие чата по клику на диалог
/* ========================== Messages UI ========================== */
/* helpers */
function adKey(v){ return (v == null || v === 'null' || v === 0 || v === '0') ? '0' : String(v); }
function getCSRF(){ const m=document.querySelector('meta[name="csrf-token"]'); return m?m.content:''; }
// ⚠️ Не переопределяем $/$all. Используем dom$ / domAll, созданные ранее.

// поднимать карточку диалога вверх контейнера
function moveDialogToTop(userId, adId){
  const key = adKey(adId);
  document
    .querySelectorAll(`.dialog-card[data-user="${userId}"][data-ad="${key}"]`)
    .forEach((card) => card.parentElement?.prepend(card));
}

// снять подсветку unread+актив и убрать бейджи у карточки
function clearCardUnread(userId, adId){
  const key = adKey(adId);
  document
    .querySelectorAll(`.dialog-card[data-user="${userId}"][data-ad="${key}"]`)
    .forEach(el=>{
      el.classList.remove('unread','active');
      el.querySelector('.unread-badge')?.remove();
    });
}

// отметить активную карточку визуально (и снять у остальных)
function setActiveCard(userId, adId){
  (window.domAll || ((s,r)=>Array.from((r||document).querySelectorAll(s))))('.dialog-card')
    .forEach(el=>el.classList.remove('active'));
  const key = adKey(adId);
  document
    .querySelectorAll(`.dialog-card[data-user="${userId}"][data-ad="${key}"]`)
    .forEach((card) => card.classList.add('active'));
}

const activeChatState = {
  userId: null,
  adId: null,
  userName: '',
  userAvatar: '',
  isBusiness: false,
  blockedByMe: false,
  blockedByThem: false,
};

function updateChatBlockState() {
  const section = document.getElementById('account-messages');
  const form = document.getElementById('chatReplyForm');
  const status = document.getElementById('chatBlockStatus');
  const statusTitle = document.getElementById('chatBlockStatusTitle');
  const statusText = document.getElementById('chatBlockStatusText');
  const statusUnblock = document.getElementById('chatStatusUnblock');
  const blockButton = document.getElementById('chatBlockButton');
  const blockButtonLabel = blockButton?.querySelector('span');
  const blocked = activeChatState.blockedByMe || activeChatState.blockedByThem;

  if (form) form.hidden = blocked;
  if (status) status.hidden = !blocked;
  if (statusUnblock) statusUnblock.hidden = !activeChatState.blockedByMe;

  if (statusTitle) {
    statusTitle.textContent = activeChatState.blockedByMe
      ? (section?.dataset.blockedTitle || 'Пользователь заблокирован')
      : (section?.dataset.blockedByUser || 'Переписка ограничена');
  }
  if (statusText) {
    statusText.textContent = activeChatState.blockedByMe
      ? (section?.dataset.blockedHint || '')
      : (section?.dataset.blockedByUser || '');
  }
  if (blockButtonLabel) {
    blockButtonLabel.textContent = activeChatState.blockedByMe
      ? (section?.dataset.unblockLabel || 'Разблокировать')
      : (section?.dataset.blockLabel || 'Заблокировать');
  }
  blockButton?.classList.toggle('is-unblock', activeChatState.blockedByMe);
}

function closeChatActions() {
  const menu = document.getElementById('chatActionsMenu');
  const toggle = document.getElementById('chatActionsToggle');
  if (menu) menu.hidden = true;
  if (toggle) toggle.setAttribute('aria-expanded', 'false');
}

/* ==== Открыть чат ==== */
window.openChat = function (userId, adId, adTitle = '', adPhoto = '', userName = '', userAvatar = '', adUrl = '') {
  const chatBox   = (window.dom$||document.querySelector).call(document,'#chat-window');
  const msgList   = (window.dom$||document.querySelector).call(document,'#message-list');
  const workspace = document.querySelector('.account-messages-section .messages-workspace');
  const box       = (window.dom$||document.querySelector).call(document,'#chatMessages');
  const rField    = (window.dom$||document.querySelector).call(document,'#chatRecipientId');
  const adField   = (window.dom$||document.querySelector).call(document,'#chatAdId');
  const chatTitle = (window.dom$||document.querySelector).call(document,'#chatAdTitle');
  const chatPhoto = (window.dom$||document.querySelector).call(document,'#chatAdPhoto');
  const chatAdLink = document.getElementById('chatAdLink');
  const chatAdPhotoLink = document.getElementById('chatAdPhotoLink');
  const chatUserName = document.getElementById('chatUserName');
  const chatUserAvatar = document.getElementById('chatUserAvatar');
  const chatEmpty = document.getElementById('chat-empty');
  if (!chatBox || !box || !rField || !adField) return;

  chatBox.style.display = 'flex';
  workspace?.classList.add('is-chat-open');
  if (chatEmpty) chatEmpty.style.display = 'none';
  if (msgList && window.matchMedia('(max-width: 820px)').matches) msgList.style.display = 'none';

  rField.value  = userId;
  adField.value = (adId ?? '');
  activeChatState.userId = String(userId);
  activeChatState.adId = adId ?? null;
  activeChatState.userName = userName || '';
  activeChatState.userAvatar = userAvatar || '';
  activeChatState.blockedByMe = false;
  activeChatState.blockedByThem = false;

  chatTitle.textContent = adTitle || (chatTitle.dataset?.fallback || 'Без названия');
  [chatAdLink, chatAdPhotoLink].forEach((link) => {
    if (!link) return;
    if (adUrl) {
      link.href = adUrl;
      link.removeAttribute('aria-disabled');
    } else {
      link.href = '#';
      link.setAttribute('aria-disabled', 'true');
    }
  });
  if (chatUserName) chatUserName.textContent = userName || '';
  if (chatUserAvatar) chatUserAvatar.src = userAvatar || '/img/default.png';
  if (adPhoto) {
    chatPhoto.src = (adPhoto.startsWith('http') || adPhoto.startsWith('/')) ? adPhoto : '/storage/' + adPhoto;
    chatPhoto.style.display = 'inline-block';
  } else {
    chatPhoto.src = ''; chatPhoto.style.display = 'none';
  }

  // визуально: снять "непрочитано" и активировать карточку
  clearCardUnread(userId, adId);
  setActiveCard(userId, adId);

  // сервер: пометить прочитанным этот диалог
  const unreadVersion = ++unreadStateVersion;
  fetch('/messages/mark-read', {
    method: 'POST',
    headers: { 'X-CSRF-TOKEN': getCSRF(), 'Accept': 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify({ user_id: userId, ad_id: (adId ?? null) })
  })
  .then(async (response) => {
    const data = await response.json().catch(() => ({}));
    if (unreadVersion !== unreadStateVersion) return;
    if (Object.prototype.hasOwnProperty.call(data, 'count')) {
      applyUnreadBadgeCount(data.count);
    }
    await Promise.all([
      refreshUnreadBadge(unreadVersion),
      pollUnread(unreadVersion),
    ]);
  })
  .catch(()=>{});

  // загрузить переписку
  const query = `?ad_id=${encodeURIComponent(adId ?? '')}&_=${Date.now()}`;
  const primary  = `/messages/${encodeURIComponent(userId)}${query}`;
  const fallback = `/messages/chat/${encodeURIComponent(userId)}${query}`;
  const dialogRequestOptions = {
    cache: 'no-store',
    headers: { 'Accept': 'text/html' },
  };
  fetch(primary, dialogRequestOptions)
    .then(r => r.ok ? r.text() : fetch(fallback, dialogRequestOptions).then(rr => rr.ok ? rr.text() : Promise.reject()))
    .then(html => {
      box.innerHTML = html;
      const meta = box.querySelector('.chat-block-meta');
      activeChatState.blockedByMe = meta?.dataset.blockedByMe === '1';
      activeChatState.blockedByThem = meta?.dataset.blockedByThem === '1';
      updateChatBlockState();
      box.scrollTop = box.scrollHeight;
    })
    .catch(err => console.error('Ошибка загрузки сообщений:', err));
};

/* ==== Закрыть чат ==== */
window.closeChat = function () {
  const chatBox = (window.dom$||document.querySelector).call(document,'#chat-window');
  const msgList = (window.dom$||document.querySelector).call(document,'#message-list');
  const workspace = document.querySelector('.account-messages-section .messages-workspace');
  const chatEmpty = document.getElementById('chat-empty');
  if (chatBox) chatBox.style.display = 'none';
  workspace?.classList.remove('is-chat-open');
  if (msgList) msgList.style.display = '';
  if (chatEmpty && !window.matchMedia('(max-width: 820px)').matches) chatEmpty.style.display = '';
  const box = (window.dom$||document.querySelector).call(document,'#chatMessages');
  if (box) box.innerHTML = '';
  if (typeof window.resetChatComposer === 'function') window.resetChatComposer();
  activeChatState.userId = null;
  activeChatState.adId = null;
  activeChatState.blockedByMe = false;
  activeChatState.blockedByThem = false;
  activeChatState.userAvatar = '';
  activeChatState.isBusiness = false;
  closeChatActions();
  (window.domAll || ((s,r)=>Array.from((r||document).querySelectorAll(s))))('.dialog-card')
    .forEach(el=>el.classList.remove('active'));
};

/* ==== Отправка сообщения ==== */
(() => {
  const form = (window.dom$||document.querySelector).call(document,'#chatReplyForm');
  if (!form) return;
  const textarea = form.querySelector('textarea[name="content"]');
  const fileInput = form.querySelector('#chatImages');
  const preview = form.querySelector('#chatAttachmentPreview');
  const fileCount = form.querySelector('#chatAttachmentCount');
  const uploadStatus = form.querySelector('#chatUploadStatus');
  const submitButton = form.querySelector('button[type="submit"]');
  const maxFiles = Number(form.dataset.maxFiles || 10);
  let selectedFiles = [];
  let previewUrls = [];
  let uploadBatchToken = '';

  function resizeTextarea() {
    if (!textarea) return;
    textarea.style.height = 'auto';
    textarea.style.height = `${Math.min(textarea.scrollHeight, 96)}px`;
  }

  function syncFileInput() {
    if (!fileInput || typeof DataTransfer === 'undefined') return;
    const transfer = new DataTransfer();
    selectedFiles.forEach((file) => transfer.items.add(file));
    fileInput.files = transfer.files;
  }

  function clearPreviewUrls() {
    previewUrls.forEach((url) => URL.revokeObjectURL(url));
    previewUrls = [];
  }

  function renderAttachments() {
    if (!preview) return;
    clearPreviewUrls();
    preview.replaceChildren();

    selectedFiles.forEach((file, index) => {
      const url = URL.createObjectURL(file);
      previewUrls.push(url);

      const item = document.createElement('div');
      item.className = 'chat-attachment-item';

      const image = document.createElement('img');
      image.src = url;
      image.alt = file.name;

      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'chat-attachment-remove';
      remove.setAttribute('aria-label', form.dataset.removePhoto || 'Remove');
      remove.innerHTML = '<i class="fas fa-times" aria-hidden="true"></i>';
      remove.addEventListener('click', () => {
        selectedFiles.splice(index, 1);
        syncFileInput();
        renderAttachments();
      });

      item.append(image, remove);
      preview.appendChild(item);
    });

    preview.hidden = selectedFiles.length === 0;
    if (fileCount) {
      fileCount.textContent = selectedFiles.length ? `${selectedFiles.length}/${maxFiles}` : '';
      fileCount.hidden = selectedFiles.length === 0;
    }
  }

  function resetComposer() {
    selectedFiles = [];
    if (fileInput) fileInput.value = '';
    if (textarea) textarea.value = '';
    clearPreviewUrls();
    if (preview) {
      preview.replaceChildren();
      preview.hidden = true;
    }
    if (fileCount) {
      fileCount.textContent = '';
      fileCount.hidden = true;
    }
    if (uploadStatus) {
      uploadStatus.textContent = '';
      uploadStatus.hidden = true;
    }
    uploadBatchToken = '';
    resizeTextarea();
  }

  function createBatchToken() {
    if (window.crypto?.randomUUID) return window.crypto.randomUUID();
    return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  }

  function normalizeUploadHeaders(headers) {
    const normalized = {};
    Object.entries(headers || {}).forEach(([key, value]) => {
      const lower = String(key || '').toLowerCase();
      if (lower === 'host' || lower === 'content-length') return;
      normalized[key] = Array.isArray(value) ? value[0] : value;
    });
    return normalized;
  }

  function loadUploadImage(file) {
    return new Promise((resolve, reject) => {
      const url = URL.createObjectURL(file);
      const image = new Image();
      image.onload = () => {
        URL.revokeObjectURL(url);
        resolve(image);
      };
      image.onerror = () => {
        URL.revokeObjectURL(url);
        reject(new Error('Image decode failed'));
      };
      image.src = url;
    });
  }

  async function prepareMessagePhoto(file) {
    const type = String(file.type || '').toLowerCase();
    if (type === 'image/gif' || !/^image\/(jpeg|png|webp)$/.test(type)) return file;

    try {
      const image = await loadUploadImage(file);
      const maxSide = 1600;
      const originalWidth = image.naturalWidth || image.width;
      const originalHeight = image.naturalHeight || image.height;
      const ratio = Math.min(1, maxSide / Math.max(originalWidth, originalHeight));
      const canvas = document.createElement('canvas');
      canvas.width = Math.max(1, Math.round(originalWidth * ratio));
      canvas.height = Math.max(1, Math.round(originalHeight * ratio));
      const context = canvas.getContext('2d', {alpha: false});
      if (!context) return file;
      context.drawImage(image, 0, 0, canvas.width, canvas.height);
      const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', 0.82));
      if (!blob || blob.size >= file.size) return file;
      return new File(
        [blob],
        `${(file.name || 'photo').replace(/\.[^.]+$/, '')}.jpg`,
        {type: 'image/jpeg', lastModified: Date.now()}
      );
    } catch {
      return file;
    }
  }

  async function uploadMessagePhoto(file, batchToken) {
    const prepared = await prepareMessagePhoto(file);
    const presignResponse = await fetch('/messages/attachments/presign', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': getCSRF(),
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        name: prepared.name,
        type: prepared.type || 'image/jpeg',
        size: prepared.size,
        batch_token: batchToken,
      }),
    });
    const presigned = await presignResponse.json().catch(() => ({}));
    if (!presignResponse.ok || !presigned.ok) {
      const error = new Error(presigned.message || `Presign failed (${presignResponse.status})`);
      error.allowFallback = presignResponse.status === 409 && presigned.fallback === true;
      throw error;
    }

    const headers = normalizeUploadHeaders(presigned.headers);
    if (!headers['Content-Type'] && !headers['content-type'] && prepared.type) {
      headers['Content-Type'] = prepared.type;
    }
    const uploadResponse = await fetch(presigned.url, {
      method: 'PUT',
      headers,
      body: prepared,
    });
    if (!uploadResponse.ok) {
      throw new Error(`Cloud upload failed (${uploadResponse.status})`);
    }

    return {temp_id: presigned.temp_id};
  }

  async function uploadMessagePhotos(files, batchToken) {
    const output = new Array(files.length);
    let cursor = 0;
    const workers = Array.from({length: Math.min(3, files.length)}, async () => {
      while (cursor < files.length) {
        const index = cursor++;
        output[index] = await uploadMessagePhoto(files[index], batchToken);
        if (uploadStatus) {
          const completed = output.filter(Boolean).length;
          uploadStatus.textContent = `${form.dataset.uploading || 'Uploading photos…'} ${completed}/${files.length}`;
        }
      }
    });
    await Promise.all(workers);
    return output;
  }

  function appendTodaySeparator(box, createdAt) {
    const dateKey = createdAt.toISOString().slice(0, 10);
    const messages = box.querySelectorAll('.chat-message-item');
    const lastMessage = messages[messages.length - 1];
    if (lastMessage?.dataset.messageDate === dateKey) return;
    const separator = document.createElement('div');
    separator.className = 'chat-date-separator';
    const label = document.createElement('span');
    label.textContent = new Intl.DateTimeFormat(undefined, {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    }).format(createdAt);
    separator.appendChild(label);
    box.appendChild(separator);
  }

  function createSentMessage(message) {
    const item = document.createElement('div');
    item.className = 'chat-message-item chat-message-sent';
    const createdAt = message?.created_at ? new Date(message.created_at) : new Date();
    item.dataset.messageDate = createdAt.toISOString().slice(0, 10);

    const stack = document.createElement('div');
    stack.className = 'chat-message-stack';
    const content = document.createElement('div');
    content.className = 'chat-message-content';
    const messageText = String(message?.content || '').trim();
    const section = document.getElementById('account-messages');

    const avatar = document.createElement('img');
    avatar.className = `chat-message-avatar ${
      section?.dataset.currentUserBusiness === '1'
        ? 'avatar-shape--business'
        : 'avatar-shape--person'
    }`;
    avatar.src = section?.dataset.currentUserAvatar || '/img/default.png';
    avatar.alt = section?.dataset.currentUserName || '';
    avatar.addEventListener('error', () => {
      avatar.src = '/img/default.png';
    }, {once: true});

    if (messageText) {
      const bubble = document.createElement('div');
      bubble.className = 'chat-message-bubble';
      const text = document.createElement('span');
      text.className = 'chat-message-text';
      text.textContent = messageText;
      const time = document.createElement('time');
      time.className = 'chat-message-time';
      time.dateTime = createdAt.toISOString();
      time.textContent = createdAt.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
      });
      bubble.append(text, time);
      content.appendChild(bubble);
    }

    const attachments = Array.isArray(message?.attachments) ? message.attachments : [];
    if (attachments.length) {
      const media = document.createElement('div');
      media.className = 'chat-message-media';
      media.dataset.count = String(Math.min(attachments.length, 4));

      attachments.forEach((attachment) => {
        if (!attachment?.url) return;
        const link = document.createElement('a');
        link.className = 'chat-message-photo';
        link.href = attachment.url;
        link.target = '_blank';
        link.rel = 'noopener';

        const image = document.createElement('img');
        image.src = attachment.url;
        image.alt = attachment.original_name || '';
        image.loading = 'lazy';
        link.appendChild(image);
        media.appendChild(link);
      });
      content.appendChild(media);
    }

    if (!messageText) {
      const time = document.createElement('time');
      time.className = 'chat-message-time chat-message-time--standalone';
      time.dateTime = createdAt.toISOString();
      time.textContent = createdAt.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
      });
      content.appendChild(time);
    }

    stack.appendChild(content);
    item.append(avatar, stack);
    return item;
  }

  document.addEventListener('error', (event) => {
    const image = event.target;
    if (!(image instanceof HTMLImageElement) || !image.matches('.chat-message-photo img')) {
      return;
    }

    const link = image.closest('.chat-message-photo');
    const media = link?.closest('.chat-message-media');
    const item = media?.closest('.chat-message-item');
    link?.remove();
    if (media && !media.querySelector('.chat-message-photo')) {
      media.remove();
      if (item && !item.querySelector('.chat-message-text')) {
        item.remove();
      }
    }
  }, true);

  window.resetChatComposer = resetComposer;

  fileInput?.addEventListener('change', () => {
    const incoming = Array.from(fileInput.files || []);
    if (!incoming.length) return;

    if (selectedFiles.length + incoming.length > maxFiles) {
      alert(form.dataset.limitMessage || `Maximum ${maxFiles} files`);
      fileInput.value = '';
      syncFileInput();
      return;
    }

    selectedFiles = selectedFiles.concat(incoming);
    syncFileInput();
    renderAttachments();
  });

  textarea?.addEventListener('input', resizeTextarea);
  textarea?.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' && !event.shiftKey && !event.isComposing) {
      event.preventDefault();
      form.requestSubmit();
    }
  });
  resizeTextarea();

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (!String(textarea?.value || '').trim() && selectedFiles.length === 0) {
      textarea?.focus();
      return;
    }

    if (submitButton) submitButton.disabled = true;
    if (uploadStatus) {
      uploadStatus.textContent = selectedFiles.length ? (form.dataset.uploading || 'Uploading photos…') : '';
      uploadStatus.hidden = selectedFiles.length === 0;
    }

    try {
      let directUploads = [];
      let useDirectUpload = selectedFiles.length > 0;
      if (useDirectUpload) {
        uploadBatchToken = createBatchToken();
        try {
          directUploads = await uploadMessagePhotos(selectedFiles, uploadBatchToken);
        } catch (uploadError) {
          if (!uploadError.allowFallback) throw uploadError;
          useDirectUpload = false;
          directUploads = [];
        }
      }

      syncFileInput();
      const formData = new FormData(form);
      if (useDirectUpload) {
        formData.delete('images[]');
        formData.delete('images');
        formData.append('message_upload_batch', uploadBatchToken);
        directUploads.forEach((upload, index) => {
          formData.append(`uploaded_attachments[${index}][temp_id]`, upload.temp_id);
        });
      }

      const res  = await fetch('/messages', { method:'POST', headers:{'X-CSRF-TOKEN': getCSRF()}, body: formData });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || !data.success) {
        const validationError = data.errors
          ? Object.values(data.errors).flat().find(Boolean)
          : null;
        alert(validationError || data.error || data.message || form.dataset.sendError || 'Ошибка отправки');
        return;
      }

      const box = (window.dom$||document.querySelector).call(document,'#chatMessages');
      if (box) {
        appendTodaySeparator(box, data.message?.created_at ? new Date(data.message.created_at) : new Date());
        box.appendChild(createSentMessage(data.message));
        box.scrollTop = box.scrollHeight;
      }
      resetComposer();

      // после исходящего — логично поднять диалог вверх
      moveDialogToTop(
        (window.dom$||document.querySelector).call(document,'#chatRecipientId').value,
        (window.dom$||document.querySelector).call(document,'#chatAdId').value
      );
    } catch (e2) {
      console.error(e2);
      alert(e2.message || form.dataset.sendError || 'Ошибка при отправке');
    } finally {
      if (submitButton) submitButton.disabled = false;
    }
  });
})();

/* ==== Переключение вкладок ==== */
window.switchTab = function(tab){
  const allowed = ['all', 'inbox', 'sent'];
  const activeTab = allowed.includes(tab) ? tab : 'all';
  document.querySelectorAll('[data-tab-panel]').forEach((panel) => {
    const active = panel.dataset.tabPanel === activeTab;
    panel.hidden = !active;
    panel.style.display = active ? '' : 'none';
  });
  document.querySelectorAll('.chat-tab').forEach((button) => {
    const active = button.dataset.tab === activeTab;
    button.classList.toggle('active', active);
    button.setAttribute('aria-selected', String(active));
  });
};

/* ==== Бейдж в шапке ==== */
let unreadStateVersion = 0;

async function refreshUnreadBadge(version = unreadStateVersion){
  try{
    const r = await fetch(`/messages/unread-count?_=${Date.now()}`,{
      cache: 'no-store',
      headers:{Accept:'application/json'}
    });
    if(!r.ok) return;
    const {count} = await r.json();
    if (version !== unreadStateVersion) return;
    applyUnreadBadgeCount(count);
  }catch{}
}

function applyUnreadBadgeCount(count){
  const total = Number(count || 0);
  const badges = Array.from(document.querySelectorAll('[data-message-unread-counter]'));
  if (!badges.length) return;
  badges.forEach((badge) => {
    if (total > 0){
      badge.textContent = String(total);
      badge.classList.remove('hidden');
      badge.style.display = '';
    } else {
      badge.textContent = '';
      badge.classList.add('hidden');
      badge.style.display = 'none';
    }
  });
}

async function refreshReviewBadge(){
  try{
    const response = await fetch(`/reviews/unread-count?_=${Date.now()}`, {
      cache: 'no-store',
      headers: {Accept: 'application/json'}
    });
    if (!response.ok) return;
    const {count} = await response.json();
    applyReviewBadgeCount(count);
  }catch{}
}

function applyReviewBadgeCount(count){
  const total = Number(count || 0);
  document.querySelectorAll('[data-review-unread-counter]').forEach((badge) => {
    if (total > 0) {
      badge.textContent = total > 99 ? '99+' : String(total);
      badge.classList.remove('hidden');
      badge.style.display = '';
    } else {
      badge.textContent = '';
      badge.classList.add('hidden');
      badge.style.display = 'none';
    }
  });
}

async function markReviewsAsRead(){
  if (!document.querySelector('[data-review-unread-counter]')) return;

  try{
    const response = await fetch('/reviews/mark-read', {
      method: 'POST',
      headers: {
        'X-CSRF-TOKEN': getCSRF(),
        'Accept': 'application/json'
      }
    });
    if (response.ok) applyReviewBadgeCount(0);
  }catch{}
}

function markReviewsReadIfOpen(){
  if (window.location.hash === '#account-reviews') {
    markReviewsAsRead();
  }
}

/* ==== Подсветка/переупорядочивание по /messages/unread-map ==== */
function applyUnreadMap(items){
  let totalUnread = 0;
  const accountDialogList = document.querySelector('.account-messages-section .message-list');

  // снять у всех
  (window.domAll || ((s,r)=>Array.from((r||document).querySelectorAll(s))))('.dialog-card').forEach(el=>{
    el.classList.remove('unread');
    el.querySelector('.unread-badge')?.remove();
  });

  // расставить только если cnt > 0 и поднять вверх
  (items||[]).forEach(row=>{
    const u = row.user_id;
    const k = adKey(row.ad_id_norm);
    const cnt = Number(row.cnt || 0);
    const matchingCards = Array.from(
      document.querySelectorAll(`.dialog-card[data-user="${u}"][data-ad="${k}"]`)
    );
    if (!accountDialogList || matchingCards.length > 0) {
      totalUnread += Math.max(0, cnt);
    }
    if (cnt > 0){
      matchingCards.forEach(el=>{
        el.classList.add('unread');
        const nameRow = el.querySelector('.dialog-name-row');
        if (nameRow){
          nameRow.querySelector('.unread-badge')?.remove();
          const b = document.createElement('span');
          b.className = 'unread-badge';
          b.textContent = cnt > 99 ? '99+' : String(cnt);
          nameRow.appendChild(b);
        }
        // на входящих диалогах поднимаем вверх
        if (el.parentElement?.id === 'inbox-messages') el.parentElement.prepend(el);
      });
    }
  });

  applyUnreadBadgeCount(totalUnread);
}
async function pollUnread(version = unreadStateVersion){
  try{
    const r = await fetch(`/messages/unread-map?_=${Date.now()}`,{
      cache: 'no-store',
      headers:{Accept:'application/json'}
    });
    if(!r.ok) return;
    const data = await r.json();
    if (version !== unreadStateVersion) return;
    applyUnreadMap(Array.isArray(data.items)?data.items:[]);
  }catch{}
}
setInterval(pollUnread, 20000);
setInterval(refreshReviewBadge, 20000);
document.addEventListener('visibilitychange', ()=>{ if(!document.hidden) pollUnread(); });
document.addEventListener('visibilitychange', ()=>{ if(!document.hidden) refreshReviewBadge(); });
window.addEventListener('load', ()=>{
  pollUnread();
  refreshUnreadBadge();
  refreshReviewBadge();
  markReviewsReadIfOpen();
});
window.addEventListener('hashchange', markReviewsReadIfOpen);
document.addEventListener('click', (event) => {
  const target = event.target instanceof Element ? event.target : null;
  const reviewTarget = target?.closest(
    'a[href*="#account-reviews"], .account-nav-item[data-target="account-reviews"]'
  );
  if (reviewTarget) markReviewsAsRead();
});

/* ==== Поиск, действия и блокировка в переписке ==== */
(() => {
  const search = document.getElementById('dialogSearch');
  const actionsToggle = document.getElementById('chatActionsToggle');
  const actionsMenu = document.getElementById('chatActionsMenu');
  const blockButton = document.getElementById('chatBlockButton');
  const statusUnblock = document.getElementById('chatStatusUnblock');
  const deleteButton = document.getElementById('chatDeleteButton');
  const blockedSection = document.getElementById('account-blocked');

  function updateBlockedCount() {
    const count = document.querySelectorAll('.blocked-user-row').length;
    const badge = document.querySelector('.blocked-users-count');
    if (badge) badge.textContent = String(count);
  }

  function ensureBlockedEmptyState() {
    const list = document.querySelector('.blocked-users-list');
    if (!list || list.querySelector('.blocked-user-row') || list.querySelector('.blocked-users-empty')) return;

    const empty = document.createElement('div');
    empty.className = 'blocked-users-empty';
    const icon = document.createElement('span');
    icon.innerHTML = '<i class="fas fa-user-shield"></i>';
    const title = document.createElement('h3');
    title.textContent = blockedSection?.dataset.emptyLabel || '';
    empty.append(icon, title);
    list.appendChild(empty);
  }

  function addBlockedUserRow() {
    const list = document.querySelector('.blocked-users-list');
    if (!list || !activeChatState.userId) return;

    list.querySelector('.blocked-users-empty')?.remove();
    if (list.querySelector(`[data-blocked-user="${activeChatState.userId}"]`)) return;

    const row = document.createElement('article');
    row.className = 'blocked-user-row';
    row.dataset.blockedUser = activeChatState.userId;

    const avatar = document.createElement('img');
    avatar.src = activeChatState.userAvatar || '/img/default.png';
    avatar.alt = activeChatState.userName || '';
    avatar.className = activeChatState.isBusiness
      ? 'avatar-shape--business'
      : 'avatar-shape--person';

    const copy = document.createElement('div');
    copy.className = 'blocked-user-row__copy';
    const name = document.createElement('strong');
    name.textContent = activeChatState.userName || '';
    const date = document.createElement('span');
    date.textContent = new Date().toLocaleString();
    copy.append(name, date);

    const action = document.createElement('button');
    action.type = 'button';
    action.dataset.inlineUnblock = activeChatState.userId;
    action.innerHTML = '<i class="fas fa-user-check"></i>';
    const actionText = document.createElement('span');
    actionText.textContent = blockedSection?.dataset.unblockLabel || '';
    action.appendChild(actionText);

    row.append(avatar, copy, action);
    list.prepend(row);
    updateBlockedCount();
  }

  function removeBlockedUserRow(userId) {
    document.querySelector(`[data-blocked-user="${userId}"]`)?.remove();
    updateBlockedCount();
    ensureBlockedEmptyState();
  }

  search?.addEventListener('input', () => {
    const query = search.value.trim().toLocaleLowerCase();
    document.querySelectorAll('.dialog-card').forEach(card => {
      card.hidden = query !== '' && !card.textContent.toLocaleLowerCase().includes(query);
    });
  });

  actionsToggle?.addEventListener('click', (event) => {
    event.stopPropagation();
    if (!actionsMenu) return;
    actionsMenu.hidden = !actionsMenu.hidden;
    actionsToggle.setAttribute('aria-expanded', String(!actionsMenu.hidden));
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('.chat-actions')) closeChatActions();
  });

  async function toggleBlock(forceUnblock = false) {
    if (!activeChatState.userId) return;

    const shouldUnblock = forceUnblock || activeChatState.blockedByMe;
    const response = await fetch(`/users/${encodeURIComponent(activeChatState.userId)}/block`, {
      method: shouldUnblock ? 'DELETE' : 'POST',
      headers: {
        'X-CSRF-TOKEN': getCSRF(),
        'Accept': 'application/json',
      },
    });
    const data = await response.json().catch(() => ({}));

    if (!response.ok || !data.success) {
      alert(data.message || data.error || 'Ошибка');
      return;
    }

    activeChatState.blockedByMe = !shouldUnblock;
    if (activeChatState.blockedByMe) addBlockedUserRow();
    else removeBlockedUserRow(activeChatState.userId);
    updateChatBlockState();
    closeChatActions();

    document
      .querySelectorAll(`.dialog-card[data-user="${activeChatState.userId}"]`)
      .forEach(card => card.classList.toggle('is-blocked', activeChatState.blockedByMe));
  }

  blockButton?.addEventListener('click', () => toggleBlock());
  statusUnblock?.addEventListener('click', () => toggleBlock(true));

  deleteButton?.addEventListener('click', () => {
    if (!activeChatState.userId) return;
    closeChatActions();
    if (typeof window.showDialogDelete === 'function') {
      window.showDialogDelete(
        activeChatState.userId,
        activeChatState.adId,
        activeChatState.userName
      );
    }
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-inline-unblock]');
    if (!button) return;

    const userId = button.dataset.inlineUnblock;
    button.disabled = true;
    try {
      const response = await fetch(`/users/${encodeURIComponent(userId)}/block`, {
        method: 'DELETE',
        headers: {
          'X-CSRF-TOKEN': getCSRF(),
          'Accept': 'application/json',
        },
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok || !data.success) throw new Error(data.message || 'Ошибка');

      removeBlockedUserRow(userId);
      if (String(activeChatState.userId) === String(userId)) {
        activeChatState.blockedByMe = false;
        updateChatBlockState();
      }
    } catch (error) {
      alert(error.message || 'Ошибка');
      button.disabled = false;
    }
  });
})();

/* ==== Делегирование кликов (без inline-скриптов в разметке) ==== */
document.addEventListener('click', (e) => {
  // крестик удаления
  const delBtn = e.target.closest('.dialog-delete');
  if (delBtn){
    e.stopPropagation();
    const card = delBtn.closest('.dialog-card');
    if (!card) return;
    const userId = card.dataset.user;
    const adId   = card.dataset.ad === '0' ? null : card.dataset.ad;
    const name   = card.dataset.userName || (card.querySelector('.dialog-name')?.firstChild?.textContent || '').trim();
    if (typeof window.showDialogDelete === 'function'){
      window.showDialogDelete(userId, adId, name);
    }
    return;
  }

  // открытие чата
  const card = e.target.closest('.dialog-card');
  if (!card) return;
  const userId  = card.dataset.user;
  const adId    = card.dataset.ad === '0' ? null : card.dataset.ad;
  const adTitle = (card.querySelector('.dialog-ad')?.textContent || '').trim();
  const adPhoto = card.getAttribute('data-ad-photo') || '';
  const userName = card.getAttribute('data-user-name') || '';
  const userAvatar = card.getAttribute('data-user-avatar') || '';
  const adUrl = card.getAttribute('data-ad-url') || '';
  activeChatState.isBusiness = card.getAttribute('data-user-business') === '1';
  window.openChat(userId, adId, adTitle, adPhoto, userName, userAvatar, adUrl);
});

/* ==== Удаление диалога (модалка) ==== */
(() => {
  const state = { userId:null, adId:null };
  const $id = id => document.getElementById(id);

  function show(userId, adId = null, displayName = ''){
    state.userId = userId; state.adId = adId;
    const o = $id('dialogDelOverlay'), m = $id('dialogDelModal'), n = $id('dialogDelName');
    if(n) n.textContent = displayName || '';
    if(o) {
      o.classList.remove('hidden');
      o.style.display = 'block';
    }
    if(m) {
      m.classList.remove('hidden');
      m.style.display = 'block';
    }
  }
  function hide(){
    const o = $id('dialogDelOverlay'), m = $id('dialogDelModal');
    if(o) {
      o.style.display = 'none';
      o.classList.add('hidden');
    }
    if(m) {
      m.style.display = 'none';
      m.classList.add('hidden');
    }
  }
  async function confirmDelete(){
    const confirmButton = $id('dialogDelConfirmBtn');
    if (confirmButton?.disabled) return;
    if (confirmButton) confirmButton.disabled = true;

    try{
      const adIdNorm = (state.adId==null || state.adId==='0') ? null : state.adId;
      const r = await fetch('/messages/delete-dialog',{
        method:'POST',
        headers:{'Content-Type':'application/json','X-CSRF-TOKEN':getCSRF(),'Accept':'application/json'},
        body: JSON.stringify({user_id: state.userId, ad_id: adIdNorm})
      });
      const data = await r.json();
      if(!data.success){ alert(data.error || 'Ошибка удаления'); return; }
      const unreadVersion = ++unreadStateVersion;

      // удалить ВСЕ карточки этого диалога (если встречаются в обоих списках)
      const key = adKey(adIdNorm);
      (window.domAll || ((s,r)=>Array.from((r||document).querySelectorAll(s))))(`#dialog-${state.userId}-${key}, .dialog-card[data-user="${state.userId}"][data-ad="${key}"]`)
        .forEach(card => {
          card.classList.remove('unread');
          card.querySelector('.unread-badge')?.remove();
          card.classList.add('fade-out');
          setTimeout(() => card.remove(), 180);
        });

      const activeRecipient = ($id('chatRecipientId')?.value ?? '').toString();
      const activeAdIdRaw = ($id('chatAdId')?.value ?? '').toString();
      const activeAdKey = adKey(activeAdIdRaw === '' ? null : activeAdIdRaw);
      if (activeRecipient === String(state.userId) && activeAdKey === key && typeof window.closeChat === 'function'){
        window.closeChat();
      }

      hide();
      if (Object.prototype.hasOwnProperty.call(data, 'count')) {
        applyUnreadBadgeCount(data.count);
      } else {
        await refreshUnreadBadge(unreadVersion);
      }
      await Promise.all([
        pollUnread(unreadVersion),
        refreshUnreadBadge(unreadVersion),
      ]);
    }catch(e){
      console.error(e);
      alert('Ошибка сети при удалении');
    } finally {
      if (confirmButton) confirmButton.disabled = false;
    }
  }
  function bind(){
    $id('dialogDelOverlay')?.addEventListener('click', hide);
    document.addEventListener('keydown', e=>{ if(e.key==='Escape') hide(); });
    $id('dialogDelConfirmBtn')?.addEventListener('click', confirmDelete);
    window.showDialogDelete = show;
    window.hideDialogDelete = hide;
  }
  if (document.readyState === 'loading') window.addEventListener('load', bind, {once:true});
  else bind();
})();


//===========================================================================


// ✅ Открытие модалки "Написать сообщение"
document.querySelectorAll(".open-message-modal").forEach(btn => {
  btn.addEventListener("click", () => {
      const modal = document.getElementById("messageModal");
      const overlay = document.getElementById("messageModalOverlay");

      // Заполняем данные о получателе
      document.getElementById("recipient_id").value = btn.dataset.userId;
      document.getElementById("ad_id").value = btn.dataset.adId;
      document.getElementById("recipient-name").textContent = btn.dataset.userName;
      document.getElementById("recipient-avatar").src = btn.dataset.userAvatar;

      modal.classList.remove("hidden");
      modal.style.display = "block";
      if (overlay) overlay.style.display = "block";
      document.body.classList.add('no-scroll');

      // Разблокируем textarea при открытии
      const textarea = modal.querySelector("textarea");
      if (textarea) textarea.removeAttribute("disabled");
  });
});

// ❌ Закрытие модалки сообщения
const messageModal = document.getElementById("messageModal");
const messageOverlay = document.getElementById("messageModalOverlay");
const closeMessageBtn = document.getElementById("messageModalClose");

if (messageModal && messageOverlay) {
  const closeMessageModal = () => {
      messageModal.classList.add("hidden");
      messageModal.style.display = "none";
      messageOverlay.style.display = "none";
      document.body.classList.remove('no-scroll');
  };

  if (closeMessageBtn) {
      closeMessageBtn.addEventListener("click", closeMessageModal);
  }

  messageOverlay.addEventListener("click", closeMessageModal);
}

// ✅ Отправка формы сообщения
const messageForm = document.getElementById("sendMessageForm");
if (messageForm) {
  messageForm.addEventListener("submit", async (e) => {
    e.preventDefault();
    const token = document.querySelector('meta[name="csrf-token"]').content;

    try {
      const response = await fetch('/messages', {
        method: 'POST',
        headers: {
          'X-CSRF-TOKEN': token,
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          recipient_id: messageForm.recipient_id.value,
          ad_id: messageForm.ad_id.value,
          content: messageForm.content.value
        })
      });

      const result = await response.json();

      if (response.ok && result.success) {
        showSuccessToast("✅ Сообщение отправлено!");
        messageForm.content.value = '';
        messageModal.classList.add("hidden");
        messageModal.style.display = "none";
        if (messageOverlay) messageOverlay.style.display = "none";
        document.body.classList.remove('no-scroll');
      } else if (response.status === 401) {
        showErrorToast("⚠️ Чтобы отправить сообщение, войдите или зарегистрируйтесь.");
      } else {
        showErrorToast(result.message || result.error || "❌ Что-то пошло не так");
      }
    } catch (err) {
      console.error("Ошибка:", err);
      showErrorToast("❌ Ошибка при отправке");
    }
  });
}


// ✅ Toast функция (вставь до закрывающего </script> в app.js или layout)
function showSuccessToast(message) {
  showToast(message, true);
}

function showErrorToast(message) {
  showToast(message, false);
}

function showToast(message, isSuccess = true) {
  let toast = document.getElementById('message-toast');
  if (!toast) {
      toast = document.createElement('div');
      toast.id = 'message-toast';
      toast.className = 'toast-box';
      document.body.appendChild(toast);
  }

  toast.className = 'toast-box ' + (isSuccess ? 'toast-success' : 'toast-error');
  toast.innerHTML = `<i class="fas ${isSuccess ? 'fa-check-circle' : 'fa-exclamation-circle'}"></i> ${message}`;

  toast.classList.add('show');

  setTimeout(() => {
      toast.classList.remove('show');
  }, 3000);
}

// 📞 Открытие модалки "Позвонить"
// 📞 Открытие/закрытие модалки (без автозвонков)
const callModal    = document.getElementById("callModal");
const callOverlay  = document.getElementById("callModalOverlay");
const callBtn      = document.getElementById("openCallModal");
const callCloseBtn = document.getElementById("callModalClose");

if (callModal && callOverlay && callBtn) {
  callBtn.addEventListener("click", () => {
    callModal.classList.remove("hidden");
    callModal.style.display = "block";
    callOverlay.style.display = "block";
    document.body.classList.add('no-scroll');
  });

  const close = () => {
    callModal.classList.add("hidden");
    callModal.style.display = "none";
    callOverlay.style.display = "none";
    document.body.classList.remove('no-scroll');
  };

  callCloseBtn?.addEventListener("click", close);
  callOverlay.addEventListener("click", close);

  // Не обязательно, но удобно: скрывать модалку после тапа по ссылке
  callModal.addEventListener('click', (e) => {
    if (e.target.closest('.phone-block[href^="tel:"]')) {
      setTimeout(close, 300);
    }
  });
}


//-----------------------------------------------------------------------------------------------------------------

// Удаление объявления
// ✅ Убедись, что этот код находится вне любых import или других обёрток,
// ✅ Удаление объявления (объявляем один раз вне блока)

if (typeof window.selectedAdId === 'undefined') {
  window.selectedAdId = null;
}

function getAdDeleteModalElements() {
  const root = document.documentElement;
  const modalTitleText = root.dataset.deleteModalTitle || 'Delete';
  const modalCancelText = root.dataset.deleteModalCancel || 'Cancel';
  const modalConfirmText = root.dataset.deleteModalConfirm || 'Delete';

  let overlay = document.getElementById('deleteModalOverlay')
    || document.getElementById('globalDeleteModalOverlay');
  let modal = document.getElementById('deleteConfirmModal')
    || document.getElementById('globalDeleteConfirmModal');
  let title = document.getElementById('deleteAdTitle')
    || document.getElementById('globalDeleteAdTitle');

  if (!overlay || !modal || !title) {
    overlay = document.createElement('div');
    overlay.id = 'globalDeleteModalOverlay';
    overlay.style.cssText = [
      'display:none',
      'position:fixed',
      'inset:0',
      'background:rgba(15,23,42,0.58)',
      'backdrop-filter:blur(2px)',
      'z-index:11998'
    ].join(';');

    modal = document.createElement('div');
    modal.id = 'globalDeleteConfirmModal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'globalDeleteConfirmTitle');
    modal.style.cssText = [
      'display:none',
      'position:fixed',
      'top:50%',
      'left:50%',
      'transform:translate(-50%, -50%)',
      'width:min(420px, calc(100vw - 32px))',
      'max-width:calc(100vw - 32px)',
      'background:#fff',
      'border-radius:16px',
      'padding:24px 18px',
      'box-shadow:0 20px 60px rgba(0,0,0,0.28)',
      'z-index:11999',
      'text-align:center'
    ].join(';');

    modal.innerHTML = `
      <div class="modal-icon"><i class="fas fa-trash-alt"></i></div>
      <h3 id="globalDeleteConfirmTitle">${modalTitleText}</h3>
      <p id="globalDeleteAdTitle" class="modal-ad-title"></p>
      <div class="modal-actions">
        <button type="button" class="modal-btn cancel-btn" id="globalDeleteCancelBtn">${modalCancelText}</button>
        <button type="button" class="modal-btn delete-btn" id="globalDeleteAdConfirmBtn"><i class="fas fa-trash"></i> ${modalConfirmText}</button>
      </div>
    `;

    document.body.appendChild(overlay);
    document.body.appendChild(modal);

    title = document.getElementById('globalDeleteAdTitle');
  }

  return {
    overlay,
    modal,
    title,
  };
}

/** Кнопка подтверждения удаления объявления в модалке */
function getAdDeleteConfirmButton(ev) {
  const t = ev && ev.currentTarget;
  if (t instanceof HTMLButtonElement) return t;
  return (
    document.getElementById('globalDeleteAdConfirmBtn')
    || document.getElementById('deleteAdConfirmBtn')
    || document.querySelector('#deleteConfirmModal button[onclick*="confirmDelete"]')
    || null
  );
}

function resetAdDeleteConfirmButtonState() {
  const btn = getAdDeleteConfirmButton();
  if (btn) btn.disabled = false;

  const deactivateBtn = document.getElementById('deactivateAdConfirmBtn');
  if (deactivateBtn) deactivateBtn.disabled = false;
}

function attachAdDeleteModalListeners() {
  const { overlay, modal } = getAdDeleteModalElements();

  if (overlay && !overlay.dataset.deleteModalBound) {
    overlay.addEventListener('click', () => window.closeDeleteModal());
    overlay.dataset.deleteModalBound = '1';
  }

  if (modal && !modal.dataset.deleteModalBound) {
    document.getElementById('globalDeleteCancelBtn')?.addEventListener('click', () => window.closeDeleteModal());
    document.getElementById('globalDeleteAdConfirmBtn')?.addEventListener('click', (event) => window.confirmDelete(event));
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const { modal: currentModal } = getAdDeleteModalElements();
      if (currentModal && currentModal.style.display !== 'none') {
        window.closeDeleteModal();
      }
    });
    modal.dataset.deleteModalBound = '1';
  }
}

// ✅ Открытие модального окна подтверждения удаления
window.showDeleteModal = function(adId, adTitle) {
  window.selectedAdId = adId;
  resetAdDeleteConfirmButtonState();
  attachAdDeleteModalListeners();

  const { overlay, modal, title } = getAdDeleteModalElements();

  if (!overlay || !modal || !title) {
    const fallbackMessage = adTitle
      ? `Удалить объявление "${adTitle}"?`
      : 'Удалить это объявление?';

    if (window.confirm(fallbackMessage)) {
      window.confirmDelete();
    }
    return;
  }

  overlay.style.display = "block";
  modal.style.display = "block";
  modal.classList.remove('hidden');
  document.body.classList.add('no-scroll');
  title.innerText = adTitle;
};

// ✅ Закрытие модального окна
window.closeDeleteModal = function() {
  window.selectedAdId = null;
  resetAdDeleteConfirmButtonState();

  const { overlay, modal } = getAdDeleteModalElements();
  if (overlay) overlay.style.display = "none";
  if (modal) {
    modal.style.display = "none";
    modal.classList.add('hidden');
  }
  document.body.classList.remove('no-scroll');
};

// ✅ Перенос объявления в неактивные из той же модалки
window.confirmDeactivate = function(ev) {
  const id = window.selectedAdId;
  if (id == null || id === '') return;

  const button = ev?.currentTarget instanceof HTMLButtonElement
    ? ev.currentTarget
    : document.getElementById('deactivateAdConfirmBtn');

  if (button) {
    if (button.disabled) return;
    button.disabled = true;
  }

  const form = document.querySelector(`#ad-${id} .deactivate-form`);
  if (!(form instanceof HTMLFormElement)) {
    if (button) button.disabled = false;
    console.error('Не найдена форма переноса объявления в неактивные');
    return;
  }

  form.submit();
};

// ✅ Подтверждение удаления (глобальное имя для onclick в Blade; лучше onclick="confirmDelete(event)")
window.confirmDelete = function(ev) {
  const id = window.selectedAdId;
  if (id == null || id === '') return;

  const button = getAdDeleteConfirmButton(ev);
  if (button) {
    if (button.disabled) return;
    button.disabled = true;
  }

  // 🔍 Ищем форму и карточку объявления
  const form = document.querySelector(`#ad-${id} .delete-form`);
  const adCard = document.querySelector(`#ad-${id}`);

  // 🔗 Если формы нет, используем прямой REST-маршрут удаления
  const action = form?.getAttribute('action') || `/ads/${id}`;
  const csrf = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');

  if (!csrf) {
    if (button) button.disabled = false;
    console.error('Не найден CSRF token для удаления объявления');
    if (typeof showErrorToast === 'function') {
      showErrorToast('CSRF: обновите страницу и попробуйте снова.');
    }
    return;
  }

  // ✅ Отправка запроса с методом DELETE
  fetch(action, {
    method: 'DELETE',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-TOKEN': csrf,
      'Accept': 'application/json'
    }
  })
  .then(async (res) => {
    if (res.ok) {
      // ✅ Плавное удаление карточки
      if (adCard) {
        adCard.classList.add('fade-out');
        setTimeout(() => adCard.remove(), 400);
      }
      closeDeleteModal();
    } else {
      if (button) button.disabled = false;
      let data = null;
      try { data = await res.json(); } catch (_) {}
      console.error('Ошибка удаления', data || res.status);
      const msg = (data && (data.error || data.message)) || `Не удалось удалить (${res.status})`;
      if (typeof showErrorToast === 'function') {
        showErrorToast(msg);
      } else {
        alert(msg);
      }
    }
  })
  .catch(err => {
    if (button) button.disabled = false;
    console.error('Ошибка:', err);
    if (typeof showErrorToast === 'function') {
      showErrorToast('Ошибка соединения при удалении');
    }
  });
};


//----------------метод обновления объявления-------------------

(function () {
  const root = document.documentElement;

  // Локализованные строки берём из data-* атрибутов <html>
  const T = {
    refresh:      root.dataset.i18nRefresh      || 'Обновить',
    refreshed:    root.dataset.i18nRefreshed    || 'Обновлено',
    nextTitle:    root.dataset.i18nNextTitle    || 'Следующее обновление',
    availableAt:  root.dataset.i18nAvailableAt  || 'Доступно:',
    failed:       root.dataset.i18nFailed       || 'Не удалось обновить',
    network:      root.dataset.i18nNetwork      || 'Ошибка соединения',
  };

  // Форматируем дату по локали браузера
  function isoToLocal(iso) {
    try {
      const d   = new Date(iso);
      const loc = navigator.language || 'ru-RU';
      return d.toLocaleString(loc, {
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit'
      });
    } catch (_) { return ''; }
  }

  // Небольшая inline-подсказка
  function showInlineNote(anchorEl, text) {
    const note = document.createElement('div');
    note.className = 'inline-note';
    note.textContent = text;
    anchorEl.parentElement.appendChild(note);
    setTimeout(() => note.remove(), 2500);
  }

  // Навешиваем обработчики ТОЛЬКО на активные кнопки
  const refreshButtons = document.querySelectorAll('.update-btn.refresh-available[data-id]');
  if (!refreshButtons.length) return;

  refreshButtons.forEach((btn) => {
    let pending = false;

    btn.addEventListener('click', async function () {
      if (pending) return;                // защита от дабл-клика
      if (this.classList.contains('refresh-disabled')) return;

      const adId = this.dataset.id;
      if (!adId) return;

      pending = true;
      this.classList.add('is-loading');   // если есть CSS-стиль под спиннер, ок; иначе просто класс

      try {
        const res  = await fetch(`/ads/${adId}/refresh`, {
          method: 'POST',
          headers: {
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
            'Accept': 'application/json'
          }
        });

        let data = null;
        try { data = await res.json(); } catch (_) {}

        // Если сервер вернул ошибку или ещё рано обновлять
        if (!res.ok || !data || data.success !== true) {
          if (data && data.next_date) {
            showInlineNote(this, `${T.availableAt} ${isoToLocal(data.next_date)}`);
          } else {
            showInlineNote(this, (data && data.error) ? data.error : T.failed);
          }
          return;
        }

        // --- Успех ---

        // 1) Обновляем подпись "Обновлено: ..."
        const infoLine = document.querySelector(`.account-ad-updated[data-ad-id="${adId}"] .datetime`);
        if (infoLine && data.refreshed_at) {
          infoLine.textContent = isoToLocal(data.refreshed_at);
          const labelEl = document.querySelector(`.account-ad-updated[data-ad-id="${adId}"] .label`);
          if (labelEl) labelEl.textContent = T.refreshed;
        }

        // 2) Меняем кнопку на "Обновлено" (disabled + тултип с датой следующего обновления)
        const nextLocal = data.next_date ? isoToLocal(data.next_date) : '';
        const wrapper = document.createElement('div');
        wrapper.classList.add('tooltip-wrapper');
        wrapper.innerHTML = `
          <button class="update-btn-with-tooltip refresh-disabled" disabled>
            <i class="fas fa-clock icon-left"></i>
            <span class="refresh-text">${T.refreshed}</span>
          </button>
          <div class="custom-tooltip">
            <div class="tooltip-title">${T.nextTitle}</div>
            <div class="tooltip-date">${nextLocal}</div>
            <div class="tooltip-arrow"></div>
          </div>
        `;
        this.parentNode.replaceChild(wrapper, this);

        // 3) Поднимаем карточку вверх списка (визуальный эффект)
        const card = wrapper.closest('.account-ad-card');
        const firstCard = document.querySelector('.account-ad-card');
        if (card && firstCard && card !== firstCard) {
          firstCard.parentNode.insertBefore(card, firstCard);
          card.classList.add('just-refreshed');
          setTimeout(() => card.classList.remove('just-refreshed'), 1500);
        }

      } catch (e) {
        console.error('refresh error', e);
        showInlineNote(this, T.network);
      } finally {
        pending = false;
        this.classList.remove('is-loading');
      }
    });
  });
})();

//--------------------------------------------------------------

let descTimeout;

// 💾 Автосохранение описания
function autoSaveDescription(value) {
  clearTimeout(descTimeout);
  const status = document.getElementById("desc-status");

  descTimeout = setTimeout(() => {
    fetch('/account/update-description', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
        'Accept': 'application/json'
      },
      body: JSON.stringify({ description: value })
    })
    .then(res => res.json())
    .then(data => {
      if (data.success) {
        status.style.color = 'green';
        status.textContent = "✅ Сохранено";
      } else {
        status.style.color = 'red';
        status.textContent = "❌ Ошибка при сохранении";
      }
    })
    .catch(err => {
      console.error(err);
      status.style.color = 'red';
      status.textContent = "❌ Ошибка сети";
    });
  }, 1000);
}

// 🧮 Ограничение на 50 слов + счётчик + предупреждение
function limitWords(textarea) {
  const maxWords = 50;
  const counter = document.getElementById('word-counter');
  const limitMessage = document.getElementById('limit-warning');

  let text = textarea.value.trim();
  let words = text.length > 0 ? text.split(/\s+/) : [];

  if (words.length > maxWords) {
    words = words.slice(0, maxWords);
    textarea.value = words.join(' ');
    if (limitMessage) {
      limitMessage.textContent = '🚫 Вы достигли лимита текста';
      limitMessage.style.color = 'red';
    }
  } else {
    if (limitMessage) limitMessage.textContent = '';
  }

  if (counter) {
    counter.textContent = `${words.length}/50 слов`;
    counter.style.color = words.length >= maxWords ? 'red' : '#555';
  }
}

// ✅ Экспорт функций (если Vite ES-модули)
window.limitWords = limitWords;
window.autoSaveDescription = autoSaveDescription;

// ✅ При загрузке обновим счётчик (внутри уже существующего DOMContentLoaded)
const textarea = document.getElementById('description');
if (textarea) {
  textarea.dispatchEvent(new Event('input'));
}

//-----------------------------------------------------------------------------

// 🔁 Обработчик для статуса (Собственник, Агентство, Застройщик)
document.querySelectorAll('.status-options').forEach(group => {
  const checkboxes = group.querySelectorAll('input[type="checkbox"]');

  checkboxes.forEach(checkbox => {
    checkbox.addEventListener('change', function () {
      if (this.checked) {
        checkboxes.forEach(cb => {
          if (cb !== this) cb.checked = false;
        });
      }
    });
  });
});

// 🔹 Логика отображения поля "Код", если выбрано "Агентство"
// 👉 Показываем/скрываем поле "Код" при выборе "Агентство"
// 🔹 Логика отображения поля "Код", если выбрано "Агентство"
const radios = document.querySelectorAll('input[name="filters[354]"]');
const codeBlock = document.getElementById('code-block');
const hidden = document.getElementById('poster_status_hidden');

function toggleCodeBlock() {
  const selected = document.querySelector('input[name="filters[354]"]:checked');
  if (selected) {
    hidden.value = selected.value;

    // ✅ Сравниваем по value — оно равно 'status_agency'
    if (selected.value === 'status_agency') {
      codeBlock.style.display = 'block';
    } else {
      codeBlock.style.display = 'none';
    }
  }
}

if (radios.length && codeBlock && hidden) {
  radios.forEach(radio => radio.addEventListener('change', toggleCodeBlock));
  toggleCodeBlock(); // при загрузке
}

// 🔧 Вин-хелп
function toggleVinHelp() {
  const help = document.getElementById('vin-help');
  help.style.display = help.style.display === 'none' ? 'block' : 'none';
}
window.toggleVinHelp = toggleVinHelp;

//========================================================================================================

// listing.blade.php

// ✅ Автоотправка формы фильтра при изменении (только на десктопе)

// ✅ Автоотправка формы фильтров на десктопе
const filterForm = document.getElementById("filterForm");
if (filterForm && window.matchMedia('(min-width: 769px)').matches) {
  const inputs = filterForm.querySelectorAll(
    'select, input[type="checkbox"], input[type="radio"], input[type="number"], input[type="text"]'
  );
  inputs.forEach(input => {
    input.addEventListener("change", () => {
      filterForm.submit();
    });
  });
}

// 📱 Открытие/закрытие фильтров на мобилке
const toggleBtn = document.getElementById('toggleFilters');
const mobileFilters = document.getElementById('mobile-filters');
const closeMobileBtn = document.getElementById('close-mobile-filters');

toggleBtn?.addEventListener("click", (e) => {
  e.preventDefault();
  mobileFilters?.classList.remove('mobile-hidden');
  mobileFilters?.classList.add('mobile-filters-active');
});

closeMobileBtn?.addEventListener("click", (e) => {
  e.preventDefault();
  mobileFilters?.classList.remove('mobile-filters-active');
  mobileFilters?.classList.add('mobile-hidden');
});


// busnes 
// 🧾 Открытие модалки активации бизнеса
window.openBusinessModal = function () {
  const modal = document.getElementById('businessModal');
  const overlay = document.getElementById('businessModalOverlay');
  if (modal && overlay) {
      modal.classList.remove('hidden');
      modal.style.display = 'block';
      overlay.style.display = 'block';
  }
};

window.closeBusinessModal = function () {
  const modal = document.getElementById('businessModal');
  const overlay = document.getElementById('businessModalOverlay');
  if (modal && overlay) {
      modal.style.display = 'none';
      modal.classList.add('hidden');
      overlay.style.display = 'none';
  }
};

if (document.getElementById('businessModal')?.dataset.open === 'true') {
  window.openBusinessModal();
}
//----------------------------------------------------------------------

//Настройки бизнес-профиля
// ✅ Показываем панель настроек
window.showBusinessSettings = function () {
  const panel = document.getElementById('business-settings-panel');
  if (panel) {
    panel.style.display = 'block';
    panel.scrollIntoView({ behavior: 'smooth' });
  }
};

// ✅ Превью баннера при выборе файла
window.previewBusinessBanner = function (e) {
  const file = e.target.files[0];
  const preview = document.getElementById('banner-preview');
  if (file && preview) {
    const reader = new FileReader();
    reader.onload = function (ev) {
      preview.src = ev.target.result;
      preview.style.display = 'block';
    };
    reader.readAsDataURL(file);
  }
};

// ✅ Редактировать режим работы
window.editWorkingHours = function (e) {
  e.preventDefault();
  const text = document.getElementById('working-hours-text');
  const input = document.getElementById('working-hours-input');
  if (text && input) {
    text.style.display = 'none';
    input.style.display = 'block';
  }
};

// ✅ Редактировать рабочие дни
window.editWorkingDays = function (e) {
  e.preventDefault();
  const text = document.getElementById('working-days-text');
  const input = document.getElementById('working-days-input');
  if (text && input) {
    text.style.display = 'none';
    input.style.display = 'block';
  }
};
// busnes stranica prodvijenie------------------------------
/// ✅ Показ модалки
window.showBusinessPromoModal = function () {
  const overlay = document.getElementById("businessPromoOverlay");
  const modal = document.getElementById("businessPromoModal");

  if (!overlay || !modal) return;

  modal.classList.remove("hidden");
  overlay.style.display = "block";
  modal.style.display = "block";

  const btn = document.getElementById("promoteBusinessBtn");
  if (btn && !btn.dataset.bound) {
    btn.dataset.bound = "true";
    btn.addEventListener("click", async () => {
      try {
        const response = await fetch("/account/promote-business", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]').content,
          },
          body: JSON.stringify({}),
        });

        const result = await response.json();

        if (result.success) {
          closeBusinessPromoModal(); // ❗ скрываем окно
          showPromoSuccessToast("Бизнес-страница продвигается на 7 дней!");
        } else {
          showPromoErrorToast(result.message || "Недостаточно средств");
        }
      } catch (error) {
        showPromoErrorToast("Ошибка при запросе");
        console.error(error);
      }
    });
  }
};

window.closeBusinessPromoModal = function () {
  const overlay = document.getElementById("businessPromoOverlay");
  const modal = document.getElementById("businessPromoModal");

  if (!overlay || !modal) return;

  overlay.style.display = "none";
  modal.style.display = "none";
  modal.classList.add("hidden");
};

function showPromoSuccessToast(message) {
  const toast = document.getElementById("promoSuccessToast") || document.getElementById("businessSuccessToast");
  const msg = document.getElementById("promoSuccessMessage");
  if (msg) msg.textContent = message;

  toast.style.display = "flex";
  setTimeout(() => {
    toast.style.display = "none";
    location.reload();
  }, 2000);
}

function showPromoErrorToast(message) {
  const toast = document.getElementById("promoErrorToast");
  const msg = document.getElementById("promoErrorMessage");
  const buttons = document.getElementById("promoErrorButtons");

  msg.textContent = message;
  toast.style.display = "flex";
  buttons.style.display = "flex";

  setTimeout(() => {
    toast.style.display = "none";
    buttons.style.display = "none";
  }, 4000);
}

function hideErrorToast() {
  const toast = document.getElementById("promoErrorToast");
  const buttons = document.getElementById("promoErrorButtons");
  toast.style.display = "none";
  buttons.style.display = "none";
}



// другие скрипты...

// ✅ Очистка поиска на бизнес-странице
const clearBtn = document.getElementById('clearSearch');
const input = document.getElementById('searchQuery');
const form = document.getElementById('businessSearchForm');

if (clearBtn && input && form) {
  clearBtn.addEventListener('click', () => {
    input.value = '';
    form.submit(); // перезагрузка формы без поиска
  });
}



//======================================

//  admin_panel 
// Пример добавления события для кнопки открытия модального окна
const openModalButtons = document.querySelectorAll('[data-modal="open"]');
openModalButtons.forEach(button => {
    button.addEventListener('click', function() {
        const modalId = this.getAttribute('data-target'); // Получаем ID модального окна
        openModal(modalId);
    });
});

// Пример открытия модального окна
function openModal(modalId) {
    const modal = document.getElementById(modalId);
    if (modal) {
        modal.style.display = 'block'; // Показываем модальное окно
    }
}

// Пример закрытия модального окна
const closeModalButtons = document.querySelectorAll('.close-modal');
closeModalButtons.forEach(button => {
    button.addEventListener('click', function() {
        const modal = this.closest('.modal');
        modal.style.display = 'none'; // Скрываем модальное окно
    });
});


//✅ about.blade.php 
// === ABOUT IGMA: лёгкая анимация появления блоков ===
const observer = new IntersectionObserver((entries) => {
  entries.forEach(e => {
    if (e.isIntersecting) {
      e.target.classList.add('in');
      observer.unobserve(e.target);
    }
  });
}, { threshold: 0.12 });

document.querySelectorAll('.about-feature, .about-section, .about-stat').forEach(el => {
  el.style.opacity = '0';
  el.style.transform = 'translateY(16px)';
  el.style.transition = 'opacity .5s ease, transform .5s ease';
  observer.observe(el);
});

const injectStyle = document.createElement('style');
injectStyle.innerHTML = `
  .about-feature.in, .about-section.in, .about-stat.in {
    opacity:1 !important; transform:translateY(0) !important;
  }
`;
document.head.appendChild(injectStyle);

// Reviews: public form, guest sign-in prompt and account panels.
const reviewForm = document.querySelector('[data-review-form]');
const reviewFormToggle = document.querySelector('[data-review-form-toggle]');
const reviewFormClose = document.querySelector('[data-review-form-close]');

if (reviewForm && reviewFormToggle) {
  reviewFormToggle.addEventListener('click', () => {
    reviewForm.classList.add('is-open');
    reviewForm.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
}

if (reviewForm && reviewFormClose) {
  reviewFormClose.addEventListener('click', () => {
    reviewForm.classList.remove('is-open');
  });
}

const reviewAuthModal = document.querySelector('[data-review-auth-modal]');
const reviewAuthOpen = document.querySelector('[data-review-auth-open]');
const reviewAuthCloseButtons = document.querySelectorAll('[data-review-auth-close]');

function setReviewAuthModal(open) {
  if (!reviewAuthModal) return;
  reviewAuthModal.hidden = !open;
  document.body.style.overflow = open ? 'hidden' : '';
}

if (reviewAuthOpen) {
  reviewAuthOpen.addEventListener('click', () => setReviewAuthModal(true));
}

reviewAuthCloseButtons.forEach(button => {
  button.addEventListener('click', () => setReviewAuthModal(false));
});

document.addEventListener('keydown', event => {
  if (event.key === 'Escape' && reviewAuthModal && !reviewAuthModal.hidden) {
    setReviewAuthModal(false);
  }
});

const accountReviewTabs = document.querySelectorAll('[data-account-review-tab]');
const accountReviewPanels = document.querySelectorAll('[data-account-review-panel]');

// Seller report: compact complaint form for signed-in users and auth prompt for guests.
const sellerReportModal = document.querySelector('[data-seller-report-modal]');
const sellerReportAuthModal = document.querySelector('[data-seller-report-auth-modal]');
const sellerReportOpen = document.querySelector('[data-seller-report-open]');
const sellerReportAuthOpen = document.querySelector('[data-seller-report-auth-open]');

function setSellerReportModal(modal, open) {
  if (!modal) return;

  modal.hidden = !open;
  document.body.style.overflow = open ? 'hidden' : '';
}

sellerReportOpen?.addEventListener('click', () => {
  setSellerReportModal(sellerReportModal, true);
});

sellerReportAuthOpen?.addEventListener('click', () => {
  setSellerReportModal(sellerReportAuthModal, true);
});

document.querySelectorAll('[data-seller-report-close]').forEach(button => {
  button.addEventListener('click', () => {
    setSellerReportModal(sellerReportModal, false);
  });
});

document.querySelectorAll('[data-seller-report-auth-close]').forEach(button => {
  button.addEventListener('click', () => {
    setSellerReportModal(sellerReportAuthModal, false);
  });
});

if (sellerReportModal?.dataset.openOnLoad === 'true') {
  setSellerReportModal(sellerReportModal, true);
}

document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;

  if (sellerReportModal && !sellerReportModal.hidden) {
    setSellerReportModal(sellerReportModal, false);
  }

  if (sellerReportAuthModal && !sellerReportAuthModal.hidden) {
    setSellerReportModal(sellerReportAuthModal, false);
  }
});

accountReviewTabs.forEach(tab => {
  tab.addEventListener('click', () => {
    const target = tab.dataset.accountReviewTab;

    accountReviewTabs.forEach(item => {
      const active = item === tab;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-selected', String(active));
    });

    accountReviewPanels.forEach(panel => {
      const active = panel.dataset.accountReviewPanel === target;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });
  });
});

const accountNavScroller = document.querySelector('.account-nav-tabs');
const accountNavPrev = document.querySelector('[data-account-nav-scroll="prev"]');
const accountNavNext = document.querySelector('[data-account-nav-scroll="next"]');

function updateAccountNavControls() {
  if (!accountNavScroller || !accountNavPrev || !accountNavNext) return;

  const maxScroll = Math.max(0, accountNavScroller.scrollWidth - accountNavScroller.clientWidth);
  const hasOverflow = maxScroll > 4;

  accountNavPrev.hidden = !hasOverflow || accountNavScroller.scrollLeft <= 4;
  accountNavNext.hidden = !hasOverflow || accountNavScroller.scrollLeft >= maxScroll - 4;
}

if (accountNavScroller && accountNavPrev && accountNavNext) {
  const scrollAccountNav = direction => {
    accountNavScroller.scrollTo({
      left: direction === 'next'
        ? accountNavScroller.scrollWidth - accountNavScroller.clientWidth
        : 0,
      behavior: 'smooth',
    });
  };

  accountNavPrev.addEventListener('click', () => scrollAccountNav('prev'));
  accountNavNext.addEventListener('click', () => scrollAccountNav('next'));
  accountNavScroller.addEventListener('scroll', updateAccountNavControls, { passive: true });
  window.addEventListener('resize', updateAccountNavControls);

  requestAnimationFrame(() => {
    const activeItem = accountNavScroller.querySelector('.account-nav-item.active');
    if (activeItem) {
      const items = Array.from(accountNavScroller.querySelectorAll('.account-nav-item'));
      const activeIndex = items.indexOf(activeItem);

      if (activeIndex === 0) {
        accountNavScroller.scrollLeft = 0;
      } else if (activeIndex === items.length - 1) {
        accountNavScroller.scrollLeft = accountNavScroller.scrollWidth - accountNavScroller.clientWidth;
      } else {
        const desiredLeft = activeItem.offsetLeft
          - ((accountNavScroller.clientWidth - activeItem.offsetWidth) / 2);
        accountNavScroller.scrollLeft = Math.max(0, desiredLeft);
      }
    }

    updateAccountNavControls();
  });
}





}); // ← конец твоего большого DOMContentLoaded из первой части

/* One-time app download promotion. The flag is per browser/device. */
(function initAppPromotion() {
  const storageKey = 'igma-app-promotion-dismissed-v1';

  if (window.location.pathname.startsWith('/admin')) return;

  try {
    if (window.localStorage.getItem(storageKey)) return;
  } catch (_) {
    return;
  }

  const labels = {
    hy: { apple: 'Ներբեռնել App Store-ից', google: 'Ներբեռնել Google Play-ից', continue: 'Շարունակել բրաուզերում', close: 'Փակել' },
    en: { apple: 'Download on the App Store', google: 'Get it on Google Play', continue: 'Continue in browser', close: 'Close' },
    ru: { apple: 'Скачать в App Store', google: 'Скачать в Google Play', continue: 'Продолжить в браузере', close: 'Закрыть' },
  };
  const text = labels[document.documentElement.lang] || labels.ru;

  const modal = document.createElement('section');
  modal.className = 'app-promo-modal';
  modal.setAttribute('role', 'dialog');
  modal.setAttribute('aria-modal', 'true');
  modal.setAttribute('aria-label', 'Igma.am app');
  modal.innerHTML = `
    <div class="app-promo-card">
      <button class="app-promo-close" type="button" aria-label="${text.close}">&times;</button>
      <div class="app-promo-visual">
        <img class="app-promo-image" src="${appPromoImage}" alt="Igma.am app">
        <div class="app-promo-image-fallback" aria-hidden="true">
          <img src="/img/logo.png" alt="">
          <strong>Igma.am</strong>
        </div>
      </div>
      <div class="app-promo-actions">
        <a class="app-promo-store" href="https://apps.apple.com/us/app/igma/id6790162251" target="_blank" rel="noopener noreferrer">${text.apple}</a>
        <a class="app-promo-store" href="https://play.google.com/store/apps/details?id=am.igma.app" target="_blank" rel="noopener noreferrer">${text.google}</a>
        <button class="app-promo-continue" type="button">${text.continue}</button>
      </div>
    </div>`;

  const dismiss = () => {
    try { window.localStorage.setItem(storageKey, '1'); } catch (_) { /* no storage available */ }
    document.body.classList.remove('app-promo-open');
    modal.classList.remove('is-visible');
    window.setTimeout(() => modal.remove(), 230);
  };

  modal.querySelector('.app-promo-close').addEventListener('click', dismiss);
  modal.querySelector('.app-promo-continue').addEventListener('click', dismiss);
  modal.querySelectorAll('.app-promo-store').forEach(link => link.addEventListener('click', dismiss));
  modal.querySelector('.app-promo-image').addEventListener('error', () => {
    modal.classList.add('app-promo-image-unavailable');
  }, { once: true });
  modal.addEventListener('click', event => {
    if (event.target === modal) dismiss();
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && document.body.contains(modal)) dismiss();
  }, { once: true });

  document.body.classList.add('app-promo-open');
  document.body.append(modal);
  requestAnimationFrame(() => modal.classList.add('is-visible'));
})();
